<template>
  <div class="pannello-funzionalita-page">
    <div class="card">
      <h2>Stanza dei bottoni</h2>
      <Accordion ref="functionalityAccordion" @tab-open="openTab($event)">
        <AccordionTab header="Riporta Contratto In Validazione">
          <div class="controls-row">
            <div class="field-group">
              <label for="idMatriceInput">ID Matrice</label>
              <input
                id="idMatriceInput"
                v-model="idMatrice"
                type="text"
                class="p-inputtext p-component"
                placeholder="Esempio: 111 oppure 111,112,113"
                @keyup.enter="runRiportaContrattoInValidazione"
              />
            </div>

            <button
              class="p-button p-component"
              :disabled="loading"
              @click="runRiportaContrattoInValidazione"
            >
              <span class="p-button-label">{{ loading ? 'Esecuzione...' : 'Esegui' }}</span>
            </button>
          </div>

          <div v-if="hasCheckItems" class="results-grid">
            <div class="response-box response-box--success">
              <h4>Matrici che passano ({{ processableItems.length }})</h4>
              <ul v-if="processableItems.length > 0" class="feedback-list">
                <li v-for="item in processableItems" :key="`ok-${item.id_matrice}`">
                  <template v-if="item.executed === true">
                    ID {{ item.id_matrice }}: Confermata.
                    <span class="changed-inline">
                      (matrice_index: {{ item?.changed?.update_matrice_index ?? 0 }},
                      matrice_ee: {{ item?.changed?.update_matrice_ee ?? 0 }},
                      matrice_gas: {{ item?.changed?.update_matrice_gas ?? 0 }},
                      storico eliminato: {{ item?.changed?.delete_matrice_index_storico ?? 0 }})
                    </span>
                  </template>
                  <template v-else>
                    ID {{ item.id_matrice }}: OK, pronta per conferma
                  </template>
                </li>
              </ul>
              <p v-else class="feedback-message">Nessuna matrice ha superato il controllo.</p>

              <button
                v-if="showConfirmButton"
                class="p-button p-component p-button-success confirm-btn"
                :disabled="loadingConfirm"
                @click="confirmValidationMatrice"
              >
                <span class="p-button-label">{{ loadingConfirm ? 'Conferma in corso...' : 'Conferma' }}</span>
              </button>
            </div>

            <div class="response-box response-box--error">
              <h4>Matrici che non passano ({{ nonProcessableItems.length }})</h4>
              <ul v-if="nonProcessableItems.length > 0" class="feedback-list">
                <li v-for="item in nonProcessableItems" :key="`ko-${item.id_matrice}`">
                  ID {{ item.id_matrice }}: {{ item.reason || 'Non processabile' }}
                </li>
              </ul>
              <p v-else class="feedback-message">Tutte le matrici hanno superato il controllo.</p>
            </div>
          </div>

          <div v-else-if="userFeedback" class="response-box" :class="`response-box--${userFeedback.severity}`">
            <h4>{{ userFeedback.title }}</h4>
            <p class="feedback-message">{{ userFeedback.message }}</p>
            <ul v-if="userFeedback.details.length > 0" class="feedback-list">
              <li v-for="detail in userFeedback.details" :key="detail">{{ detail }}</li>
            </ul>
          </div>
        </AccordionTab>
        <AccordionTab header="Attiva ricerca contratto da validare" >
          <Loader v-if="loader" />
          <div v-else>
            <Button :disabled="canSearchNextValidation" icon="pi pi-send" label="Abilita ricerca" @click="setActiveCanSearchNextValidation()"/>
          </div>
        </AccordionTab>
        <AccordionTab header="Lista Processi">
          <div v-if="!hasProcesslistPassword" class="response-box response-box--warn processlist-guard-box">
            <Button
              class="processlist-create-psw-btn"
              icon="pi pi-lock"
              label="Crea Password"
              @click="openCreateProcesslistPasswordModal()"
            />
          </div>

          <template v-else>
          <Loader v-if="loadingProcesslist" />
          <div v-else>
            <Button icon="pi pi-play" label="Avvia" @click="loadFullProcesslist()" />
            <Button
              class="p-button-danger processlist-kill-selected"
              icon="pi pi-times"
              label="Kill selezionati"
              :disabled="!canKillSelected || killingSelected || confirmingKillWithPassword"
              @click="requestKillSelectedProcesses()"
            />
          </div>

          <div v-if="processlistItems.length > 0" class="processlist-table-wrap">
            <table class="processlist-table">
              <thead>
                <tr>
                  <th class="checkbox-col">
                    <input
                      type="checkbox"
                      :checked="allProcessesSelected"
                      @change="toggleSelectAllProcesses($event)"
                    />
                  </th>
                  <th>Id</th>
                  <th>User</th>
                  <th>Time</th>
                  <th>Info</th>
                  <th>Azione</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, index) in processlistItems" :key="`${item.Id ?? 'row'}-${index}`">
                  <td class="checkbox-col">
                    <input
                      type="checkbox"
                      :value="item.Id"
                      v-model="selectedProcessIds"
                      :disabled="!item.Id || isProcessBeingKilled(item.Id)"
                    />
                  </td>
                  <td>{{ item.Id ?? '-' }}</td>
                  <td>{{ item.User ?? '-' }}</td>
                  <td>{{ item.Time ?? '-' }}</td>
                  <td>{{ item.Info || '-' }}</td>
                  <td>
                    <Button
                      class="p-button-sm p-button-danger"
                      icon="pi pi-times"
                      label="Kill"
                      :disabled="!item.Id || isProcessBeingKilled(item.Id) || killingSelected || confirmingKillWithPassword"
                      @click="requestKillSingleProcess(item.Id)"
                    />
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          </template>
        </AccordionTab>
        <AccordionTab header="Check numeri fattura Agyo">
          <div class="controls-row">
            <div class="field-group">
              <label for="startDateAgyoInput">Dal</label>
              <input
                id="startDateAgyoInput"
                v-model="agyoStartDate"
                type="date"
                class="p-inputtext p-component"
              />
            </div>

            <div class="field-group">
              <label for="endDateAgyoInput">Al</label>
              <input
                id="endDateAgyoInput"
                v-model="agyoEndDate"
                type="date"
                class="p-inputtext p-component"
              />
            </div>

            <Button
              icon="pi pi-download"
              label="Scarica file"
              :loading="loadingExportNumeriFatturaAgyo"
              :disabled="loadingExportNumeriFatturaAgyo"
              @click="exportNumeriFatturaAgyo"
            />
          </div>
        </AccordionTab>
        <AccordionTab header="Aggiungi remi">
          <div class="w-full flex flex-wrap">
            <div class="col-12">
              <div class="flex align-items-center">
                <label class="mr-2 white-space-nowrap">Seleziona Comune</label>
                <Dropdown v-model="selectedComune" :options="comuniRemi" filter optionLabel="nome" class="w-full"></Dropdown>
              </div>
            </div>
            <div class="col-12" v-if="selectedComune">
              <div class="flex">
                <div class="col-6">
                  <label class="mr-2">Remi da aggiungere (separati da virgola)</label>
                  <div class="w-full" v-if="selectedComune.codici_remi.length > 0">
                    <Chip v-for="(remi, i) in selectedComune.codici_remi" :key="i" :label="remi" class="m-1"></Chip>
                  </div>
                </div>
                <div class="col-6">
                  <label class="mr-2">Remi da aggiungere (separati da virgola)</label>
                  <InputText v-model="selectedComune.remiToAdd" placeholder="Esempio: 30000123,SMG00400306D" class="w-full mb-2"></InputText>
                  <Button label="Aggiungi remi" @click="addRemiToComune()" class="p-button-success" v-if="selectedComune.remiToAdd"></Button>
                </div>
              </div>
            </div>
          </div>
        </AccordionTab>
        <AccordionTab header="Aggiungi Codice Destinatario - Sdi">
          <Loader v-if="loadingAddSdi" />
          <div class="w-full flex flex-wrap">
            <div class="col-12">
              <div class="flex align-items-center">
                <label class="mr-2 white-space-nowrap">Codice destinatario SDI</label>
              <InputText
                v-model="newSdiCode"
                placeholder="Esempio: ABC1234"
                maxlength="7"
                  class="w-18rem mr-2"
                @keyup.enter="addCodiceDestinatarioSdi()"
              />
                <Button
                  label="Aggiungi codice SDI"
                  icon="pi pi-plus"
                  class="p-button-success"
                  :loading="loadingAddSdi"
                  :disabled="loadingAddSdi || !newSdiCode"
                  @click="addCodiceDestinatarioSdi()"
                />
              </div>
              <small class="block mb-3">Sono ammessi solo numeri e lettere, da 6 a 7 caratteri.</small>
            </div>
          </div>
        </AccordionTab>
        <AccordionTab header="Resetta caricamento">
          <Loader v-if="loader" />

          <label class="mr-2">Id caricamento da resettare (ricerca singolo caricamento)</label>
          <InputText v-model="idMatriceToReset" :disabled="loader" class="w-full mb-2" @input="resetStoricoCaricamento()"></InputText>
          <Button label="Ricerca caricamento" :disabled="loader" @click="getStoricoCaricamento()" class="p-button-success" v-if="idMatriceToReset"/>

          <Button v-if="canDetachSignature" label="Sgancia richiesta di firma" icon="pi pi-unlink" class="p-button-warning mt-2" :disabled="loader" @click="detachContractSignature" />
          <div v-if="storicoCaricamento" class="mt-3">
            <DataTable :value="storicoCaricamento" showGridlines scrollable>
              <Column>
                <template #body="{data}">
                  <div class="flex justify-content">
                    <Button v-if="data.available_to_reset" class="p-button-text p-button-info" icon="pi pi-replay" label="Resetta stato" @click="resetCaricamento(data.cod_stato_aggiornamento)"
                    />
                  </div>
                </template>
              </Column>
              <Column v-for="col of columnStoricoCaricamento" :key="col" :field="col" :header="col" style="min-width: 80px"></Column>
            </DataTable>
          </div>
        </AccordionTab>
        <AccordionTab header="Allinea data inizio PP/contratto">
          <Loader v-if="loader" />
          <label class="mr-2">Id caricamento da allineare (separati da virgola)</label>
          <InputText placeholder="Esempio: 80000,100000,100020" v-model="idsMatriceDaAllineare" class="w-full mb-2"></InputText>
          <Button label="Allinea data inizio" @click="allineaDataInizio()" class="p-button-success" v-if="idsMatriceDaAllineare"/>
        </AccordionTab>
        <AccordionTab header="Allinea PP con contratto">
          <Loader v-if="loader" />
          <div v-else-if="pp_without_ctr.exist" class="mt-3">
            <div v-for="(pp_without_ctr_type, header) of pp_without_ctr.data" :key="header">
              <DataTable :value="pp_without_ctr_type.data" showGridlines scrollable>
                <template #header>{{ header }}</template>
                <Column v-for="col of pp_without_ctr_type.columns" :key="col" :field="col" :header="col" style="min-width: 80px"></Column>
              </DataTable>
            </div>
            <Button label="Allinea fornitura con contratto" @click="allineaPPtoCTR()" class="p-button-success mt-3"/>
          </div>
          <div v-else class="flex align-items-center">
            <Button class="p-button-text p-button-rounded" style="font-size: large;" icon="pi pi-refresh" v-tooltip="'Aggiorna'" @click="getPPwithoutCTR()"/>
            <div class="response-box response-box--warn m-0">
              <p class="feedback-message">Non ci sono punti di prelievo senza contratto da allineare</p>
            </div>
          </div>
        </AccordionTab>
        <AccordionTab header="Validazioni prenotate">
          <Loader v-if="loader" />
          <Button class="p-button-text p-button-rounded" style="font-size: large;" icon="pi pi-refresh" v-tooltip="'Aggiorna'" @click="getValidazioniPrenotate()"/>
          <DataTable :value="validazioni_prenotate.data" showGridlines scrollable>
            <template #empty>
              <div class="response-box response-box--warn m-0">
                <p class="feedback-message">Non ci sono validazioni prenotate</p>
              </div>
            </template>
            <Column>
              <template #body="{data}">
                <Button icon="pi pi-trash" class="p-button-danger p-button-text" v-tooltip="'Elimina prenotazione'" @click="deleteValidazionePrenotata(data.id)"/>
              </template>
            </Column>
            <Column v-for="col of validazioni_prenotate.columns" :key="col.field" :field="col.field" :header="col.label" style="min-width: 80px"></Column>
          </DataTable>
        </AccordionTab>
        <AccordionTab header="Aggiungi Categoria ticket">
          <Loader v-if="loadingCategoryTicket" />

          <div v-else class="category-ticket-section"> 
            <div class="controls-row category-ticket-form">
              <Button
                icon="pi pi-plus"
                label="Aggiungi categoria"
                class="p-button-success"
                :disabled="addingCategoryTicket || deletingCategoryTicket"
                @click="openAddCategoryTicketModal"
              />
              <Button
                icon="pi pi-trash"
                label="Elimina selezionate"
                class="p-button-danger"
                :loading="deletingCategoryTicket"
                :disabled="deletingCategoryTicket || selectedCategoryTicketItems.length === 0"
                @click="deleteSelectedCategoryTickets"
              />
            </div>

            <DataTable
              v-model:selection="selectedCategoryTicketItems"
              :value="categoryTicketItems"
              dataKey="id"
              showGridlines
              scrollable
              scrollHeight="420px"
              class="category-ticket-table"
            >
              <template #empty>
                <div class="response-box response-box--warn m-0">
                  <p class="feedback-message">Nessuna categoria ticket presente</p>
                </div>
              </template>
              <Column selectionMode="multiple" headerStyle="width: 3em" />
              <Column field="id" header="ID" style="min-width: 80px" />
              <Column field="motivation" header="Motivazione" style="min-width: 220px" />
              <Column header="Visibile ad agente" style="min-width: 140px">
                <template #body="{ data }">
                  {{ Number(data.can_view_agente) === 1 ? 'Sì' : 'No' }}
                </template>
              </Column>
            </DataTable>
          </div>
        </AccordionTab>
        <AccordionTab header="Gestisci News Esterne Per App">
          <div class="external-news-form-grid">
            <div class="field-group">
              <label for="externalNewsTitle">Titolo</label>
              <InputText
                id="externalNewsTitle"
                v-model="externalNewsForm.title"
                class="w-full"
                placeholder="Titolo news"
                :disabled="savingExternalNews"
              />
            </div>
            <div class="field-group">
              <label for="externalNewsImage">URL immagine</label>
              <InputText
                id="externalNewsImage"
                v-model="externalNewsForm.image"
                class="w-full"
                placeholder="https://..."
                :disabled="savingExternalNews"
              />
            </div>
            <div class="field-group">
              <label for="externalNewsLink">Link esterno</label>
              <InputText
                id="externalNewsLink"
                v-model="externalNewsForm.external_link"
                class="w-full"
                placeholder="https://..."
                :disabled="savingExternalNews"
              />
            </div>
            <div class="field-group external-news-visible-field">
              <label for="externalNewsVisible">Visibile</label>
              <div class="flex align-items-center gap-2">
                <Checkbox
                  id="externalNewsVisible"
                  v-model="externalNewsForm.visible"
                  :binary="true"
                  :disabled="savingExternalNews"
                />
                <span>{{ externalNewsForm.visible ? 'Sì' : 'No' }}</span>
              </div>
            </div>
            <div class="field-group external-news-description-field">
              <label for="externalNewsDescription">Descrizione</label>
              <Textarea
                id="externalNewsDescription"
                v-model="externalNewsForm.description"
                rows="5"
                class="w-full"
                :autoResize="true"
                :disabled="savingExternalNews"
              />
            </div>
          </div>

          <div class="external-news-actions">
            <Button
              :label="externalNewsEditingId ? 'Salva modifica' : 'Aggiungi news'"
              :icon="externalNewsEditingId ? 'pi pi-save' : 'pi pi-plus'"
              class="p-button-success"
              :loading="savingExternalNews"
              @click="saveExternalNews"
            />
            <Button
              label="Reset"
              icon="pi pi-eraser"
              class="p-button-secondary p-button-outlined"
              :disabled="savingExternalNews"
              @click="resetExternalNewsForm"
            />
            <Button
              label="Aggiorna lista"
              icon="pi pi-refresh"
              class="p-button-outlined"
              :loading="loadingExternalNews"
              :disabled="savingExternalNews"
              @click="loadExternalNews(true)"
            />
          </div>

          <Loader v-if="loadingExternalNews" />
          <div v-else-if="externalNewsItems.length === 0" class="response-box response-box--warn m-0">
            <p class="feedback-message">Nessuna news presente</p>
          </div>
          <DataTable
            v-else
            :value="externalNewsItems"
            dataKey="id"
            showGridlines
            scrollable
            class="external-news-table"
          >
            <Column field="id" header="ID" style="min-width: 70px" />
            <Column field="title" header="Titolo" style="min-width: 240px" />
            <Column field="external_link" header="Link" style="min-width: 220px" />
            <Column header="Visibile" style="min-width: 100px">
              <template #body="{ data }">
                <Tag :value="Number(data.visible) === 1 ? 'Sì' : 'No'" :severity="Number(data.visible) === 1 ? 'success' : 'danger'" />
              </template>
            </Column>
            <Column header="Azioni" style="min-width: 300px">
              <template #body="{ data }">
                <div class="external-news-row-actions">
                  <Button
                    label="Modifica"
                    icon="pi pi-pencil"
                    class="p-button-sm"
                    :disabled="savingExternalNews"
                    @click="editExternalNews(data)"
                  />
                  <Button
                    :label="Number(data.visible) === 1 ? 'Nascondi' : 'Rendi visibile'"
                    :icon="Number(data.visible) === 1 ? 'pi pi-eye-slash' : 'pi pi-eye'"
                    class="p-button-sm p-button-warning"
                    :loading="isTogglingExternalNews(data.id)"
                    :disabled="savingExternalNews || isDeletingExternalNews(data.id)"
                    @click="toggleExternalNewsVisibility(data)"
                  />
                  <Button
                    label="Elimina"
                    icon="pi pi-trash"
                    class="p-button-sm p-button-danger"
                    :loading="isDeletingExternalNews(data.id)"
                    :disabled="savingExternalNews || isTogglingExternalNews(data.id)"
                    @click="deleteExternalNews(data)"
                  />
                </div>
              </template>
            </Column>
          </DataTable>
        </AccordionTab>
        <AccordionTab header="Cliente ID mancante">
          <div class="flex justify-content-between align-items-center flex-wrap mb-3 gap-2">
            <span class="font-semibold">
              Totale righe: {{ matriciIndexClienteIdMancante.total }} | Selezionate: {{ matriciIndexClienteIdMancantePayload.length }}
            </span>
            <div class="missing-client-actions">
              <Button
                label="Aggiorna selezionate"
                icon="pi pi-save"
                class="p-button-rounded p-button-success p-button-sm"
                :loading="updatingMatriciIndexClienteId"
                :disabled="updatingMatriciIndexClienteId || matriciIndexClienteIdMancantePayload.length === 0"
                @click="updateMatriciIndexClienteId"
              />
              <Button
                label="Aggiorna"
                icon="pi pi-refresh"
                class="p-button-rounded p-button-outlined p-button-sm"
                :loading="loadingMatriciIndexClienteIdMancante"
                :disabled="updatingMatriciIndexClienteId"
                @click="loadMatriciIndexClienteIdMancante(true)"
              />
            </div>
          </div>

          <Loader v-if="loadingMatriciIndexClienteIdMancante" />
          <div v-else-if="matriciIndexClienteIdMancante.items.length === 0" class="response-box response-box--warn m-0">
            <p class="feedback-message">Nessuna riga con cliente_id mancante trovata</p>
          </div>
          <Accordion v-else :multiple="true" class="missing-client-accordion">
            <AccordionTab
              v-for="group in matriciIndexClienteIdMancante.items"
              :key="group.period"
              :header="`${group.period} (${group.count})`"
            >
              <DataTable
                :value="group.rows"
                dataKey="id"
                showGridlines
                scrollable
                :rowClass="getMissingClientRowClass"
                class="missing-client-table"
              >
                <template #empty>
                  <div class="response-box response-box--warn m-0">
                    <p class="feedback-message">Nessuna riga presente nel gruppo</p>
                  </div>
                </template>
                <Column headerStyle="width: 3em" bodyStyle="text-align: center">
                  <template #header>
                    <Checkbox
                      :modelValue="isMissingClientGroupFullySelected(group)"
                      :binary="true"
                      :disabled="getSelectableMissingClientRows(group).length === 0"
                      @update:modelValue="toggleMissingClientGroupSelection(group, $event)"
                    />
                  </template>
                  <template #body="{ data }">
                    <Checkbox
                      :modelValue="isMissingClientRowSelected(group.period, data)"
                      :binary="true"
                      :disabled="!canSelectMissingClientRow(data)"
                      @update:modelValue="toggleMissingClientRowSelection(group.period, data, $event)"
                    />
                  </template>
                </Column>
                <Column field="id" header="matrice_index.id" style="min-width: 120px" />
                <Column header="data_caricamento" style="min-width: 170px">
                  <template #body="{ data }">
                    {{ formatDateTime(data.data_caricamento) }}
                  </template>
                </Column>
                <Column header="cliente_id da salvare" style="min-width: 170px">
                  <template #body="{ data }">
                    {{ getClienteIdsForMissingClientRow(data) || '-' }}
                  </template>
                </Column>
                <Column header="matrice_ee" style="min-width: 360px">
                  <template #body="{ data }">
                    <div v-if="data.ee.length > 0" class="missing-client-supplies">
                      <div v-for="(supply, index) in data.ee" :key="`ee-${data.id}-${index}`" class="missing-client-supply">
                        <span><strong>POD:</strong> {{ supply.pod || '-' }}</span>
                        <span><strong>cliente_id:</strong> {{ supply.cliente_id || '-' }}</span>
                        <span v-if="supply.id_recuperato"><strong>id_recuperato:</strong> {{ supply.id_recuperato }}</span>
                        <span>{{ supply.denominazione_cliente || '-' }}</span>
                        <Button
                          v-if="canUpdateRecoveredSupplyClienteId(supply)"
                          label="Aggiorna cliente"
                          icon="pi pi-save"
                          class="p-button-rounded p-button-success p-button-sm missing-client-supply-action"
                          :loading="isUpdatingRecoveredSupplyClienteId('ee', supply)"
                          :disabled="isUpdatingRecoveredSupplyClienteId('ee', supply)"
                          @click="updateRecoveredSupplyClienteId('ee', supply)"
                        />
                      </div>
                    </div>
                    <span v-else>-</span>
                  </template>
                </Column>
                <Column header="matrice_gas" style="min-width: 360px">
                  <template #body="{ data }">
                    <div v-if="data.gas.length > 0" class="missing-client-supplies">
                      <div v-for="(supply, index) in data.gas" :key="`gas-${data.id}-${index}`" class="missing-client-supply">
                        <span><strong>PDR:</strong> {{ supply.pdr || '-' }}</span>
                        <span><strong>cliente_id:</strong> {{ supply.cliente_id || '-' }}</span>
                        <span v-if="supply.id_recuperato"><strong>id_recuperato:</strong> {{ supply.id_recuperato }}</span>
                        <span>{{ supply.denominazione_cliente || '-' }}</span>
                        <Button
                          v-if="canUpdateRecoveredSupplyClienteId(supply)"
                          label="Aggiorna cliente"
                          icon="pi pi-save"
                          class="p-button-rounded p-button-success p-button-sm missing-client-supply-action"
                          :loading="isUpdatingRecoveredSupplyClienteId('gas', supply)"
                          :disabled="isUpdatingRecoveredSupplyClienteId('gas', supply)"
                          @click="updateRecoveredSupplyClienteId('gas', supply)"
                        />
                      </div>
                    </div>
                    <span v-else>-</span>
                  </template>
                </Column>
              </DataTable>
            </AccordionTab>
          </Accordion>
        </AccordionTab>
        <AccordionTab header="Rappresentante ID mancante">
          <div class="flex justify-content-between align-items-center flex-wrap mb-3 gap-2">
            <span class="font-semibold">
              Totale righe: {{ matriciIndexRappresentanteIdMancante.total }} | Selezionate: {{ matriciIndexRappresentanteIdMancantePayload.length }}
            </span>
            <div class="missing-client-actions">
              <Button
                label="Aggiorna selezionate"
                icon="pi pi-save"
                class="p-button-rounded p-button-success p-button-sm"
                :loading="updatingMatriciIndexRappresentanteId"
                :disabled="updatingMatriciIndexRappresentanteId || matriciIndexRappresentanteIdMancantePayload.length === 0"
                @click="updateMatriciIndexRappresentanteId"
              />
              <Button
                label="Aggiorna"
                icon="pi pi-refresh"
                class="p-button-rounded p-button-outlined p-button-sm"
                :loading="loadingMatriciIndexRappresentanteIdMancante"
                :disabled="updatingMatriciIndexRappresentanteId"
                @click="loadMatriciIndexRappresentanteIdMancante(true)"
              />
            </div>
          </div>

          <Loader v-if="loadingMatriciIndexRappresentanteIdMancante" />
          <div v-else-if="matriciIndexRappresentanteIdMancante.items.length === 0" class="response-box response-box--warn m-0">
            <p class="feedback-message">Nessuna riga con rappresentante_id mancante trovata</p>
          </div>
          <Accordion v-else :multiple="true" class="missing-client-accordion">
            <AccordionTab
              v-for="group in matriciIndexRappresentanteIdMancante.items"
              :key="group.period"
              :header="`${group.period} (${group.count})`"
            >
              <DataTable
                :value="group.rows"
                dataKey="id"
                showGridlines
                scrollable
                :rowClass="getMissingRepresentativeRowClass"
                class="missing-client-table"
              >
                <template #empty>
                  <div class="response-box response-box--warn m-0">
                    <p class="feedback-message">Nessuna riga presente nel gruppo</p>
                  </div>
                </template>
                <Column headerStyle="width: 3em" bodyStyle="text-align: center">
                  <template #header>
                    <Checkbox
                      :modelValue="isMissingRepresentativeGroupFullySelected(group)"
                      :binary="true"
                      :disabled="getSelectableMissingRepresentativeRows(group).length === 0"
                      @update:modelValue="toggleMissingRepresentativeGroupSelection(group, $event)"
                    />
                  </template>
                  <template #body="{ data }">
                    <Checkbox
                      :modelValue="isMissingRepresentativeRowSelected(group.period, data)"
                      :binary="true"
                      :disabled="!canSelectMissingRepresentativeRow(data)"
                      @update:modelValue="toggleMissingRepresentativeRowSelection(group.period, data, $event)"
                    />
                  </template>
                </Column>
                <Column field="id" header="matrice_index.id" style="min-width: 120px" />
                <Column header="data_caricamento" style="min-width: 170px">
                  <template #body="{ data }">
                    {{ formatDateTime(data.data_caricamento) }}
                  </template>
                </Column>
                <Column field="cod_type_client" header="cod_type_client" style="min-width: 130px" />
                <Column header="codfis log" style="min-width: 170px">
                  <template #body="{ data }">
                    {{ data.codfis_rappresentante_log || '-' }}
                  </template>
                </Column>
                <Column header="id_recuperato" style="min-width: 130px">
                  <template #body="{ data }">
                    {{ data.id_recuperato || '-' }}
                  </template>
                </Column>
                <Column header="rappresentante recuperato" style="min-width: 260px">
                  <template #body="{ data }">
                    <div class="missing-client-supply">
                      <span>{{ data.rappresentante_recuperato_nome || '-' }}</span>
                      <span v-if="data.rappresentante_recuperato_codfis"><strong>CF:</strong> {{ data.rappresentante_recuperato_codfis }}</span>
                    </div>
                  </template>
                </Column>
                <Column header="log caricamento" style="min-width: 300px">
                  <template #body="{ data }">
                    <div class="missing-client-supply">
                      <span>{{ data.caricamento_log_name || '-' }}</span>
                      <span v-if="data.caricamento_log_id"><strong>ID log:</strong> {{ data.caricamento_log_id }}</span>
                    </div>
                  </template>
                </Column>
              </DataTable>
            </AccordionTab>
          </Accordion>
        </AccordionTab>
        <AccordionTab header="Caricamenti con stato 2 duplicato">
          <div class="flex justify-content-between align-items-center flex-wrap mb-3 gap-2">
            <span class="font-semibold">
              Totale caricamenti: {{ caricamentiMatriceIndexStoricoDuplicatoStato2.total }}
            </span>
            <Button
              label="Aggiorna"
              icon="pi pi-refresh"
              class="p-button-rounded p-button-outlined p-button-sm"
              :loading="loadingCaricamentiMatriceIndexStoricoDuplicatoStato2"
              @click="loadCaricamentiMatriceIndexStoricoDuplicatoStato2(true)"
            />
          </div>

          <Loader v-if="loadingCaricamentiMatriceIndexStoricoDuplicatoStato2" />
          <div v-else-if="caricamentiMatriceIndexStoricoDuplicatoStato2.items.length === 0" class="response-box response-box--warn m-0">
            <p class="feedback-message">Nessun caricamento con più stati 2 nello storico trovato</p>
          </div>
          <Accordion v-else :multiple="true" class="matrice-storico-duplicato-accordion">
            <AccordionTab
              v-for="item in caricamentiMatriceIndexStoricoDuplicatoStato2.items"
              :key="item.id"
              :header="getCaricamentoStoricoDuplicatoHeader(item)"
            >
              <div class="missing-client-row-meta">
                <span><strong>matrice_index.id:</strong> {{ item.id }}</span>
                <span><strong>data_caricamento:</strong> {{ formatDateTime(item.data_caricamento) || '-' }}</span>
                <span><strong>stati 2:</strong> {{ item.righe_storico_stato_2 || 0 }}</span>
                <span><strong>storico ids:</strong> {{ item.storico_ids || '-' }}</span>
              </div>

              <DataTable
                :value="getCaricamentoStoricoDuplicatoRows(item)"
                dataKey="id"
                showGridlines
                scrollable
                :rowClass="getMatriceIndexStoricoDuplicatoRowClass"
                class="matrice-storico-duplicato-table"
              >
                <template #empty>
                  <div class="response-box response-box--warn m-0">
                    <p class="feedback-message">Nessuna riga storico presente</p>
                  </div>
                </template>
                <Column header="Azione" style="min-width: 120px">
                  <template #body="{ data }">
                    <Button
                      v-if="canDeleteMatriceIndexStoricoRow(data)"
                      label="Elimina"
                      icon="pi pi-trash"
                      class="p-button-sm p-button-danger"
                      :loading="isDeletingMatriceIndexStorico(data.id)"
                      :disabled="isDeletingMatriceIndexStorico(data.id) || !isLastDeletableMatriceIndexStoricoRow(data)"
                      @click="deleteMatriceIndexStorico(data)"
                    />
                    <span v-else>-</span>
                  </template>
                </Column>
                <Column
                  v-for="col in matriceIndexStoricoDuplicatoStoricoColumns"
                  :key="col.field"
                  :field="col.field"
                  :header="col.label"
                  style="min-width: 130px"
                >
                  <template #body="{ data }">
                    {{ formatMatriceIndexStoricoDuplicatoCell(data[col.field], col.field) }}
                  </template>
                </Column>
              </DataTable>
            </AccordionTab>
          </Accordion>
        </AccordionTab>
        <AccordionTab header="Valida indirizzi fatture Poste">
          <div class="controls-row invoice-poste-controls-row">
            <div class="field-group invoice-poste-input-field">
              <label for="numeriFatturaPosteInput">Numeri fattura</label>
              <Textarea
                id="numeriFatturaPosteInput"
                v-model="numeriFatturaPoste"
                class="w-full invoice-poste-textarea"
                placeholder="Esempio: E1,G12345678"
                :disabled="loadingFatturePoste"
                rows="4"
                :autoResize="true"
                @keyup.enter.ctrl="validaFatturePoste"
              />
            </div>
            <Button
              icon="pi pi-check"
              label="Valida"
              class="p-button-success invoice-poste-validate-button"
              :loading="loadingFatturePoste"
              :disabled="loadingFatturePoste || !numeriFatturaPoste.trim()"
              @click="validaFatturePoste"
            />
          </div>

          <div v-if="fatturePosteErrors.length > 0" class="response-box response-box--error">
            <h4>Fatture non trovate o non cartacee ({{ fatturePosteErrors.length }})</h4>
            <ul class="feedback-list">
              <li v-for="numero in fatturePosteErrors" :key="`poste-error-${numero}`">{{ numero }}</li>
            </ul>
          </div>

          <DataTable
            v-if="fatturePosteReport.length > 0"
            :value="fatturePosteReport"
            dataKey="numero"
            showGridlines
            scrollable
            class="invoice-poste-table"
            :rowClass="getFatturaPosteRowClass"
          >
            <Column field="numero" header="Fattura" style="min-width: 120px" />
            <Column header="Stato" style="min-width: 150px">
              <template #body="{ data }">
                <span class="invoice-poste-status" :class="data.valid ? 'invoice-poste-status--ok' : 'invoice-poste-status--ko'">
                  {{ data.valid ? 'Valida' : 'Da correggere' }}
                </span>
                <span v-if="data.saved" class="invoice-poste-status invoice-poste-status--saved">Salvata</span>
              </template>
            </Column>
            <Column header="Toponimo" style="min-width: 130px">
              <template #body="{ data }">
                <InputText v-if="data.contatto && data.valid !== true" v-model="data.contatto.toponimo" class="w-full" @input="markFatturaPosteRowDirty(data)" />
                <span v-else>{{ data.contatto?.toponimo || '-' }}</span>
              </template>
            </Column>
            <Column header="Indirizzo" style="min-width: 220px">
              <template #body="{ data }">
                <InputText v-if="data.contatto && data.valid !== true" v-model="data.contatto.indirizzo" class="w-full" @input="markFatturaPosteRowDirty(data)" />
                <span v-else>{{ data.contatto?.indirizzo || '-' }}</span>
              </template>
            </Column>
            <Column header="Civico" style="min-width: 100px">
              <template #body="{ data }">
                <InputText v-if="data.contatto && data.valid !== true" v-model="data.contatto.civico" class="w-full" @input="markFatturaPosteRowDirty(data)" />
                <span v-else>{{ data.contatto?.civico || '-' }}</span>
              </template>
            </Column>
            <Column header="CAP" style="min-width: 105px">
              <template #body="{ data }">
                <InputText v-if="data.contatto && data.valid !== true" v-model="data.contatto.cap" class="w-full" @input="markFatturaPosteRowDirty(data)" />
                <span v-else>{{ data.contatto?.cap || '-' }}</span>
              </template>
            </Column>
            <Column header="Comune" style="min-width: 180px">
              <template #body="{ data }">
                <InputText v-if="data.contatto && data.valid !== true" v-model="data.contatto.comune" class="w-full" @input="markFatturaPosteRowDirty(data, true)" />
                <span v-else>{{ data.contatto?.comune || '-' }}</span>
              </template>
            </Column>
            <Column header="Provincia" style="min-width: 110px">
              <template #body="{ data }">
                <InputText v-if="data.contatto && data.valid !== true" v-model="data.contatto.provincia" class="w-full" @input="markFatturaPosteRowDirty(data, true)" />
                <span v-else>{{ data.contatto?.provincia || '-' }}</span>
              </template>
            </Column>
            <Column header="Esito Poste" style="min-width: 260px">
              <template #body="{ data }">
                {{ data.valid ? (data.poste?.message || 'Indirizzo valido') : (data.error || data.poste?.error || '-') }}
              </template>
            </Column>
            <Column header="Azioni" style="min-width: 220px">
              <template #body="{ data }">
                <div class="invoice-poste-actions">
                  <Button v-if="data.valid !== true" icon="pi pi-check" label="Valida" class="p-button-sm" :loading="data.loading_validate" :disabled="!data.contatto || data.loading_validate || data.loading_save" @click="validaContattoFatturaPoste(data)" />
                  <Button v-if="data.can_save === true" icon="pi pi-save" label="Salva" class="p-button-sm p-button-success" :loading="data.loading_save" :disabled="!data.contatto || data.loading_validate || data.loading_save" @click="aggiornaContattoFatturaPoste(data)" />
                </div>
              </template>
            </Column>
          </DataTable>
        </AccordionTab>
        <AccordionTab header="Fatture non inviate da processare">
          <div class="flex justify-content-between align-items-center flex-wrap mb-3 gap-2">
            <span class="font-semibold">
              Totale fatture: {{ fattureNonInviateDaProcessare.total }} | Agenti: {{ fattureNonInviateDaProcessareGroups.length }}
            </span>
            <Button
              label="Aggiorna"
              icon="pi pi-refresh"
              class="p-button-rounded p-button-outlined p-button-sm"
              :loading="loadingFattureNonInviateDaProcessare"
              @click="loadFattureNonInviateDaProcessare(true)"
            />
          </div>

          <Loader v-if="loadingFattureNonInviateDaProcessare" />
          <div v-else-if="fattureNonInviateDaProcessareGroups.length === 0" class="response-box response-box--warn m-0">
            <p class="feedback-message">Nessuna fattura non inviata da processare</p>
          </div>
          <Accordion v-else :multiple="true" class="fatture-non-inviate-accordion">
            <AccordionTab
              v-for="group in fattureNonInviateDaProcessareGroups"
              :key="group.key"
              :header="`${group.label} (${group.count})`"
            >
              <DataTable
                :value="group.rows"
                showGridlines
                scrollable
                class="fatture-non-inviate-table"
              >
                <template #empty>
                  <div class="response-box response-box--warn m-0">
                    <p class="feedback-message">Nessuna fattura presente nel gruppo</p>
                  </div>
                </template>
                <Column
                  v-for="col in fattureNonInviateDaProcessareColumns"
                  :key="col.field"
                  :field="col.field"
                  :header="col.label"
                  style="min-width: 130px"
                >
                  <template #body="{ data }">
                    {{ formatFatturaNonInviataCell(data[col.field], col.field) }}
                  </template>
                </Column>
              </DataTable>
            </AccordionTab>
          </Accordion>
        </AccordionTab>
        <AccordionTab header="Cron">
          <div class="flex flex-wrap">
            <Button
              :loading="loadingCreateContratti"
              :disabled="loadingCreateContratti || loadingCreateContrattiCount || createContrattiCounts.total === 0"
              @click="createContratti"
              class="p-button-rounded p-button-success create-contracts-button mr-2 mb-2"
            >
              <span class="create-contracts-badge">POD {{ createContrattiCounts.pod }}</span>
              <span class="create-contracts-label">Crea contratti</span>
              <span class="create-contracts-badge">PDR {{ createContrattiCounts.pdr }}</span>
            </Button>
            <Button
              label="Report ricerche clienti e rappresentanti"
              icon="pi pi-eye"
              class="p-button-rounded p-button-info mb-2"
              :loading="loadingCheckExistReport || loadingCheckExistReportAgents"
              :disabled="loadingCheckExistReport"
              @click="openCheckExistReportFilters"
            />
          </div>
          <section v-if="showCheckExistReportSearch" class="check-exist-report-search mt-3">
            <div class="flex align-items-center justify-content-between mb-2">
              <h3 class="m-0">Ricerca report</h3>
              <Button icon="pi pi-times" class="p-button-text p-button-rounded" aria-label="Chiudi ricerca report"
                :disabled="loadingCheckExistReport" @click="showCheckExistReportSearch = false" />
            </div>
            <p class="feedback-message">Senza agenti selezionati, il report include tutti gli agenti nel periodo scelto. Se anche le date sono vuote, analizza l'ultima ora.</p>
            <div class="grid">
            <div class="field-group col-12 md:col-4">
              <label for="checkExistAgentIds">Agenti</label>
              <MultiSelect inputId="checkExistAgentIds" v-model="checkExistReportFilters.agentIds"
                :options="checkExistReportAgents" optionLabel="label" optionValue="id" filter display="chip"
                placeholder="Tutti gli agenti" class="w-full" :loading="loadingCheckExistReportAgents"
                :disabled="loadingCheckExistReport || loadingCheckExistReportAgents"
                :maxSelectedLabels="3" selectedItemsLabel="{0} agenti selezionati"
                emptyMessage="Nessun agente disponibile" emptyFilterMessage="Nessun agente trovato" />
            </div>
            <div class="field-group col-12 md:col-4">
              <label for="checkExistFrom">Data e ora iniziale</label>
              <Calendar inputId="checkExistFrom" v-model="checkExistReportFilters.from" dateFormat="dd/mm/yy"
                showTime showSeconds hourFormat="24" showIcon class="w-full" :disabled="loadingCheckExistReport" />
            </div>
            <div class="field-group col-12 md:col-4">
              <label for="checkExistTo">Data e ora finale</label>
              <Calendar inputId="checkExistTo" v-model="checkExistReportFilters.to" dateFormat="dd/mm/yy"
                showTime showSeconds hourFormat="24" showIcon class="w-full" :disabled="loadingCheckExistReport" />
            </div>
            </div>
            <p class="feedback-message">Orari Europe/Rome. Con solo la data iniziale, la fine è adesso; con solo la data finale, l'inizio è un'ora prima. Nessuna mail inviata.</p>
            <div class="flex flex-wrap gap-2 mt-3">
              <Button label="Svuota filtri" class="p-button-text" :disabled="loadingCheckExistReport"
                @click="checkExistReportFilters = { agentIds: [], from: null, to: null }" />
              <Button label="Mostra anteprima" icon="pi pi-eye" :loading="loadingCheckExistReport || loadingCheckExistReportAgents"
                :disabled="loadingCheckExistReport" @click="loadCheckExistReportPreview" />
            </div>

            <div v-if="checkExistReport" class="response-box mt-3">
              <p class="feedback-message">Anteprima report. Nessuna mail inviata.</p>
              <p v-if="checkExistReport?.status === 'nessuna_chiamata'" class="feedback-message">
                Nessuna ricerca di clienti o rappresentanti effettuata dagli agenti nel periodo selezionato.
              </p>
              <template v-if="checkExistReport.agenti?.length">
                <p>Periodo: {{ checkExistReport.inizio }} — {{ checkExistReport.fine }} (Europe/Rome)</p>
                <h4>Riepilogo per agente e rotta</h4>
                <DataTable :value="checkExistSummaryRows" showGridlines scrollable>
                  <Column field="agente" header="Agente" sortable />
                  <Column field="rotta" header="Ricerca" sortable />
                  <Column field="chiamate" header="Chiamate" sortable />
                  <Column field="payload_distinti" header="Payload distinti" />
                  <Column field="ricerche_distinte" header="CF/PIVA distinti" />
                  <Column field="caricamenti" header="Caricamenti agente nel periodo" />
                  <Column field="rapporto" header="Chiamate totali / caricamenti" />
                  <Column field="chiamate_con_caricamento" header="Caricamento successivo" />
                  <Column field="chiamate_con_caricamento_precedente" header="Solo precedente" />
                  <Column field="chiamate_senza_caricamento" header="Nessun caricamento" />
                  <Column field="chiamate_non_verificabili" header="Non verificabili" />
                </DataTable>
                <h4>Dettaglio ricerche</h4>
                <p>Successivo: caricamento nel periodo dopo la ricerca. Solo precedente: possibile consultazione di un cliente già caricato. Nessun caricamento: ricerca da verificare. Il collegamento usa agente e CF/PIVA, senza un identificativo della sessione wizard.</p>
                <label for="checkExistOutcome">Esito </label>
                <select id="checkExistOutcome" v-model="checkExistOutcome" class="p-inputtext p-component mb-3">
                  <option value="">Tutti gli esiti</option>
                  <option>Caricamento successivo</option>
                  <option>Solo caricamento precedente</option>
                  <option>Nessun caricamento associato</option>
                  <option>Non verificabile</option>
                </select>
                <DataTable :value="checkExistDetailRows" showGridlines scrollable paginator :rows="20" :rowsPerPageOptions="[20, 50, 100]">
                  <template #empty>Nessuna ricerca per l'esito selezionato.</template>
                  <Column field="agente" header="Agente" sortable />
                  <Column field="rotta" header="Ricerca" sortable />
                  <Column field="log_id" header="ID log" sortable />
                  <Column field="ora" header="Data ricerca" sortable />
                  <Column field="cf" header="CF / identificativo rappresentante" />
                  <Column field="piva" header="PIVA cliente" />
                  <Column field="ip" header="IP" />
                  <Column field="esito" header="Esito" sortable>
                    <template #body="{ data }">
                      <span :class="{ 'text-red-600 font-bold': data.esito === 'Nessun caricamento associato', 'text-green-600': data.esito === 'Caricamento successivo' }">{{ data.esito }}</span>
                    </template>
                  </Column>
                  <Column field="caricamento_id" header="ID caricamento" sortable />
                  <Column field="caricamento_ora" header="Data caricamento" sortable />
                  <Column field="tempo" header="Tempo prima / dopo la ricerca" />
                </DataTable>
              </template>
              <p v-else-if="checkExistReport.status === 'in_esecuzione'">Un report è già in esecuzione. Riprova al termine.</p>

            </div>
          </section>
        </AccordionTab>
        <AccordionTab header="Logs">
          <div class="flex flex-wrap">
            <Button
              v-for="logType in logTypes"
              :key="logType.project + ':' + logType.type"
              :label="logType.project + ' · ' + logType.label"
              class="p-button-rounded p-button-success mr-2 mb-2"
              :loading="loadingLogs && selectedLogType === logType.type && selectedLogProject === logType.project"
              :disabled="loadingLogs || loadingLogGlobalSearch"
              @click="loadLogFiles(logType.type, logType.project)"
            />
          </div>

          <div class="logs-global-search-toolbar">
            <span class="p-input-icon-left logs-global-search-input-wrap">
              <i class="pi pi-search" />
              <InputText
                v-model="logGlobalSearchQuery"
                class="p-inputtext-sm logs-global-search-input"
                placeholder="Stringa in tutti i log"
                :disabled="loadingLogs || loadingLogGlobalSearch || logTypes.length === 0"
                @input="onLogGlobalSearchInput"
                @keydown.enter.prevent="searchAllLogTypes"
                @keydown.esc.prevent="clearLogGlobalSearch"
              />
            </span>
            <Button
              icon="pi pi-search"
              label="Cerca"
              class="p-button-sm p-button-success logs-global-search-button"
              :loading="loadingLogGlobalSearch"
              :disabled="!canSearchAllLogTypes"
              @click="searchAllLogTypes"
            />
            <Button
              icon="pi pi-times"
              class="p-button-sm p-button-text p-button-secondary logs-global-search-clear"
              :disabled="loadingLogGlobalSearch || (!logGlobalSearchQuery && logGlobalSearchResults.length === 0)"
              @click="clearLogGlobalSearch"
            />
            <span class="logs-global-search-status">{{ logGlobalSearchStatusLabel }}</span>
          </div>

          <DataTable
            v-if="logGlobalSearchLastQuery"
            :value="logGlobalSearchResults"
            showGridlines
            scrollable
            class="logs-global-search-results"
          >
            <template #empty>
              <div class="response-box response-box--warn m-0">
                <p class="feedback-message">
                  {{ loadingLogGlobalSearch ? 'Ricerca in corso...' : `Nessun risultato trovato per "${logGlobalSearchLastQuery}"` }}
                </p>
              </div>
            </template>
            <Column field="log_type_label" header="Tipo" style="min-width: 190px"></Column>
            <Column field="filename" header="File" style="min-width: 260px"></Column>
            <Column field="match_count" header="Occorrenze" style="min-width: 110px"></Column>
            <Column header="Anteprima" style="min-width: 420px">
              <template #body="{ data }">
                <div class="logs-global-search-preview">
                  <div
                    v-for="match in data.preview_matches"
                    :key="`${data.project}-${data.log_type}-${data.filename}-${match.line_number}`"
                    class="logs-global-search-preview-line"
                  >
                    <strong>{{ match.line_number }}:</strong> {{ match.text }}
                  </div>
                </div>
              </template>
            </Column>
            <Column header="Azioni" style="min-width: 110px">
              <template #body="{ data }">
                <Button
                  icon="pi pi-eye"
                  class="p-button-text p-button-info"
                  v-tooltip="'Mostra contenuto'"
                  :loading="loadingLogContent && selectedLogFilename === data.filename && !isLogTailActive"
                  :disabled="loadingLogContent"
                  @click="openLogFile(data.filename, logGlobalSearchLastQuery, data.project)"
                />
              </template>
            </Column>
          </DataTable>

          <Loader v-if="loadingLogs" />
          <DataTable v-else :value="logFiles" showGridlines scrollable class="logs-table">
            <template #empty>
              <div class="response-box response-box--warn m-0">
                <p class="feedback-message">
                  {{ selectedLogType ? 'Nessun file di log disponibile per il tipo selezionato' : 'Seleziona un tipo log' }}
                </p>
              </div>
            </template>
            <Column field="filename" header="File" style="min-width: 260px"></Column>
            <Column field="date" header="Data" style="min-width: 120px"></Column>
            <Column field="size" header="Dimensione" style="min-width: 120px">
              <template #body="{ data }">
                {{ formatBytes(data.size) }}
              </template>
            </Column>
            <Column field="last_modified" header="Ultima modifica" style="min-width: 180px"></Column>
            <Column header="Azioni" style="min-width: 150px">
              <template #body="{ data }">
                <Button
                  icon="pi pi-eye"
                  class="p-button-text p-button-info"
                  v-tooltip="'Mostra contenuto'"
                  :loading="loadingLogContent && selectedLogFilename === data.filename && !isLogTailActive"
                  :disabled="loadingLogContent"
                  @click="openLogFile(data.filename, '', data.project)"
                />
                <Button
                  icon="pi pi-play"
                  class="p-button-text p-button-success"
                  v-tooltip="'Tail live'"
                  :loading="loadingLogContent && selectedLogFilename === data.filename && isLogTailActive"
                  :disabled="loadingLogContent"
                  @click="openLogTail(data.filename, data.project)"
                />
              </template>
            </Column>
          </DataTable>
        </AccordionTab>
        <AccordionTab header="File pratiche da recuperare">
          <div class="controls-row payload-id-controls-row">
            <div class="field-group">
              <label for="filePraticheMonth">Mese creazione</label>
              <div class="calendar-stepper">
                <Button
                  icon="pi pi-chevron-left"
                  class="p-button-sm p-button-text calendar-stepper-button"
                  :disabled="loadingFilePraticheDaRecuperare || updatingFilePraticheDaRecuperare"
                  @click="shiftCalendarDate('filePraticheMonth', -1, 'month')"
                />
                <Calendar
                  id="filePraticheMonth"
                  v-model="filePraticheMonth"
                  view="month"
                  dateFormat="mm/yy"
                  :manualInput="false"
                  :showIcon="true"
                  :maxDate="calendarMaxMonth"
                  placeholder="Seleziona mese"
                  class="w-full"
                />
                <Button
                  icon="pi pi-chevron-right"
                  class="p-button-sm p-button-text calendar-stepper-button"
                  :disabled="loadingFilePraticheDaRecuperare || updatingFilePraticheDaRecuperare || isCalendarShiftDisabled('filePraticheMonth', 1, 'month', null, calendarMaxMonth)"
                  @click="shiftCalendarDate('filePraticheMonth', 1, 'month', null, calendarMaxMonth)"
                />
              </div>
            </div>
            <div class="field-group payload-id-without-limit-field">
              <label for="filePraticheWithoutLimit">Risultati</label>
              <div class="flex align-items-center gap-2">
                <Checkbox
                  id="filePraticheWithoutLimit"
                  v-model="filePraticheWithoutLimit"
                  :binary="true"
                  :disabled="loadingFilePraticheDaRecuperare || updatingFilePraticheDaRecuperare"
                />
                <span>Senza limite 20</span>
              </div>
            </div>
            <Button
              label="Cerca"
              icon="pi pi-search"
              class="p-button-success"
              :loading="loadingFilePraticheDaRecuperare"
              :disabled="loadingFilePraticheDaRecuperare || !filePraticheMonth"
              @click="loadFilePraticheDaRecuperare(true)"
            />
            <Button
              label="Aggiorna selezionati"
              icon="pi pi-save"
              class="p-button-success"
              :loading="updatingFilePraticheDaRecuperare"
              :disabled="updatingFilePraticheDaRecuperare || selectedFilePraticheDaRecuperare.length === 0"
              @click="updateFilePraticheDaRecuperare"
            />
          </div>

          <div v-if="filePraticheDaRecuperareLoaded" class="response-box response-box--info m-0 mt-3 payload-id-total-box">
            <p class="feedback-message">
              Totale file per {{ filePraticheLoadedMonthLabel }}:
              <strong>{{ formatPayloadIdTotal(filePraticheDaRecuperare.total) }}</strong>
              <span class="payload-id-visible-count">
                (visualizzati: {{ filePraticheDaRecuperare.items.length }}{{ filePraticheLoadedWithoutLimit ? ', senza limite' : ', limite 20' }})
              </span>
            </p>
          </div>

          <Loader v-if="loadingFilePraticheDaRecuperare || updatingFilePraticheDaRecuperare" />
          <div v-else-if="filePraticheDaRecuperareLoaded && filePraticheDaRecuperare.items.length === 0" class="response-box response-box--warn m-0 mt-3">
            <p class="feedback-message">Nessun file pratica da recuperare per il mese selezionato</p>
          </div>
          <DataTable
            v-else-if="filePraticheDaRecuperare.items.length > 0"
            :value="filePraticheDaRecuperare.items"
            dataKey="id"
            showGridlines
            scrollable
            :paginator="true"
            :rows="20"
            :rowsPerPageOptions="[10, 20, 50, 100]"
            paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
            currentPageReportTemplate="{first} a {last} di {totalRecords}"
            class="file-pratiche-recupero-table mt-3"
          >
            <template #header>
              Totale file: {{ formatPayloadIdTotal(filePraticheDaRecuperare.total) }} | Visualizzati: {{ filePraticheDaRecuperare.items.length }} | Selezionati: {{ selectedFilePraticheDaRecuperare.length }}
            </template>
            <template #empty>
              <div class="response-box response-box--warn m-0">
                <p class="feedback-message">Nessun file pratica da recuperare</p>
              </div>
            </template>
            <Column headerStyle="width: 3em" bodyStyle="text-align: center">
              <template #header>
                <Checkbox
                  :modelValue="areAllFilePraticheDaRecuperareSelected()"
                  :binary="true"
                  :disabled="updatingFilePraticheDaRecuperare || getSelectableFilePraticheDaRecuperare().length === 0"
                  @update:modelValue="toggleAllFilePraticheDaRecuperare($event)"
                />
              </template>
              <template #body="{ data }">
                <Checkbox
                  :modelValue="isFilePraticaDaRecuperareSelected(data)"
                  :binary="true"
                  :disabled="!isFilePraticaDaRecuperareSelectable(data) || updatingFilePraticheDaRecuperare"
                  @update:modelValue="toggleFilePraticaDaRecuperareSelection(data, $event)"
                />
              </template>
            </Column>
            <Column
              v-for="col in filePraticheDaRecuperareColumns"
              :key="col.field"
              :field="col.field"
              :header="col.label"
              style="min-width: 150px"
              :sortable="true"
            >
              <template #body="{ data }">
                {{ formatFilePraticaDaRecuperareCell(data[col.field], col.field) }}
              </template>
            </Column>
          </DataTable>
        </AccordionTab>
        <AccordionTab header="Payload ID caricamenti">
          <div class="controls-row payload-id-controls-row">
            <div class="field-group">
              <label for="payloadIdMonth">Mese caricamento</label>
              <div class="calendar-stepper">
                <Button
                  icon="pi pi-chevron-left"
                  class="p-button-sm p-button-text calendar-stepper-button"
                  :disabled="loadingPayloadIdCaricamenti || updatingPayloadIdCaricamenti"
                  @click="shiftCalendarDate('payloadIdMonth', -1, 'month')"
                />
                <Calendar
                  id="payloadIdMonth"
                  v-model="payloadIdMonth"
                  view="month"
                  dateFormat="mm/yy"
                  :manualInput="false"
                  :showIcon="true"
                  :maxDate="calendarMaxMonth"
                  placeholder="Seleziona mese"
                  class="w-full"
                />
                <Button
                  icon="pi pi-chevron-right"
                  class="p-button-sm p-button-text calendar-stepper-button"
                  :disabled="loadingPayloadIdCaricamenti || updatingPayloadIdCaricamenti || isCalendarShiftDisabled('payloadIdMonth', 1, 'month', null, calendarMaxMonth)"
                  @click="shiftCalendarDate('payloadIdMonth', 1, 'month', null, calendarMaxMonth)"
                />
              </div>
            </div>
            <div class="field-group payload-id-without-limit-field">
              <label for="payloadIdWithoutLimit">Risultati</label>
              <div class="flex align-items-center gap-2">
                <Checkbox
                  id="payloadIdWithoutLimit"
                  v-model="payloadIdWithoutLimit"
                  :binary="true"
                  :disabled="loadingPayloadIdCaricamenti || updatingPayloadIdCaricamenti"
                />
                <span>Senza limite 20</span>
              </div>
            </div>
            <Button
              icon="pi pi-search"
              label="Cerca"
              class="p-button-success"
              :loading="loadingPayloadIdCaricamenti"
              :disabled="loadingPayloadIdCaricamenti || !payloadIdMonth"
              @click="loadPayloadIdCaricamenti"
            />
            <Button
              icon="pi pi-save"
              label="Aggiorna selezionati"
              class="p-button-success"
              :loading="updatingPayloadIdCaricamenti"
              :disabled="updatingPayloadIdCaricamenti || selectedPayloadIdCaricamenti.length === 0"
              @click="updatePayloadIdCaricamenti"
            />
          </div>

          <div v-if="payloadIdCaricamentiLoaded" class="response-box response-box--info m-0 mt-3 payload-id-total-box">
            <p class="feedback-message">
              Totale caricamenti per {{ payloadIdLoadedMonthLabel }}:
              <strong>{{ formatPayloadIdTotal(payloadIdCaricamenti.total) }}</strong>
              <span class="payload-id-visible-count">
                (visualizzati: {{ payloadIdCaricamenti.items.length }}{{ payloadIdLoadedWithoutLimit ? ', senza limite' : ', limite 20' }})
              </span>
            </p>
          </div>

          <Loader v-if="loadingPayloadIdCaricamenti || updatingPayloadIdCaricamenti" />
          <div v-else-if="payloadIdCaricamentiLoaded && payloadIdCaricamenti.items.length === 0" class="response-box response-box--warn m-0 mt-3">
            <p class="feedback-message">Nessun caricamento trovato per il mese selezionato</p>
          </div>
          <DataTable
            v-else-if="payloadIdCaricamenti.items.length > 0"
            :value="payloadIdCaricamenti.items"
            dataKey="matrice_index_id"
            showGridlines
            scrollable
            :paginator="true"
            :rows="20"
            :rowsPerPageOptions="[10, 20, 50, 100]"
            class="payload-id-table mt-3"
          >
            <template #header>
              Totale mese: {{ formatPayloadIdTotal(payloadIdCaricamenti.total) }} | Visualizzati: {{ payloadIdCaricamenti.items.length }} | Selezionati: {{ payloadIdSelectionLabel }}
            </template>
            <Column headerStyle="width: 3em" bodyStyle="text-align: center">
              <template #header>
                <Checkbox
                  :modelValue="areAllPayloadIdCaricamentiSelected()"
                  :binary="true"
                  :disabled="updatingPayloadIdCaricamenti || getSelectablePayloadIdCaricamenti().length === 0"
                  @update:modelValue="toggleAllPayloadIdCaricamenti($event)"
                />
              </template>
              <template #body="{ data }">
                <Checkbox
                  :modelValue="isPayloadIdCaricamentoSelected(data)"
                  :binary="true"
                  :disabled="!isPayloadIdCaricamentoSelectable(data) || isPayloadIdCaricamentoSelectionDisabled(data) || updatingPayloadIdCaricamenti"
                  @update:modelValue="togglePayloadIdCaricamentoSelection(data, $event)"
                />
              </template>
            </Column>
            <Column
              v-for="col in payloadIdCaricamentiColumns"
              :key="col.field"
              :field="col.field"
              :header="col.label"
              style="min-width: 150px"
              :sortable="true"
            >
              <template #body="{ data }">
                <Tag
                  v-if="col.field === 'match_type'"
                  :value="getPayloadIdMatchLabel(data.match_type)"
                  :severity="getPayloadIdMatchSeverity(data.match_type)"
                />
                <strong v-else-if="isPayloadIdSuggestedField(col.field)">{{ data[col.field] || '-' }}</strong>
                <span v-else>{{ formatPayloadIdCaricamentiCell(data[col.field], col.field) }}</span>
              </template>
            </Column>
          </DataTable>
        </AccordionTab>
        <AccordionTab header="Log data switch retroattivi">
          <div class="controls-row payload-id-controls-row">
            <div class="field-group">
              <label for="switchDateLogMonth">Mese validazione</label>
              <div class="calendar-stepper">
                <Button
                  icon="pi pi-chevron-left"
                  class="p-button-sm p-button-text calendar-stepper-button"
                  :disabled="loadingSwitchDateLogRetroattivi || creatingSwitchDateLogRetroattivi"
                  @click="shiftCalendarDate('switchDateLogMonth', -1, 'month')"
                />
                <Calendar
                  id="switchDateLogMonth"
                  v-model="switchDateLogMonth"
                  view="month"
                  dateFormat="mm/yy"
                  :manualInput="false"
                  :showIcon="true"
                  :maxDate="calendarMaxMonth"
                  placeholder="Seleziona mese"
                  class="w-full"
                />
                <Button
                  icon="pi pi-chevron-right"
                  class="p-button-sm p-button-text calendar-stepper-button"
                  :disabled="loadingSwitchDateLogRetroattivi || creatingSwitchDateLogRetroattivi || isCalendarShiftDisabled('switchDateLogMonth', 1, 'month', null, calendarMaxMonth)"
                  @click="shiftCalendarDate('switchDateLogMonth', 1, 'month', null, calendarMaxMonth)"
                />
              </div>
            </div>
            <div class="field-group payload-id-without-limit-field">
              <label for="switchDateLogWithoutLimit">Risultati</label>
              <div class="flex align-items-center gap-2">
                <Checkbox
                  id="switchDateLogWithoutLimit"
                  v-model="switchDateLogWithoutLimit"
                  :binary="true"
                  :disabled="loadingSwitchDateLogRetroattivi || creatingSwitchDateLogRetroattivi"
                />
                <span>Senza limite 20</span>
              </div>
            </div>

            <Button
              icon="pi pi-search"
              label="Cerca"
              class="p-button-success"
              :loading="loadingSwitchDateLogRetroattivi"
              :disabled="loadingSwitchDateLogRetroattivi || !switchDateLogMonth"
              @click="loadSwitchDateLogRetroattivi"
            />
            <Button
              icon="pi pi-save"
              label="Crea log selezionati"
              class="p-button-success"
              :loading="creatingSwitchDateLogRetroattivi"
              :disabled="creatingSwitchDateLogRetroattivi || selectedSwitchDateLogRetroattivi.length === 0"
              @click="createSwitchDateLogRetroattivi"
            />
          </div>

          <div v-if="switchDateLogRetroattiviLoaded" class="response-box response-box--info m-0 mt-3 payload-id-total-box">
            <p class="feedback-message">
              Totale log data switch da creare per {{ switchDateLogLoadedMonthLabel }}:
              <strong>{{ formatPayloadIdTotal(switchDateLogRetroattivi.total) }}</strong>
              <span class="payload-id-visible-count">
                (visualizzati: {{ switchDateLogRetroattivi.items.length }}{{ switchDateLogLoadedWithoutLimit ? ', senza limite' : ', limite 20' }})
              </span>
            </p>
          </div>

          <Loader v-if="loadingSwitchDateLogRetroattivi || creatingSwitchDateLogRetroattivi" />
          <div v-else-if="switchDateLogRetroattiviLoaded && switchDateLogRetroattivi.items.length === 0" class="response-box response-box--warn m-0 mt-3">
            <p class="feedback-message">Nessun log data switch da creare per il mese di validazione selezionato</p>
          </div>
          <DataTable
            v-else-if="switchDateLogRetroattivi.items.length > 0"
            :value="switchDateLogRetroattivi.items"
            dataKey="matrice_index_id"
            showGridlines
            scrollable
            :paginator="true"
            :rows="20"
            :rowsPerPageOptions="[10, 20, 50, 100]"
            class="payload-id-table mt-3"
          >
            <template #header>
              Totale da creare: {{ formatPayloadIdTotal(switchDateLogRetroattivi.total) }} | Visualizzati: {{ switchDateLogRetroattivi.items.length }} | Selezionati: {{ switchDateLogSelectionLabel }}
            </template>
            <Column headerStyle="width: 3em" bodyStyle="text-align: center">
              <template #header>
                <Checkbox
                  :modelValue="areAllSwitchDateLogRetroattiviSelected()"
                  :binary="true"
                  :disabled="creatingSwitchDateLogRetroattivi || getSelectableSwitchDateLogRetroattivi().length === 0"
                  @update:modelValue="toggleAllSwitchDateLogRetroattivi($event)"
                />
              </template>
              <template #body="{ data }">
                <Checkbox
                  :modelValue="isSwitchDateLogRetroattivoSelected(data)"
                  :binary="true"
                  :disabled="!isSwitchDateLogRetroattivoSelectable(data) || isSwitchDateLogSelectionDisabled(data) || creatingSwitchDateLogRetroattivi"
                  @update:modelValue="toggleSwitchDateLogRetroattivoSelection(data, $event)"
                />
              </template>
            </Column>
            <Column
              v-for="col in switchDateLogRetroattiviColumns"
              :key="col.field"
              :field="col.field"
              :header="col.label"
              style="min-width: 150px"
              :sortable="true"
            >
              <template #body="{ data }">
                <Tag
                  v-if="col.field === 'selezionabile'"
                  :value="data.selezionabile ? 'Si' : 'No'"
                  :severity="data.selezionabile ? 'success' : 'warning'"
                />
                <Tag
                  v-else-if="col.field === 'update_pod' || col.field === 'update_pdr'"
                  :value="data[col.field] ? 'Si' : 'No'"
                  :severity="data[col.field] ? 'success' : 'secondary'"
                />
                <span v-else>{{ formatSwitchDateLogRetroattiviCell(data[col.field], col.field) }}</span>
              </template>
            </Column>
          </DataTable>
        </AccordionTab>
        <AccordionTab header="Forza scissione PK">
          <div class="controls-row force-scissione-pk-controls-row">
            <div class="field-group force-scissione-pk-input-field">
              <label for="forceScissionePkIds">ID matrici</label>
              <Textarea
                id="forceScissionePkIds"
                v-model="forzaScissionePkIds"
                :autoResize="true"
                rows="5"
                class="w-full force-scissione-pk-textarea"
                placeholder="Esempio: 111,112,113"
              />
            </div>

            <Button
              icon="pi pi-check"
              label="Forza scissione"
              class="p-button-success force-scissione-pk-button"
              :loading="loadingForzaScissionePk"
              :disabled="loadingForzaScissionePk || loadingCronForzaScissionePk"
              @click="forzaScissionePkMassiva"
            />
            <Button
              icon="pi pi-play"
              label="Avvia cron"
              class="p-button-info force-scissione-pk-button"
              :loading="loadingCronForzaScissionePk"
              :disabled="loadingForzaScissionePk || loadingCronForzaScissionePk"
              @click="cronForzaScissionePkMassiva"
            />
          </div>

          <div v-if="forzaScissionePkFeedback" class="response-box mt-3" :class="`response-box--${forzaScissionePkFeedback.severity}`">
            <h4>{{ forzaScissionePkFeedback.title }}</h4>
            <p class="feedback-message">{{ forzaScissionePkFeedback.message }}</p>
            <ul v-if="forzaScissionePkFeedback.details.length > 0" class="feedback-list">
              <li v-for="detail in forzaScissionePkFeedback.details" :key="detail">{{ detail }}</li>
            </ul>
          </div>
        </AccordionTab>
        <AccordionTab header="Matrici senza switch">
          <div class="controls-row payload-id-controls-row">
            <div class="field-group">
              <label for="matriciSenzaSwitchMonth">Mese caricamento</label>
              <div class="calendar-stepper">
                <Button
                  icon="pi pi-chevron-left"
                  class="p-button-sm p-button-text calendar-stepper-button"
                  :disabled="loadingMatriciSenzaSwitch"
                  @click="shiftCalendarDate('matriciSenzaSwitchMonth', -1, 'month')"
                />
                <Calendar
                  id="matriciSenzaSwitchMonth"
                  v-model="matriciSenzaSwitchMonth"
                  view="month"
                  dateFormat="mm/yy"
                  :manualInput="false"
                  :showIcon="true"
                  :maxDate="calendarMaxMonth"
                  placeholder="Seleziona mese"
                  class="w-full"
                />
                <Button
                  icon="pi pi-chevron-right"
                  class="p-button-sm p-button-text calendar-stepper-button"
                  :disabled="loadingMatriciSenzaSwitch || isCalendarShiftDisabled('matriciSenzaSwitchMonth', 1, 'month', null, calendarMaxMonth)"
                  @click="shiftCalendarDate('matriciSenzaSwitchMonth', 1, 'month', null, calendarMaxMonth)"
                />
              </div>
            </div>

            <div class="field-group payload-id-without-limit-field">
              <label for="matriciSenzaSwitchWithoutLimit">Risultati</label>
              <div class="flex align-items-center gap-2">
                <Checkbox
                  id="matriciSenzaSwitchWithoutLimit"
                  v-model="matriciSenzaSwitchWithoutLimit"
                  :binary="true"
                  :disabled="loadingMatriciSenzaSwitch || creatingMatriciSwitchMancanti"
                />
                <span>Senza limite 20</span>
              </div>
            </div>

            <Button
              icon="pi pi-search"
              label="Cerca"
              class="p-button-success"
              :loading="loadingMatriciSenzaSwitch"
              :disabled="loadingMatriciSenzaSwitch || creatingMatriciSwitchMancanti || !matriciSenzaSwitchMonth"
              @click="loadMatriciSenzaSwitch"
            />
            <Button
              v-if="selectedMatriciSenzaSwitchCodState2Items.length > 0"
              icon="pi pi-save"
              :label="`Crea switch mancanti (${selectedMatriciSenzaSwitchCodState2Items.length})`"
              class="p-button-info"
              :loading="creatingMatriciSwitchMancanti"
              :disabled="loadingMatriciSenzaSwitch || creatingMatriciSwitchMancanti"
              @click="createMatriciSwitchMancanti"
            />
          </div>

          <div v-if="matriciSenzaSwitchLoaded" class="response-box response-box--info m-0 mt-3 payload-id-total-box">
            <p class="feedback-message">
              Totale righe senza switch per {{ matriciSenzaSwitchLoadedMonthLabel }}:
              <strong>{{ formatPayloadIdTotal(matriciSenzaSwitch.total) }}</strong>
              <span class="payload-id-visible-count">
                (visualizzate: {{ matriciSenzaSwitch.items.length }}{{ matriciSenzaSwitchLoadedWithoutLimit ? ', senza limite' : ', limite 20' }}, selezionate: {{ selectedMatriciSenzaSwitch.length }}, switch da creare: {{ selectedMatriciSenzaSwitchCodState2Items.length }})
              </span>
            </p>
          </div>

          <Loader v-if="loadingMatriciSenzaSwitch || creatingMatriciSwitchMancanti" />
          <div v-else-if="matriciSenzaSwitchLoaded && matriciSenzaSwitch.items.length === 0" class="response-box response-box--warn m-0 mt-3">
            <p class="feedback-message">Nessuna riga matrice_ee o matrice_gas senza switch per il mese selezionato</p>
          </div>
          <DataTable
            v-else-if="matriciSenzaSwitch.items.length > 0"
            :value="matriciSenzaSwitch.items"
            dataKey="row_key"
            showGridlines
            scrollable
            :paginator="true"
            :rows="20"
            :rowsPerPageOptions="[10, 20, 50, 100]"
            class="matrici-senza-switch-table mt-3"
          >
            <template #header>
              Totale righe: {{ formatPayloadIdTotal(matriciSenzaSwitch.total) }} | Visualizzate: {{ matriciSenzaSwitch.items.length }} | Selezionate: {{ selectedMatriciSenzaSwitch.length }}
            </template>
            <Column headerStyle="width: 3em" bodyStyle="text-align: center">
              <template #header>
                <Checkbox
                  :modelValue="areAllMatriciSenzaSwitchSelected()"
                  :binary="true"
                  :disabled="creatingMatriciSwitchMancanti || getSelectableMatriciSenzaSwitch().length === 0"
                  @update:modelValue="toggleAllMatriciSenzaSwitch($event)"
                />
              </template>
              <template #body="{ data }">
                <Checkbox
                  :modelValue="isMatriciSenzaSwitchSelected(data)"
                  :binary="true"
                  :disabled="!isMatriciSenzaSwitchSelectable(data) || creatingMatriciSwitchMancanti"
                  @update:modelValue="toggleMatriciSenzaSwitchSelection(data, $event)"
                />
              </template>
            </Column>
            <Column
              v-for="col in matriciSenzaSwitchColumns"
              :key="col.field"
              :field="col.field"
              :header="col.label"
              style="min-width: 140px"
              :sortable="true"
            >
              <template #body="{ data }">
                <Tag
                  v-if="col.field === 'tipo'"
                  :value="String(data.tipo || '-').toUpperCase()"
                  :severity="data.tipo === 'gas' ? 'warning' : 'info'"
                />
                <span v-else>{{ formatMatriciSenzaSwitchCell(data[col.field], col.field) }}</span>
              </template>
            </Column>
          </DataTable>
        </AccordionTab>
        <AccordionTab header="Log Error Preavvisi">
          <div class="flex justify-content-between align-items-center flex-wrap mb-3 gap-2">
            <div class="log-error-preavvisi-toolbar">
              <span class="font-semibold">
                Totale errori: {{ logErrorPreavvisiTotal }}
                | PEC {{ logErrorPreavvisi.pec.total }}
                | Email {{ logErrorPreavvisi.email.total }}
              </span>
              <div class="field-group log-error-preavvisi-filter">
                <label>Tipo invio</label>
                <SelectButton
                  v-model="logErrorPreavvisiTipoFilter"
                  :options="logErrorPreavvisiTipoOptions"
                  optionLabel="label"
                  optionValue="value"
                  :allowEmpty="false"
                />
              </div>
            </div>
            <Button
              label="Aggiorna"
              icon="pi pi-refresh"
              class="p-button-rounded p-button-outlined p-button-sm"
              :loading="loadingLogErrorPreavvisi"
              @click="loadLogErroriInviiPreavvisi(true)"
            />
          </div>

          <Loader v-if="loadingLogErrorPreavvisi && !logErrorPreavvisiLoaded" />
          <div v-else-if="logErrorPreavvisiLoaded && logErrorPreavvisiVisibleTotal === 0" class="response-box response-box--warn m-0">
            <p class="feedback-message">{{ logErrorPreavvisiEmptyMessage }}</p>
          </div>
          <Accordion v-else :multiple="true" class="log-error-preavvisi-accordion">
            <AccordionTab v-if="showLogErrorPreavvisiPec" :header="`PEC (${logErrorPreavvisi.pec.total})`">
              <DataTable
                :value="logErrorPreavvisi.pec.items"
                :lazy="true"
                :paginator="true"
                :rows="logErrorPreavvisi.pec.per_page"
                :totalRecords="logErrorPreavvisi.pec.total"
                :first="logErrorPreavvisiPecFirst"
                :rowsPerPageOptions="[10, 20, 50, 100]"
                :loading="loadingLogErrorPreavvisiPec"
                dataKey="id"
                showGridlines
                scrollable
                class="log-error-preavvisi-table"
                @page="onLogErrorPreavvisiPage('pec', $event)"
              >
                <template #empty>
                  <div class="response-box response-box--warn m-0">
                    <p class="feedback-message">Nessun errore PEC</p>
                  </div>
                </template>
                <Column field="created_at" header="Data" style="min-width: 170px">
                  <template #body="{ data }">
                    {{ formatLogErrorPreavvisiDate(data.created_at) }}
                  </template>
                </Column>
                <Column field="numero" header="N. fattura" style="min-width: 140px">
                  <template #body="{ data }">
                    <Tag v-if="data.numero" :value="String(data.numero)" severity="info" />
                    <span v-else>-</span>
                  </template>
                </Column>
                <Column field="email_destinatario" header="Destinatario" style="min-width: 240px"></Column>
                <Column field="errore" header="Errore" style="min-width: 360px">
                  <template #body="{ data }">
                    <span class="log-error-preavvisi-error">{{ data.errore || '-' }}</span>
                  </template>
                </Column>
              </DataTable>
            </AccordionTab>
            <AccordionTab v-if="showLogErrorPreavvisiEmail" :header="`Email (${logErrorPreavvisi.email.total})`">
              <DataTable
                :value="logErrorPreavvisi.email.items"
                :lazy="true"
                :paginator="true"
                :rows="logErrorPreavvisi.email.per_page"
                :totalRecords="logErrorPreavvisi.email.total"
                :first="logErrorPreavvisiEmailFirst"
                :rowsPerPageOptions="[10, 20, 50, 100]"
                :loading="loadingLogErrorPreavvisiEmail"
                dataKey="id"
                showGridlines
                scrollable
                class="log-error-preavvisi-table"
                @page="onLogErrorPreavvisiPage('email', $event)"
              >
                <template #empty>
                  <div class="response-box response-box--warn m-0">
                    <p class="feedback-message">Nessun errore Email</p>
                  </div>
                </template>
                <Column field="created_at" header="Data" style="min-width: 170px">
                  <template #body="{ data }">
                    {{ formatLogErrorPreavvisiDate(data.created_at) }}
                  </template>
                </Column>
                <Column field="numero" header="N. fattura" style="min-width: 140px">
                  <template #body="{ data }">
                    <Tag v-if="data.numero" :value="String(data.numero)" severity="info" />
                    <span v-else>-</span>
                  </template>
                </Column>
                <Column field="email_destinatario" header="Destinatario" style="min-width: 240px"></Column>
                <Column field="errore" header="Errore" style="min-width: 360px">
                  <template #body="{ data }">
                    <span class="log-error-preavvisi-error">{{ data.errore || '-' }}</span>
                  </template>
                </Column>
              </DataTable>
            </AccordionTab>
          </Accordion>
        </AccordionTab>
        <AccordionTab header="Ask Mail - Test connessione DB">
          <div class="ask-mail-toolbar mb-3">
            <div class="field-group">
              <label class="flex align-items-center gap-2">
                <Checkbox v-model="askMailIncludeTables" :binary="true" inputId="askMailTables" />
                <span>Elenca tabelle</span>
              </label>
            </div>
            <div class="field-group">
              <label for="askMailTable">DESCRIBE tabella (opzionale)</label>
              <InputText
                id="askMailTable"
                v-model="askMailTableName"
                placeholder="es. users"
                class="w-full"
              />
            </div>
            <Button
              label="Testa connessione"
              icon="pi pi-database"
              class="p-button-rounded"
              :loading="loadingAskMailCheck"
              @click="testAskMailConnection()"
            />
          </div>

          <Loader v-if="loadingAskMailCheck && !askMailResult" />

          <div
            v-if="askMailResult"
            class="response-box"
            :class="askMailResult.success ? 'response-box--success' : 'response-box--warn'"
          >
            <p class="feedback-message font-semibold m-0 mb-2">
              {{ askMailResult.success ? 'Connessione OK' : 'Connessione fallita' }}
            </p>
            <pre class="ask-mail-result">{{ formatAskMailResult(askMailResult) }}</pre>
          </div>
        </AccordionTab>
        <AccordionTab header="Punti switchati con annullamento APN">
          <div class="controls-row">
            <div class="field-group">
              <label for="apnMonthInput">Mese di caricamento</label>
              <Calendar inputId="apnMonthInput" v-model="apnMonth" view="month" dateFormat="mm/yy" :manualInput="false" showIcon :disabled="loadingApnPoints || processingApn" placeholder="Seleziona mese" />
            </div>
            <div class="field-group">
              <label for="apnTypeInput">Fornitura</label>
              <Dropdown inputId="apnTypeInput" v-model="apnType" :options="apnTypeOptions" optionLabel="label" optionValue="value" :disabled="loadingApnPoints || processingApn" />
            </div>
            <Button label="Cerca" icon="pi pi-search" :loading="loadingApnPoints" :disabled="!apnMonth || processingApn" @click="searchApnPoints" />
          </div>
          <div v-if="apnProcessResult" class="response-box" :class="apnProcessResult.failed ? 'response-box--error' : 'response-box--success'">
            <p>Elaborati: {{ apnProcessResult.processed }} | Saltati: {{ apnProcessResult.skipped }} | Falliti: {{ apnProcessResult.failed }}</p>
            <DataTable :value="apnProcessResult.items" showGridlines paginator :rows="20">
              <Column field="id_pratica_annullamento" header="ID annullamento" />
              <Column header="Esito">
                <template #body="{ data }">{{ { processed: 'Elaborato', skipped: 'Saltato', failed: 'Fallito' }[data.status] }}</template>
              </Column>
              <Column field="message" header="Dettaglio" />
            </DataTable>
          </div>
          <p v-if="apnError" class="feedback-message">{{ apnError }}</p>
          <template v-if="apnSearched">
            <p>Risultati: {{ apnTotal }}. Mese di caricamento: {{ apnQuery.month }}.</p>
            <div v-if="apnPoints.length > 0" class="controls-row mt-3 mb-3">
              <span>Selezionati: {{ selectedApnIds.length }} / 100</span>
              <Button label="Elabora annullamenti selezionati" icon="pi pi-play" :loading="processingApn" :disabled="selectedApnIds.length === 0 || loadingApnPoints || processingApn" @click="processSelectedApn" />
            </div>
            <DataTable :value="apnPoints" :loading="loadingApnPoints || processingApn" lazy paginator :rows="apnRows" :first="apnFirst" :totalRecords="apnTotal" :rowsPerPageOptions="[20, 50, 100]" showGridlines scrollable @page="onApnPage">
              <template #empty>Nessun punto trovato.</template>
              <Column header="Seleziona" style="width: 80px">
                <template #body="{ data }">
                  <Checkbox :modelValue="selectedApnIds.includes(Number(data.id_pratica_annullamento))" binary :disabled="processingApn || loadingApnPoints || (selectedApnIds.length >= 100 && !selectedApnIds.includes(Number(data.id_pratica_annullamento)))" :aria-label="'Seleziona annullamento ' + data.id_pratica_annullamento" @update:modelValue="toggleApnSelection(data.id_pratica_annullamento, $event)" />
                </template>
              </Column>
              <Column field="tipo" header="Tipo" />
              <Column field="supply_id" header="ID punto" />
              <Column field="punto" header="POD / PDR" style="min-width: 180px" />
              <Column field="denominazione_cliente" header="Cliente" style="min-width: 200px" />
              <Column field="matrice_id" header="ID matrice" />
              <Column field="data_caricamento" header="Data caricamento" style="min-width: 170px" />
              <Column field="id_switch" header="ID switch" />
              <Column field="stato_punto" header="Stato punto" />
              <Column field="cod_state_switch" header="Stato switch" />
              <Column field="protocollo" header="Protocollo" style="min-width: 180px" />
              <Column field="id_pratica_annullamento" header="ID annullamento" />
              <Column field="data_annullamento" header="Data annullamento" style="min-width: 170px" />
              <Column field="motivazione" header="Motivazione APN" style="min-width: 300px" />
            </DataTable>
          </template>
        </AccordionTab>
        <AccordionTab v-if="cambioRappresentanteAvailable" header="Recupera documenti d'identità rappresentanti">
          <p>Documenti d'identità presenti nella matrice più recente con stato 6, ma assenti per il rappresentante. Avvia l'allineamento dalla singola riga.</p>
          <Button label="Aggiorna" icon="pi pi-refresh" class="p-button-sm mb-3" :loading="loadingDocumentiIdentitaRappresentanti" :disabled="loadingDocumentiIdentitaRappresentanti || allineamentoDocumentoIdentitaId !== null" @click="aggiornaDocumentiIdentitaRappresentanti" />
          <div v-if="documentiIdentitaRappresentantiError" class="response-box response-box--warn">
            <p class="feedback-message">{{ documentiIdentitaRappresentantiError }}</p>
          </div>
          <template v-if="documentiIdentitaRappresentantiLoaded">
            <div class="response-box response-box--info">
              <p class="feedback-message">
                Documenti da allineare: <strong>{{ documentiIdentitaRappresentanti.total }}</strong>
              </p>
            </div>
            <DataTable :value="documentiIdentitaRappresentanti.items" dataKey="rappresentante_id" lazy paginator :rows="20" :first="documentiIdentitaRappresentantiFirst" :totalRecords="documentiIdentitaRappresentanti.total" :loading="loadingDocumentiIdentitaRappresentanti" showGridlines class="mt-3" @page="onDocumentiIdentitaRappresentantiPage">
              <template #empty>Nessun documento d'identità da allineare.</template>
              <Column field="rappresentante_id" header="ID rappresentante" />
              <Column field="rappresentante" header="Rappresentante" />
              <Column field="matrice_id" header="ID matrice" />
              <Column field="data_caricamento" header="Data caricamento" />
              <Column field="filename" header="Documento matrice" />
              <Column field="file_messaggio" header="File SFTP" />
              <Column header="Allineamento">
                <template #body="{ data }">
                  <span v-tooltip="data.file_messaggio">
                    <Button label="Allinea documento" icon="pi pi-upload" class="p-button-sm p-button-success" :loading="allineamentoDocumentoIdentitaId === data.rappresentante_id" :disabled="!data.file_presente || allineamentoDocumentoIdentitaId !== null" @click="allineaDocumentoIdentitaRappresentante(data)" />
                  </span>
                </template>
              </Column>
            </DataTable>
          </template>
          <Loader v-else-if="loadingDocumentiIdentitaRappresentanti" />
        </AccordionTab>
      </Accordion>
    </div>

    <Dialog
      v-model:visible="showLogContentModal"
      modal
      :header="logDialogTitle"
      class="log-content-dialog"
      :style="{ width: '80vw' }"
      :breakpoints="{ '960px': '95vw', '640px': '100vw' }"
      @hide="stopLogTail"
    >
      <div v-if="selectedLogFilename" class="log-tail-toolbar">
        <div class="log-tail-actions">
          <span class="log-tail-status" :class="{ 'log-tail-status--active': isLogTailActive }">
            {{ isLogTailActive ? 'Tail live attivo' : 'Tail live non attivo' }}
          </span>
          <span v-if="hasUnreadLogTailContent" class="log-tail-new-lines">
            Nuove righe in coda: {{ unreadLogTailCount }}
          </span>
          <Button
            v-if="hasUnreadLogTailContent"
            icon="pi pi-angle-double-down"
            label="Vai in fondo"
            class="p-button-sm p-button-text p-button-info"
            @click="scrollLogContentToBottom"
          />
          <Button
            v-if="isLogTailActive"
            icon="pi pi-stop"
            label="Stop tail"
            class="p-button-sm p-button-text p-button-danger"
            @click="stopLogTail"
          />
          <Button
            v-else
            icon="pi pi-play"
            label="Avvia tail"
            class="p-button-sm p-button-text p-button-success"
            :disabled="loadingLogContent"
            @click="resumeLogTail(selectedLogFilename)"
          />
        </div>
        <div class="log-search-toolbar">
          <span class="p-input-icon-left log-search-input-wrap">
            <i class="pi pi-search" />
            <InputText
              v-model="logSearchQuery"
              class="p-inputtext-sm log-search-input"
              placeholder="Cerca nel log"
              @input="onLogSearchInput"
              @keydown.enter.prevent="navigateLogSearch($event.shiftKey ? -1 : 1)"
              @keydown.esc.prevent="clearLogSearch"
            />
          </span>
          <span class="log-search-count">{{ logSearchStatusLabel }}</span>
          <Button
            icon="pi pi-chevron-up"
            class="p-button-sm p-button-text log-search-button"
            :disabled="logSearchMatches.length === 0"
            @click="navigateLogSearch(-1)"
          />
          <Button
            icon="pi pi-chevron-down"
            class="p-button-sm p-button-text log-search-button"
            :disabled="logSearchMatches.length === 0"
            @click="navigateLogSearch(1)"
          />
          <Button
            icon="pi pi-times"
            class="p-button-sm p-button-text p-button-secondary log-search-button"
            :disabled="!logSearchQuery"
            @click="clearLogSearch"
          />
        </div>
      </div>
      <Loader v-if="loadingLogContent" />
      <div v-else class="log-content-wrap">
        <div v-if="hasUnreadLogTailContent" class="log-read-threshold">
          <span>Soglia lettura nuovi log</span>
        </div>
        <div ref="logContentPre" class="log-content" @scroll="onLogContentScroll">
          <template v-if="logContentLines.length > 0">
            <template v-for="(line, index) in logContentLines" :key="`${index}-${line.length}`">
              <div v-if="shouldShowUnreadMarker(index)" class="log-unread-marker">
                Nuovi log
              </div>
              <div class="log-content-line" :class="getLogLineClass(index)" :data-line-index="index">
                <template
                  v-for="(segment, segmentIndex) in getHighlightedLogLineSegments(line, index)"
                  :key="`${index}-${segmentIndex}-${segment.text.length}`"
                >
                  <mark
                    v-if="segment.match"
                    class="log-search-match"
                    :class="{ 'log-search-match--active': segment.active }"
                  >
                    {{ segment.text }}
                  </mark>
                  <span v-else>{{ segment.text }}</span>
                </template>
              </div>
            </template>
          </template>
          <div v-else class="log-content-line">File vuoto</div>
        </div>
      </div>
    </Dialog>

    <Dialog
      v-model:visible="showAddCategoryTicketModal"
      modal
      header="Aggiungi categoria ticket"
      :style="{ width: '32rem' }"
      :closable="!addingCategoryTicket"
      :dismissableMask="!addingCategoryTicket"
    >
      <div class="field-group">
        <label for="newCategoryTicketMotivation">Motivazione</label>
        <InputText
          id="newCategoryTicketMotivation"
          v-model="newCategoryTicketMotivation"
          class="w-full"
          placeholder="Es. Reclamo fatturazione"
          @keyup.enter="addNewCategoryTicket"
        />
      </div>

      <div class="field-group category-ticket-checkbox">
        <label for="newCategoryTicketCanViewAgente">Visibile ad agente</label>
        <div class="flex align-items-center gap-2">
          <Checkbox
            id="newCategoryTicketCanViewAgente"
            v-model="newCategoryTicketCanViewAgente"
            :binary="true"
          />
          <span>{{ newCategoryTicketCanViewAgente ? 'Sì' : 'No' }}</span>
        </div>
      </div>

      <template #footer>
        <Button
          label="Annulla"
          class="p-button-text"
          :disabled="addingCategoryTicket"
          @click="closeAddCategoryTicketModal"
        />
        <Button
          label="Conferma"
          icon="pi pi-check"
          :loading="addingCategoryTicket"
          :disabled="addingCategoryTicket || !newCategoryTicketMotivation.trim()"
          @click="addNewCategoryTicket"
        />
      </template>
    </Dialog>

    <Dialog
      v-model:visible="showCreateProcesslistPasswordModal"
      modal
      header="Crea Password Lista Processi"
      :style="{ width: '32rem' }"
      :closable="!creatingProcesslistPassword"
      :dismissableMask="!creatingProcesslistPassword"
    >
      <div class="field-group processlist-password-field">
        <label for="processlistPasswordInput">Password</label>
        <input
          id="processlistPasswordInput"
          v-model="processlistPassword"
          type="password"
          class="p-inputtext p-component"
          placeholder="Inserisci password"
          @keyup.enter="createProcesslistPassword"
        />
      </div>

      <template #footer>
        <Button
          label="Annulla"
          class="p-button-text"
          :disabled="creatingProcesslistPassword"
          @click="showCreateProcesslistPasswordModal = false"
        />
        <Button
          label="Salva Password"
          icon="pi pi-check"
          :loading="creatingProcesslistPassword"
          @click="createProcesslistPassword"
        />
      </template>
    </Dialog>

    <Dialog
      v-model:visible="showKillProcessPasswordModal"
      modal
      header="Conferma kill processo"
      :style="{ width: '32rem' }"
      :closable="!confirmingKillWithPassword"
      :dismissableMask="!confirmingKillWithPassword"
    >
      <p class="feedback-message">
        Inserisci la password per confermare il kill di
        <strong>{{ pendingKillProcessIds.length }}</strong>
        {{ pendingKillProcessIds.length === 1 ? 'processo' : 'processi' }}.
      </p>

      <div class="field-group processlist-password-field">
        <label for="killProcessPasswordInput">Password</label>
        <input
          id="killProcessPasswordInput"
          v-model="killProcessPassword"
          type="password"
          class="p-inputtext p-component"
          placeholder="Inserisci password"
          @keyup.enter="confirmKillProcessesByPassword"
        />
      </div>

      <template #footer>
        <Button
          label="Annulla"
          class="p-button-text"
          :disabled="confirmingKillWithPassword"
          @click="showKillProcessPasswordModal = false"
        />
        <Button
          label="Conferma kill"
          icon="pi pi-check"
          class="p-button-danger"
          :loading="confirmingKillWithPassword"
          @click="confirmKillProcessesByPassword"
        />
      </template>
    </Dialog>
  </div>
</template>

<script>
import PanelAdminService from '@/services/ask-admin/panel-admin'
import CambioRappresentanteService from '@/services/ask-pratiche/cambio-rappresentante'
import PreavvisiFattureClientiService from '@/services/ask-management/preavvisi-fatture-clienti-service'
import AskMailService from '@/services/ask-management/ask-mail-service'
import Loader from "@/components/Loader.vue";
import { useToast } from "primevue/usetoast";

export default {
  name: 'PannelloFunzionalita',
  components: {
    Loader
  },
  data() {
    return {
      apnMonth: new Date(new Intl.DateTimeFormat('sv-SE', { timeZone: 'Europe/Rome', year: 'numeric', month: '2-digit' }).format(new Date()) + '-01T12:00:00'),
      apnType: 'all',
      apnTypeOptions: [
        { label: 'Tutte', value: 'all' },
        { label: 'Energia', value: 'ee' },
        { label: 'Gas', value: 'gas' },
      ],
      selectedApnIds: [],
      processingApn: false,
      apnProcessResult: null,
      apnPoints: [],
      apnTotal: 0,
      apnRows: 20,
      apnFirst: 0,
      apnSearched: false,
      loadingApnPoints: false,
      apnError: '',
      apnQuery: null,
      loader: false,
      service: null,
      cambioRappresentanteAvailable: false,
      loadingDocumentiIdentitaRappresentanti: false,
      documentiIdentitaRappresentantiLoaded: false,
      documentiIdentitaRappresentanti: { total: 0, items: [] },
      documentiIdentitaRappresentantiFirst: 0,
      allineamentoDocumentoIdentitaId: null,
      documentiIdentitaRappresentantiError: '',
      idMatrice: '',
      loading: false,
      loadingConfirm: false,
      responseData: null,
      userFeedback: null,
      processlistItems: [],
      selectedProcessIds: [],
      showConfirmButton: false,
      isRiportaSectionOpen: false,
      canSearchNextValidation: null,
      loadingProcesslist: false,
      hasProcesslistPassword: false,
      checkingProcesslistPassword: false,
      showCreateProcesslistPasswordModal: false,
      creatingProcesslistPassword: false,
      processlistPassword: '',
      showKillProcessPasswordModal: false,
      killProcessPassword: '',
      confirmingKillWithPassword: false,
      pendingKillProcessIds: [],
      killingSelected: false,
      killingProcessIds: [],
      agyoStartDate: '',
      agyoEndDate: '',
      loadingExportNumeriFatturaAgyo: false,
      toast: useToast(),
      comuniRemi: [],
      selectedComune: null,
      newSdiCode: '',
      loadingAddSdi: false,
      idsMatriceDaAllineare: '',
      idMatriceToReset: null,
      storicoCaricamento: null,
      canDetachSignature: false,
      signatureToDetach: null,
      columnStoricoCaricamento: [],
      pp_without_ctr: {
        exist: false,
        data: []
      },
      validazioni_prenotate: {
        exist: false,
        data: [],
        columns: [],
        reset(){
          this.exist = false
          this.data = []
          this.columns = []
        }
      },
      categoryTicketItems: [],
      selectedCategoryTicketItems: [],
      showAddCategoryTicketModal: false,
      loadingCategoryTicket: false,
      addingCategoryTicket: false,
      deletingCategoryTicket: false,
      newCategoryTicketMotivation: '',
      newCategoryTicketCanViewAgente: false,
      loadingCheckExistReport: false,
      showCheckExistReportSearch: false,
      checkExistReportFilters: { agentIds: [], from: null, to: null },
      checkExistReportAgents: [],
      loadingCheckExistReportAgents: false,
      checkExistReport: null,
      checkExistOutcome: '',
      loadingCreateContratti: false,
      loadingCreateContrattiCount: false,
      createContrattiCounts: {
        total: 0,
        pod: 0,
        pdr: 0,
      },
      loadingLogs: false,
      loadingLogContent: false,
      selectedLogType: null,
      selectedLogProject: 'ask_pratiche',
      selectedLogFileProject: 'ask_pratiche',
      selectedLogFilename: null,
      selectedLogContent: '',
      showLogContentModal: false,
      logSearchQuery: '',
      logSearchActiveMatchIndex: -1,
      logGlobalSearchQuery: '',
      logGlobalSearchLastQuery: '',
      logGlobalSearchResults: [],
      logGlobalSearchErrorCount: 0,
      logGlobalSearchCompletedTypes: 0,
      logGlobalSearchTotalTypes: 0,
      logGlobalSearchSearchedTypes: [],
      logGlobalSearchRunId: 0,
      loadingLogGlobalSearch: false,
      logFiles: [],
      logTypes: [],
      loadingLogTypes: false,
      loadingLogTail: false,
      isLogTailActive: false,
      logTailOffset: null,
      logTailTimer: null,
      logTailPollMs: 2000,
      logTailAutoStopTimer: null,
      logTailAutoStopMs: 15 * 60 * 1000,
      markNextLogTailContentAsUnread: false,
      isLogPinnedToBottom: true,
      hasUnreadLogTailContent: false,
      unreadLogTailStartLine: null,
      readLogTailUntilLine: null,
      loadingMatriciIndexClienteIdMancante: false,
      matriciIndexClienteIdMancanteLoaded: false,
      updatingMatriciIndexClienteId: false,
      updatingRecoveredSupplyClienteIds: {},
      matriciIndexClienteIdMancanteSelections: {},
      matriciIndexClienteIdMancante: {
        total: 0,
        items: [],
      },
      loadingMatriciIndexRappresentanteIdMancante: false,
      matriciIndexRappresentanteIdMancanteLoaded: false,
      updatingMatriciIndexRappresentanteId: false,
      matriciIndexRappresentanteIdMancanteSelections: {},
      matriciIndexRappresentanteIdMancante: {
        total: 0,
        items: [],
      },
      loadingCaricamentiMatriceIndexStoricoDuplicatoStato2: false,
      caricamentiMatriceIndexStoricoDuplicatoStato2Loaded: false,
      caricamentiMatriceIndexStoricoDuplicatoStato2: {
        total: 0,
        items: [],
        columns: [],
      },
      deletingMatriceIndexStoricoIds: {},
      numeriFatturaPoste: '',
      loadingFatturePoste: false,
      fatturePosteReport: [],
      fatturePosteErrors: [],
      loadingFattureNonInviateDaProcessare: false,
      fattureNonInviateDaProcessareLoaded: false,
      fattureNonInviateDaProcessare: {
        total: 0,
        items: [],
        columns: [],
      },
      loadingFilePraticheDaRecuperare: false,
      updatingFilePraticheDaRecuperare: false,
      filePraticheDaRecuperareLoaded: false,
      calendarMaxMonth: new Date(new Date().getFullYear(), new Date().getMonth(), 1),
      filePraticheMonth: null,
      filePraticheLoadedMonth: null,
      filePraticheLoadedWithoutLimit: false,
      filePraticheWithoutLimit: false,
      selectedFilePraticheDaRecuperare: [],
      filePraticheDaRecuperare: {
        total: 0,
        items: [],
        columns: [],
      },
      payloadIdMonth: null,
      loadingPayloadIdCaricamenti: false,
      updatingPayloadIdCaricamenti: false,
      payloadIdCaricamentiLoaded: false,
      payloadIdLoadedMonth: null,
      payloadIdLoadedWithoutLimit: false,
      payloadIdWithoutLimit: false,
      payloadIdUpdateChunkSize: 20,
      selectedPayloadIdCaricamenti: [],
      maxSelectedPayloadIdCaricamenti: 20,
      payloadIdCaricamenti: {
        total: null,
        items: [],
        columns: [],
      },
      switchDateLogMonth: null,
      loadingSwitchDateLogRetroattivi: false,
      creatingSwitchDateLogRetroattivi: false,
      switchDateLogRetroattiviLoaded: false,
      switchDateLogLoadedMonth: null,
      switchDateLogLoadedWithoutLimit: false,
      switchDateLogWithoutLimit: false,
      switchDateLogUpdateChunkSize: 20,
      selectedSwitchDateLogRetroattivi: [],
      maxSelectedSwitchDateLogRetroattivi: 20,
      switchDateLogRetroattivi: {
        total: null,
        items: [],
        columns: [],
      },
      matriciSenzaSwitchMonth: null,
      loadingMatriciSenzaSwitch: false,
      creatingMatriciSwitchMancanti: false,
      selectedMatriciSenzaSwitch: [],
      matriciSenzaSwitchLoaded: false,
      matriciSenzaSwitchLoadedMonth: null,
      matriciSenzaSwitchLoadedWithoutLimit: false,
      matriciSenzaSwitchWithoutLimit: false,
      matriciSenzaSwitch: {
        total: null,
        items: [],
        columns: [],
      },
      loadingExternalNews: false,
      savingExternalNews: false,
      externalNewsItems: [],
      externalNewsEditingId: null,
      externalNewsDeletingIds: {},
      externalNewsTogglingIds: {},
      externalNewsForm: {
        title: '',
        image: '',
        description: '',
        external_link: '',
        visible: true,
      },
      forzaScissionePkIds: '',
      loadingForzaScissionePk: false,
      loadingCronForzaScissionePk: false,
      forzaScissionePkFeedback: null,
      preavvisiService: null,
      loadingLogErrorPreavvisi: false,
      loadingLogErrorPreavvisiPec: false,
      loadingLogErrorPreavvisiEmail: false,
      logErrorPreavvisiLoaded: false,
      logErrorPreavvisiTipoFilter: 'all',
      logErrorPreavvisiTipoOptions: [
        { label: 'Tutti', value: 'all' },
        { label: 'PEC', value: 'pec' },
        { label: 'Email', value: 'email' },
      ],
      logErrorPreavvisi: {
        pec: {
          items: [],
          total: 0,
          current_page: 1,
          last_page: 1,
          per_page: 20,
        },
        email: {
          items: [],
          total: 0,
          current_page: 1,
          last_page: 1,
          per_page: 20,
        },
      },
      askMailService: null,
      loadingAskMailCheck: false,
      askMailIncludeTables: false,
      askMailTableName: '',
      askMailResult: null,
    }
  },
  created() {
    this.service = new PanelAdminService(this.$http, this.$eventBus)
    this.loadCambioRappresentanteAvailability()
    this.preavvisiService = new PreavvisiFattureClientiService(this.$http, this.$eventBus)
    this.askMailService = new AskMailService(this.$http, this.$eventBus)
    this.logTypes = this.getDefaultLogTypes()
    this.checkProcesslistPasswordStatus()
    this.loadCreateContrattiCount()
    this.loadExternalNews()
  },
  beforeUnmount() {
    this.stopLogTail()
  },
  computed: {
    checkExistSummaryRows() {
      return (this.checkExistReport?.agenti || []).flatMap(agent => Object.entries(agent.rotte || {}).map(([route, stats]) => ({
        ...stats, agente: (agent.nome || 'Agente') + ' (#' + agent.agente_id + ')',
        rotta: route === 'check-exist-client' ? 'Cliente' : 'Rappresentante',
        caricamenti: agent.caricamenti, rapporto: agent.chiamate_per_caricamento ?? '—'
      })))
    },
    checkExistDetailRows() {
      const outcomes = [
        ['con_caricamento', 'Caricamento successivo', 'caricamento_successivo', 'dopo'],
        ['con_caricamento_precedente', 'Solo caricamento precedente', 'caricamento_precedente', 'prima'],
        ['senza_caricamento', 'Nessun caricamento associato'],
        ['non_verificabili', 'Non verificabile']
      ]
      return (this.checkExistReport?.agenti || []).flatMap(agent => Object.entries(agent.rotte || {}).flatMap(([route, stats]) =>
        outcomes.flatMap(([key, esito, uploadKey, direction]) => (stats[key] || []).map(detail => {
          const upload = detail[uploadKey]
          return { ...detail, agente: (agent.nome || 'Agente') + ' (#' + agent.agente_id + ')',
            rotta: route === 'check-exist-client' ? 'Cliente' : 'Rappresentante', esito,
            cf: detail.ricerca?.cf || '—', piva: detail.ricerca?.piva || '—',
            caricamento_id: upload?.id ?? '—', caricamento_ora: upload?.ora || '—',
            tempo: upload ? upload.tempo_trascorso + ' ' + direction : '—' }
        }))
      )).filter(row => !this.checkExistOutcome || row.esito === this.checkExistOutcome)
        .sort((a, b) => b.ora.localeCompare(a.ora) || b.log_id - a.log_id)
    },
    responseItems() {
      return this.getResponseItems(this.responseData?.data)
    },
    logDialogTitle() {
      if (!this.selectedLogFilename) return 'Log'

      return this.isLogTailActive
        ? `${this.selectedLogFilename} - LIVE`
        : this.selectedLogFilename
    },
    logErrorPreavvisiTotal() {
      return Number(this.logErrorPreavvisi?.pec?.total || 0) + Number(this.logErrorPreavvisi?.email?.total || 0)
    },
    showLogErrorPreavvisiPec() {
      return this.logErrorPreavvisiTipoFilter === 'all' || this.logErrorPreavvisiTipoFilter === 'pec'
    },
    showLogErrorPreavvisiEmail() {
      return this.logErrorPreavvisiTipoFilter === 'all' || this.logErrorPreavvisiTipoFilter === 'email'
    },
    logErrorPreavvisiVisibleTotal() {
      if (this.logErrorPreavvisiTipoFilter === 'pec') {
        return Number(this.logErrorPreavvisi?.pec?.total || 0)
      }
      if (this.logErrorPreavvisiTipoFilter === 'email') {
        return Number(this.logErrorPreavvisi?.email?.total || 0)
      }
      return this.logErrorPreavvisiTotal
    },
    logErrorPreavvisiEmptyMessage() {
      if (this.logErrorPreavvisiTipoFilter === 'pec') return 'Nessun errore PEC registrato'
      if (this.logErrorPreavvisiTipoFilter === 'email') return 'Nessun errore Email registrato'
      return 'Nessun errore di invio preavvisi registrato'
    },
    logErrorPreavvisiPecFirst() {
      return (Number(this.logErrorPreavvisi.pec.current_page || 1) - 1) * Number(this.logErrorPreavvisi.pec.per_page || 20)
    },
    logErrorPreavvisiEmailFirst() {
      return (Number(this.logErrorPreavvisi.email.current_page || 1) - 1) * Number(this.logErrorPreavvisi.email.per_page || 20)
    },
    logContentLines() {
      if (!this.selectedLogContent) return []

      return String(this.selectedLogContent).split(/\r\n|\n|\r/)
    },
    logSearchMatches() {
      const query = String(this.logSearchQuery || '')
      if (!query) return []

      const needle = query.toLocaleLowerCase()
      const matches = []

      this.logContentLines.forEach((line, lineIndex) => {
        const haystack = String(line || '')
        const normalizedHaystack = haystack.toLocaleLowerCase()
        let matchIndex = normalizedHaystack.indexOf(needle)

        while (matchIndex !== -1) {
          matches.push({
            lineIndex,
            start: matchIndex,
            end: matchIndex + query.length,
            matchIndex: matches.length,
          })

          matchIndex = normalizedHaystack.indexOf(needle, matchIndex + Math.max(query.length, 1))
        }
      })

      return matches
    },
    logSearchMatchesByLine() {
      const matchesByLine = new Map()

      this.logSearchMatches.forEach((match) => {
        const lineMatches = matchesByLine.get(match.lineIndex) || []
        lineMatches.push(match)
        matchesByLine.set(match.lineIndex, lineMatches)
      })

      return matchesByLine
    },
    activeLogSearchMatch() {
      if (this.logSearchActiveMatchIndex < 0) return null

      return this.logSearchMatches[this.logSearchActiveMatchIndex] || null
    },
    logSearchStatusLabel() {
      if (!this.logSearchQuery) return '0 / 0'
      if (this.logSearchMatches.length === 0) return '0 / 0'

      const current = this.activeLogSearchMatch
        ? this.logSearchActiveMatchIndex + 1
        : 0

      return `${current} / ${this.logSearchMatches.length}`
    },
    normalizedLogGlobalSearchQuery() {
      return String(this.logGlobalSearchQuery || '').trim()
    },
    isLogGlobalSearchQueryValid() {
      return Array.from(this.normalizedLogGlobalSearchQuery).length >= 3
    },
    canSearchAllLogTypes() {
      return Boolean(
        this.logTypes.length > 0
        && !this.loadingLogs
        && !this.loadingLogGlobalSearch
        && this.isLogGlobalSearchQueryValid
      )
    },
    logGlobalSearchStatusLabel() {
      if (this.logTypes.length === 0) return 'Nessun tipo log disponibile'
      if (this.loadingLogs) return 'Caricamento file log...'
      if (this.normalizedLogGlobalSearchQuery && !this.isLogGlobalSearchQueryValid) {
        return 'Minimo 3 caratteri'
      }
      if (this.loadingLogGlobalSearch) {
        return `Ricerca: ${this.logGlobalSearchCompletedTypes}/${this.logGlobalSearchTotalTypes} tipi, ${this.logGlobalSearchResults.length} file trovati`
      }
      if (this.logGlobalSearchLastQuery) {
        const totalMatches = this.logGlobalSearchResults.reduce((total, item) => {
          return total + Number(item.match_count || 0)
        }, 0)
        const errorLabel = this.logGlobalSearchErrorCount > 0
          ? `, errori: ${this.logGlobalSearchErrorCount}`
          : ''

        return `${this.logGlobalSearchResults.length} file, ${totalMatches} occorrenze${errorLabel}`
      }

      return `${this.logTypes.length} tipi log disponibili`
    },
    unreadLogTailCount() {
      if (this.unreadLogTailStartLine === null) return 0

      const firstUnreadLine = Math.max(
        this.unreadLogTailStartLine,
        Number.isFinite(Number(this.readLogTailUntilLine)) ? Number(this.readLogTailUntilLine) + 1 : this.unreadLogTailStartLine
      )

      return Math.max(this.logContentLines.length - firstUnreadLine, 0)
    },
    hasCheckItems() {
      return this.responseItems.length > 0
    },
    processableItems() {
      return this.responseItems.filter(item => item.can_process === true)
    },
    nonProcessableItems() {
      return this.responseItems.filter(item => item.can_process !== true)
    },
    processlistValidIds() {
      return this.processlistItems
        .map(item => Number(item?.Id))
        .filter(id => Number.isInteger(id) && id > 0)
    },
    allProcessesSelected() {
      return this.processlistValidIds.length > 0 && this.selectedProcessIds.length === this.processlistValidIds.length
    },
    canKillSelected() {
      return this.selectedProcessIds.length > 0
    },
    selectedMatriciIndexClienteIdMancanteRows() {
      return Object.values(this.matriciIndexClienteIdMancanteSelections)
        .flatMap(items => Array.isArray(items) ? items : [])
    },
    matriciIndexClienteIdMancantePayload() {
      const itemsByMatrice = new Map()

      this.selectedMatriciIndexClienteIdMancanteRows.forEach(row => {
        const clienteId = this.getClienteIdsForMissingClientRow(row)

        if (row?.id && clienteId) {
          itemsByMatrice.set(Number(row.id), {
            matrice_id: Number(row.id),
            cliente_id: clienteId,
          })
        }
      })

      return Array.from(itemsByMatrice.values())
    },
    selectedMatriciIndexRappresentanteIdMancanteRows() {
      return Object.values(this.matriciIndexRappresentanteIdMancanteSelections)
        .flatMap(items => Array.isArray(items) ? items : [])
    },
    matriciIndexRappresentanteIdMancantePayload() {
      const itemsByMatrice = new Map()

      this.selectedMatriciIndexRappresentanteIdMancanteRows.forEach(row => {
        if (row?.id && this.isPositiveIntegerValue(row?.id_recuperato)) {
          itemsByMatrice.set(Number(row.id), {
            matrice_id: Number(row.id),
            rappresentante_id: Number(row.id_recuperato),
          })
        }
      })

      return Array.from(itemsByMatrice.values())
    },
    matriceIndexStoricoDuplicatoStoricoColumns() {
      const firstRow = this.caricamentiMatriceIndexStoricoDuplicatoStato2.items
        .flatMap(item => Array.isArray(item?.storico) ? item.storico : [])
        .find(row => row && typeof row === 'object')

      if (!firstRow) return []

      return Object.keys(firstRow)
        .filter(field => field !== 'can_delete_from_duplicate_stato_2')
        .map(field => ({
          field,
          label: this.humanizeColumnLabel(field),
        }))
    },
    fattureNonInviateDaProcessareGroups() {
      const items = Array.isArray(this.fattureNonInviateDaProcessare.items)
        ? this.fattureNonInviateDaProcessare.items
        : []

      if (items.length === 0) return []

      const alreadyGrouped = items.every(item => (
        Array.isArray(item?.fatture) ||
        Array.isArray(item?.rows) ||
        Array.isArray(item?.items)
      ))

      if (alreadyGrouped) {
        const groups = items.map((item, index) => {
          const rows = Array.isArray(item?.fatture)
            ? item.fatture
            : Array.isArray(item?.rows)
              ? item.rows
              : Array.isArray(item?.items)
                ? item.items
                : []

          return {
            key: this.getFatturaNonInviataAgentKey(item, index),
            label: this.getFatturaNonInviataAgentLabel(item),
            count: Number(item?.count || rows.length || 0),
            rows,
          }
        })

        return this.sortFattureNonInviateGroups(groups)
      }

      const groups = new Map()

      items.forEach((row) => {
        const key = this.getFatturaNonInviataAgentKey(row)

        if (!groups.has(key)) {
          groups.set(key, {
            key,
            label: this.getFatturaNonInviataAgentLabel(row),
            count: 0,
            rows: [],
          })
        }

        const group = groups.get(key)
        group.rows.push(row)
        group.count = group.rows.length
      })

      return this.sortFattureNonInviateGroups(Array.from(groups.values()))
    },
    fattureNonInviateDaProcessareColumns() {
      const columns = Array.isArray(this.fattureNonInviateDaProcessare.columns)
        ? this.fattureNonInviateDaProcessare.columns
        : []

      if (columns.length > 0) {
        return columns
          .map(col => ({
            field: col.field || col.key || col.name,
            label: col.label || col.header || col.field || col.key || col.name,
          }))
          .filter(col => col.field)
      }

      const firstRow = this.fattureNonInviateDaProcessareGroups
        .flatMap(group => group.rows)
        .find(row => row && typeof row === 'object')

      if (!firstRow) return []

      return Object.keys(firstRow).map(field => ({
        field,
        label: this.humanizeColumnLabel(field),
      }))
    },
    filePraticheDaRecuperareColumns() {
      const columns = Array.isArray(this.filePraticheDaRecuperare.columns)
        ? this.filePraticheDaRecuperare.columns
        : []

      if (columns.length > 0) {
        return columns
          .map(col => ({
            field: col.field || col.key || col.name,
            label: col.label || col.header || col.field || col.key || col.name,
          }))
          .filter(col => col.field)
      }

      const firstRow = Array.isArray(this.filePraticheDaRecuperare.items)
        ? this.filePraticheDaRecuperare.items.find(row => row && typeof row === 'object')
        : null

      if (!firstRow) return []

      return Object.keys(firstRow).map(field => ({
        field,
        label: this.humanizeColumnLabel(field),
      }))
    },
    filePraticheLoadedMonthLabel() {
      if (!this.filePraticheLoadedMonth) return 'il mese selezionato'

      const [year, month] = String(this.filePraticheLoadedMonth).split('-')
      if (!year || !month) return this.filePraticheLoadedMonth

      return `${month}/${year}`
    },
    payloadIdLoadedMonthLabel() {
      if (!this.payloadIdLoadedMonth) return 'il mese selezionato'

      const [year, month] = String(this.payloadIdLoadedMonth).split('-')
      if (!year || !month) return this.payloadIdLoadedMonth

      return `${month}/${year}`
    },
    payloadIdSelectionLabel() {
      if (this.payloadIdLoadedWithoutLimit) return String(this.selectedPayloadIdCaricamenti.length)

      return `${this.selectedPayloadIdCaricamenti.length} / ${this.maxSelectedPayloadIdCaricamenti}`
    },
    switchDateLogLoadedMonthLabel() {
      if (!this.switchDateLogLoadedMonth) return 'il mese selezionato'

      const [year, month] = String(this.switchDateLogLoadedMonth).split('-')
      if (!year || !month) return this.switchDateLogLoadedMonth

      return `${month}/${year}`
    },
    switchDateLogSelectionLabel() {
      if (this.switchDateLogLoadedWithoutLimit) return String(this.selectedSwitchDateLogRetroattivi.length)

      return `${this.selectedSwitchDateLogRetroattivi.length} / ${this.maxSelectedSwitchDateLogRetroattivi}`
    },
    matriciSenzaSwitchLoadedMonthLabel() {
      if (!this.matriciSenzaSwitchLoadedMonth) return 'il mese selezionato'

      if (String(this.matriciSenzaSwitchLoadedMonth).includes('/')) {
        return this.matriciSenzaSwitchLoadedMonth
      }

      const [year, month] = String(this.matriciSenzaSwitchLoadedMonth).split('-')
      if (!year || !month) return this.matriciSenzaSwitchLoadedMonth

      return `${month}/${year}`
    },
    payloadIdCaricamentiColumns() {
      const columns = Array.isArray(this.payloadIdCaricamenti.columns)
        ? this.payloadIdCaricamenti.columns
        : []

      if (columns.length > 0) {
        return columns
          .map(col => ({
            field: col.field || col.key || col.name,
            label: col.label || col.header || col.field || col.key || col.name,
          }))
          .filter(col => col.field)
      }

      const firstRow = Array.isArray(this.payloadIdCaricamenti.items)
        ? this.payloadIdCaricamenti.items.find(row => row && typeof row === 'object')
        : null

      if (!firstRow) return []

      return Object.keys(firstRow).map(field => ({
        field,
        label: this.humanizeColumnLabel(field),
      }))
    },
    switchDateLogRetroattiviColumns() {
      const hiddenFields = ['data_prev', 'data_next', 'selezionabile', 'reason', 'log_esistente_id']
      const columns = Array.isArray(this.switchDateLogRetroattivi.columns)
        ? this.switchDateLogRetroattivi.columns
        : []

      if (columns.length > 0) {
        return columns
          .map(col => ({
            field: col.field || col.key || col.name,
            label: col.label || col.header || col.field || col.key || col.name,
          }))
          .filter(col => col.field && !hiddenFields.includes(col.field))
      }

      const firstRow = Array.isArray(this.switchDateLogRetroattivi.items)
        ? this.switchDateLogRetroattivi.items.find(row => row && typeof row === 'object')
        : null

      if (!firstRow) return []

      return Object.keys(firstRow)
        .filter(field => !hiddenFields.includes(field))
        .map(field => ({
          field,
          label: this.humanizeColumnLabel(field),
        }))
    },
    matriciSenzaSwitchColumns() {
      const fallbackColumns = [
        { field: 'tipo', label: 'Tipo' },
        { field: 'id', label: 'ID' },
        { field: 'id_switch', label: 'id_switch' },
        { field: 'matrice_id', label: 'matrice_id' },
        { field: 'pod', label: 'POD' },
        { field: 'pdr', label: 'PDR' },
        { field: 'data_caricamento', label: 'data_caricamento' },
        { field: 'precheck', label: 'precheck' },
        { field: 'caricato', label: 'caricato' },
        { field: 'cod_stato_caricamento', label: 'cod_stato_caricamento' },
        { field: 'cod_state_switch', label: 'cod_state_switch' },
        { field: 'active', label: 'active' },
        { field: 'timoe_ok', label: 'timoe_ok' },
        { field: 'timg_ok', label: 'timg_ok' },
        { field: 'suggerimento_insert_switch', label: 'suggerimento_insert_switch' },
        { field: 'suggerimento_errore', label: 'suggerimento_errore' },
      ]
      const columns = Array.isArray(this.matriciSenzaSwitch.columns)
        ? this.matriciSenzaSwitch.columns
        : []

      if (columns.length > 0) {
        return columns
          .map(col => ({
            field: col.field || col.key || col.name,
            label: col.label || col.header || col.field || col.key || col.name,
          }))
          .filter(col => col.field)
      }

      return fallbackColumns
    },
    selectedMatriciSenzaSwitchCodState2Items() {
      return Array.isArray(this.selectedMatriciSenzaSwitch)
        ? this.selectedMatriciSenzaSwitch.filter(item => this.isMatriciSenzaSwitchSelectable(item))
        : []
    }
  },
  methods: {
    async loadCambioRappresentanteAvailability() {
      try {
        this.cambioRappresentanteAvailable = await new CambioRappresentanteService(this.$http).isAvailable()
      } catch (error) {
        this.cambioRappresentanteAvailable = false
      }
    },
    toggleApnSelection(id, selected) {
      const annullamentoId = Number(id)
      if (selected) {
        if (!this.selectedApnIds.includes(annullamentoId) && this.selectedApnIds.length < 100) this.selectedApnIds.push(annullamentoId)
      } else {
        this.selectedApnIds = this.selectedApnIds.filter(value => value !== annullamentoId)
      }
    },
    async processSelectedApn() {
      if (!this.selectedApnIds.length || this.processingApn || this.loadingApnPoints) return
      this.processingApn = true
      this.apnError = ''
      this.apnProcessResult = null
      try {
        this.apnProcessResult = await this.service.processAnnullamentiApnSelezionati([...this.selectedApnIds])
        this.selectedApnIds = []
        this.apnFirst = 0
        await this.loadApnPoints()
      } catch (error) {
        this.apnError = error?.response?.data?.message || 'Impossibile elaborare gli annullamenti selezionati.'
      } finally {
        this.processingApn = false
      }
    },
    async searchApnPoints() {
      if (this.processingApn || this.loadingApnPoints) return
      this.selectedApnIds = []
      this.apnProcessResult = null
      if (!(this.apnMonth instanceof Date) || Number.isNaN(this.apnMonth.getTime())) return
      const month = `${this.apnMonth.getFullYear()}-${String(this.apnMonth.getMonth() + 1).padStart(2, '0')}`
      this.apnQuery = { month, type: this.apnType === 'all' ? null : this.apnType }
      this.apnFirst = 0
      this.apnPoints = []
      this.apnTotal = 0
      this.apnSearched = true
      await this.loadApnPoints()
    },
    async onApnPage(event) {
      if (this.loadingApnPoints || this.processingApn) return
      this.apnFirst = event.first
      this.apnRows = event.rows
      await this.loadApnPoints()
    },
    async loadApnPoints() {
      this.loadingApnPoints = true
      this.apnError = ''
      try {
        const result = await this.service.getPuntiSwitchatiConApnByMonth({
          ...this.apnQuery, page: Math.floor(this.apnFirst / this.apnRows) + 1, per_page: this.apnRows,
        })
        this.apnPoints = result.data || []
        this.apnTotal = Number(result.total || 0)
      } catch (error) {
        this.apnPoints = []
        this.apnError = error?.response?.data?.message || 'Impossibile recuperare i punti con annullamento APN.'
      } finally {
        this.loadingApnPoints = false
      }
    },

    getDefaultLogTypes() {
      return [
        { type: 'esign_performance', label: 'Tempi firma OTP', project: 'ask_flussi' },
        { type: 'mail', label: 'Mail' },
        { type: 'accettazioni', label: 'Accettazioni' },
        { type: 'caricamento_contratti', label: 'Caricamento contratti' },
        { type: 'aggiornamento_stato_caricamenti', label: 'Aggiornamento stato caricamenti' },
        { type: 'aggiornamento_righe_matrice', label: 'Aggiornamento righe matrice' },
        { type: 'precheck', label: 'Precheck' },
        { type: 'switch', label: 'Switch' },
        { type: 'apn_annullamento_switch', label: 'APN annullamento switch' },
        { type: 'movimento_ignoto', label: 'Movimenti ignoti' },
      ].map(log => ({...log, project: log.project || 'ask_pratiche', base_name: log.type}))
    },
    normalizeLogTypes(payload) {
      const items = Array.isArray(payload)
        ? payload
        : Array.isArray(payload?.items)
          ? payload.items
          : Array.isArray(payload?.data)
            ? payload.data
            : []

      return items
        .map(item => ({
          type: String(item?.type || '').trim(),
          project: item?.project || 'ask_pratiche',
          base_name: item?.base_name || item?.type || '',
          label: String(item?.label || item?.type || '').trim()
        }))
        .filter(item => item.type && item.label)
    },
    async loadLogTypes() {
      if (this.loadingLogTypes) return
      this.loadingLogTypes = true
      try {
        await this.service.getLogTypes(result => {
          this.logTypes = [
            ...this.logTypes.filter(logType => logType.project !== result.project),
            ...this.normalizeLogTypes(result)
          ]
          if (result.unavailable) this.toast.add({
            severity: 'warn', summary: 'Log parzialmente disponibili',
            detail: 'Non raggiungibile: ' + result.project, life: 5000
          })
        })
      } catch (err) {
        this.logTypes = this.getDefaultLogTypes()
      } finally {
        this.loadingLogTypes = false
      }
    },
    normalizeIdMatriceInput() {
      const raw = String(this.idMatrice ?? '')
      const tokens = raw
        .split(',')
        .map(token => token.trim())
        .filter(Boolean)

      if (tokens.length === 0) {
        return { valid: false, value: '', ids: [] }
      }

      const allNumeric = tokens.every(token => /^\d+$/.test(token) && Number(token) > 0)
      if (!allNumeric) {
        return { valid: false, value: '', ids: [] }
      }

      const ids = [...new Set(tokens.map(token => String(Number(token))))]
      return {
        valid: true,
        ids,
        value: ids.join(',')
      }
    },
    getInputDetailsLabel() {
      const normalized = this.normalizeIdMatriceInput()
      return normalized.valid ? normalized.value : String(this.idMatrice ?? '')
    },
    getResponseItems(data) {
      if (Array.isArray(data?.items)) return data.items
      if (data && (data.id_matrice != null || data.can_process != null)) return [data]
      return []
    },
    buildFriendlyFeedback(payload, isError = false) {
      const metaStatusCode = payload?.meta?.status?.code
      const metaStatusMessage = payload?.meta?.status?.message
      const data = payload?.data || {}
      const canProcess = data?.can_process
      const executed = data?.executed
      const reason = data?.reason || payload?.meta?.message || metaStatusMessage || ''
      const items = this.getResponseItems(data)

      if (!isError && items.length > 0) {
        const processableCount = items.filter(item => item.can_process === true).length
        const executedCount = items.filter(item => item.executed === true).length
        const processableItems = items.filter(item => item.can_process === true)
        const notProcessable = items.filter(item => item.can_process !== true)
        const details = [
          `Totale matrici: ${items.length}`,
          `Matrici processabili: ${processableCount}`
        ]

        if (data?.executed === true) {
          details.push(`Matrici confermate: ${executedCount}`)
        }

        if (processableItems.length > 0) {
          details.push('--- Matrici che passano il controllo ---')
          processableItems.forEach(item => {
            details.push(`ID ${item.id_matrice}: OK, pronta per conferma`)
          })
        }

        if (notProcessable.length > 0) {
          details.push('--- Matrici che NON passano il controllo ---')
          notProcessable.forEach(item => {
            details.push(`ID ${item.id_matrice}: ${item.reason || 'Non processabile'}`)
          })
        }

        if (items.length === 1) {
          const single = items[0]
          if (single.can_process === true && single.executed === false) {
            if (single?.would_change?.update_matrice_index != null) {
              details.push(`Righe matrice_index da aggiornare: ${single.would_change.update_matrice_index}`)
            }
            if (single?.would_change?.update_matrice_ee != null) {
              details.push(`Righe matrice_ee da aggiornare: ${single.would_change.update_matrice_ee}`)
            }
            if (single?.would_change?.update_matrice_gas != null) {
              details.push(`Righe matrice_gas da aggiornare: ${single.would_change.update_matrice_gas}`)
            }
            if (single?.would_change?.delete_matrice_index_storico != null) {
              details.push(`Righe storico da eliminare: ${single.would_change.delete_matrice_index_storico}`)
            }

            return {
              severity: 'success',
              title: 'Controllo completato',
              message: 'Operazione valida: la matrice puo essere riportata in validazione.',
              details
            }
          }

          if (single.can_process === true && single.executed === true) {
            if (single?.changed?.update_matrice_index != null) {
              details.push(`Righe matrice_index aggiornate: ${single.changed.update_matrice_index}`)
            }
            if (single?.changed?.update_matrice_ee != null) {
              details.push(`Righe matrice_ee aggiornate: ${single.changed.update_matrice_ee}`)
            }
            if (single?.changed?.update_matrice_gas != null) {
              details.push(`Righe matrice_gas aggiornate: ${single.changed.update_matrice_gas}`)
            }
            if (single?.changed?.delete_matrice_index_storico != null) {
              details.push(`Righe storico eliminate: ${single.changed.delete_matrice_index_storico}`)
            }

            return {
              severity: 'success',
              title: 'Conferma completata',
              message: 'La matrice e stata riportata in validazione con successo.',
              details
            }
          }

          if (single.can_process === false) {
            return {
              severity: 'warn',
              title: 'Controllo non superato',
              message: single.reason || 'La matrice non puo essere riportata in validazione.',
              details
            }
          }
        }

        if (data?.executed === true) {
          return {
            severity: executedCount > 0 ? 'success' : 'warn',
            title: executedCount > 0 ? 'Conferma completata' : 'Nessuna matrice confermata',
            message: executedCount > 0
              ? `Conferma completata per ${executedCount} matrici.`
              : 'Nessuna matrice e stata confermata.',
            details
          }
        }

        return {
          severity: processableCount > 0 ? 'success' : 'warn',
          title: processableCount > 0 ? 'Controllo completato' : 'Controllo non superato',
          message: processableCount > 0
            ? `${processableCount} matrici possono essere confermate.`
            : 'Nessuna matrice e processabile.',
          details
        }
      }

      if (!isError && canProcess === true && executed === false) {
        const details = [
          `ID matrice: ${data.id_matrice ?? this.getInputDetailsLabel()}`,
          `Stato attuale: ${data?.contratto?.old_cod_stato_caricamento ?? '-'}`,
          `Nuovo stato: ${data?.contratto?.new_cod_stato_caricamento ?? '-'}`
        ]

        if (data?.would_change?.update_matrice_index != null) {
          details.push(`Righe matrice_index da aggiornare: ${data.would_change.update_matrice_index}`)
        }
        if (data?.would_change?.update_matrice_ee != null) {
          details.push(`Righe matrice_ee da aggiornare: ${data.would_change.update_matrice_ee}`)
        }
        if (data?.would_change?.update_matrice_gas != null) {
          details.push(`Righe matrice_gas da aggiornare: ${data.would_change.update_matrice_gas}`)
        }
        if (data?.would_change?.delete_matrice_index_storico != null) {
          details.push(`Righe storico da eliminare: ${data.would_change.delete_matrice_index_storico}`)
        }

        return {
          severity: 'success',
          title: 'Controllo completato',
          message: 'Operazione valida: il contratto puo essere riportato in validazione.',
          details
        }
      }

      if (!isError && canProcess === true && executed === true) {
        const details = [`ID matrice: ${data.id_matrice ?? this.getInputDetailsLabel()}`]
        if (data?.changed?.update_matrice_index != null) {
          details.push(`Righe matrice_index aggiornate: ${data.changed.update_matrice_index}`)
        }
        if (data?.changed?.update_matrice_ee != null) {
          details.push(`Righe matrice_ee aggiornate: ${data.changed.update_matrice_ee}`)
        }
        if (data?.changed?.update_matrice_gas != null) {
          details.push(`Righe matrice_gas aggiornate: ${data.changed.update_matrice_gas}`)
        }
        if (data?.changed?.delete_matrice_index_storico != null) {
          details.push(`Righe storico eliminate: ${data.changed.delete_matrice_index_storico}`)
        }

        return {
          severity: 'success',
          title: 'Conferma completata',
          message: 'La matrice e stata riportata in validazione con successo.',
          details
        }
      }

      if (!isError && canProcess === true) {
        return {
          severity: 'success',
          title: 'Controllo completato',
          message: 'Il contratto puo essere riportato in validazione.',
          details: [
            `ID matrice: ${data.id_matrice}`,
            `Stato attuale: ${data?.contratto?.cod_stato_caricamento_attuale ?? '-'}`,
            `Stato target: ${data?.contratto?.cod_stato_caricamento_target ?? '-'}`
          ]
        }
      }

      if (!isError && canProcess === false) {
        const details = [`ID matrice: ${data.id_matrice ?? this.getInputDetailsLabel()}`]
        if (data?.punti?.totali != null) details.push(`Punti totali: ${data.punti.totali}`)
        if (data?.punti?.non_validi != null) details.push(`Punti non validi: ${data.punti.non_validi}`)

        return {
          severity: 'warn',
          title: 'Controllo non superato',
          message: reason || 'Il contratto non puo essere riportato in validazione.',
          details
        }
      }

      if (metaStatusCode === 404) {
        return {
          severity: 'error',
          title: 'Contratto non trovato',
          message: 'Nessun contratto trovato con questo ID matrice.',
          details: [`ID matrice: ${this.getInputDetailsLabel()}`]
        }
      }

      if (metaStatusCode === 422) {
        const validationErrors = payload?.meta?.validate?.id_matrice?.[0]
        const backendReason = payload?.meta?.message || metaStatusMessage
        return {
          severity: 'warn',
          title: 'Controllo non eseguibile',
          message: backendReason || validationErrors || 'I dati inseriti non sono validi.',
          details: [`ID matrice: ${this.getInputDetailsLabel()}`]
        }
      }

      if (metaStatusCode === 401 || metaStatusCode === 403) {
        return {
          severity: 'error',
          title: 'Non autorizzato',
          message: 'Sessione non valida o permessi insufficienti. Esegui nuovamente il login.',
          details: []
        }
      }

      return {
        severity: 'error',
        title: 'Errore imprevisto',
        message: 'Si e verificato un problema durante la richiesta. Riprova tra poco.',
        details: []
      }
    },
    async runRiportaContrattoInValidazione() {
      const normalized = this.normalizeIdMatriceInput()
      if (!normalized.valid) {
        this.showConfirmButton = false
        this.userFeedback = {
          severity: 'warn',
          title: 'Dato non valido',
          message: 'Inserisci uno o piu ID matrice numerici maggiori di 0, separati da virgola.',
          details: []
        }
        this.responseData = null
        return
      }

      this.loading = true
      this.responseData = null
      this.userFeedback = null
      this.showConfirmButton = false

      try {
        this.responseData = await this.service.riportaContrattoInValidazione(normalized.value)
        this.userFeedback = this.buildFriendlyFeedback(this.responseData, false)
        const responseItems = this.getResponseItems(this.responseData?.data)
        this.showConfirmButton = responseItems.some(item => item.can_process === true && item.executed === false)
        this.$toast.add({
          severity: this.userFeedback.severity === 'error' ? 'warn' : this.userFeedback.severity,
          summary: this.userFeedback.title,
          detail: this.userFeedback.message,
          life: 3000
        })
      } catch (err) {
        this.responseData = err?.response?.data || null
        this.userFeedback = this.buildFriendlyFeedback(this.responseData, true)
        this.showConfirmButton = false
        this.$toast.add({
          severity: 'warn',
          summary: 'Errore',
          detail: this.userFeedback.message,
          life: 4500
        })
      } finally {
        this.loading = false
      }
    },
    async confirmValidationMatrice() {
      const processableIds = this.processableItems.map(item => item.id_matrice).filter(Boolean)
      if (processableIds.length === 0) {
        return
      }

      this.loadingConfirm = true

      try {
        this.responseData = await this.service.confirmValidationMatrice(processableIds.join(','))
        this.userFeedback = this.buildFriendlyFeedback(this.responseData, false)
        this.showConfirmButton = false
        this.$toast.add({
          severity: 'success',
          summary: this.userFeedback.title,
          detail: this.userFeedback.message,
          life: 3500
        })
      } catch (err) {
        this.responseData = err?.response?.data || null
        this.userFeedback = this.buildFriendlyFeedback(this.responseData, true)
        this.$toast.add({
          severity: 'warn',
          summary: 'Errore',
          detail: this.userFeedback.message,
          life: 4500
        })
      } finally {
        this.loadingConfirm = false
      }
    },
    async openTab(evt){
      if (this.$refs.functionalityAccordion?.tabs?.[evt.index]?.props?.header === "Recupera documenti d'identità rappresentanti") await this.loadDocumentiIdentitaRappresentanti(1)
      if (this.$refs.functionalityAccordion?.tabs?.[evt.index]?.props?.header === 'Logs') await this.loadLogTypes()
      if(evt.index == 1) await this.getCanSearchNextValidation()
      if(evt.index == 2) await this.checkProcesslistPasswordStatus()
      if(evt.index == 4) await this.getComuniRemi()
      if(evt.index == 8) await this.getPPwithoutCTR()
      if(evt.index == 9) await this.getValidazioniPrenotate()
      if(evt.index == 10) await this.getCategoryMotivationTicket()
      if(evt.index == 11) await this.loadMatriciIndexClienteIdMancante()
      if(evt.index == 12) await this.loadMatriciIndexRappresentanteIdMancante()
      if(evt.index == 13) await this.loadCaricamentiMatriceIndexStoricoDuplicatoStato2()
      if(evt.index == 15) await this.loadFattureNonInviateDaProcessare()
      if(evt.index == 16) await this.loadCreateContrattiCount()
      if(evt.index == 23) await this.loadLogErroriInviiPreavvisi()
    },
    async loadDocumentiIdentitaRappresentanti(page) {
      if (!this.cambioRappresentanteAvailable || this.loadingDocumentiIdentitaRappresentanti) return
      this.loadingDocumentiIdentitaRappresentanti = true
      this.documentiIdentitaRappresentantiError = ''
      try {
        const result = await this.service.getDocumentiIdentitaRappresentanteDaAllineare(page)
        this.documentiIdentitaRappresentanti = result
        this.documentiIdentitaRappresentantiFirst = (page - 1) * 20
        this.documentiIdentitaRappresentantiLoaded = true
      } catch (err) {
        this.documentiIdentitaRappresentantiError = err?.response?.data?.message || 'Caricamento dei casi da allineare non riuscito.'
      } finally {
        this.loadingDocumentiIdentitaRappresentanti = false
      }
    },
    async onDocumentiIdentitaRappresentantiPage(event) {
      await this.loadDocumentiIdentitaRappresentanti(event.page + 1)
    },
    async aggiornaDocumentiIdentitaRappresentanti() {
      const page = Math.floor(this.documentiIdentitaRappresentantiFirst / 20) + 1
      await this.loadDocumentiIdentitaRappresentanti(page)
      if (!this.documentiIdentitaRappresentanti.items.length && page > 1) await this.loadDocumentiIdentitaRappresentanti(page - 1)
    },
    async allineaDocumentoIdentitaRappresentante(row) {
      if (this.allineamentoDocumentoIdentitaId !== null) return
      this.allineamentoDocumentoIdentitaId = row.rappresentante_id
      try {
        const result = await this.service.allineaDocumentoIdentitaRappresentante(row.matrice_id, row.rappresentante_id)
        this.toast.add({ severity: 'success', detail: result.success ? 'Documento allineato.' : 'Documento già presente.', life: 4000 })
        const currentPage = Math.floor(this.documentiIdentitaRappresentantiFirst / 20) + 1
        await this.loadDocumentiIdentitaRappresentanti(currentPage)
        if (!this.documentiIdentitaRappresentanti.items.length && currentPage > 1) await this.loadDocumentiIdentitaRappresentanti(currentPage - 1)
      } catch (err) {
        this.toast.add({ severity: 'warn', summary: 'Allineamento non riuscito', detail: err?.response?.data?.message || 'Impossibile allineare il documento.', life: 6000 })
      } finally {
        this.allineamentoDocumentoIdentitaId = null
      }
    },
    async getCanSearchNextValidation(){
      this.loader = true
      await this.service.getCanSearchNextValidation()
      .then((res) => {
        this.canSearchNextValidation = res
      })
      .finally(()=>{
        this.loader = false
      })
    },
    async setActiveCanSearchNextValidation(){
      this.loader = true
      await this.service.setActiveCanSearchNextValidation()
      .then((res) => {
        let severity = res ? 'success' : 'warn'
        let detail = res ? 'Abilitato' : 'Errore'
        this.toast.add({severity: severity, detail: detail, life: 10000})
        this.canSearchNextValidation = res
      })
      .finally(()=>{
        this.loader = false
      })
    },
    async loadFullProcesslist() {
      if (!this.hasProcesslistPassword) {
        this.toast.add({
          severity: 'warn',
          summary: 'Accesso bloccato',
          detail: 'Devi prima creare la password per la lista processi.',
          life: 4000
        })
        return
      }

      this.loadingProcesslist = true
      this.processlistItems = []
      this.selectedProcessIds = []

      try {
        const res = await this.service.getFullProcesslist()
        const total = Number(res?.data?.total || 0)
        this.processlistItems = Array.isArray(res?.data?.items) ? res.data.items : []
        this.toast.add({
          severity: 'success',
          summary: 'Operazione completata',
          detail: `Lista processi recuperata. Totale: ${total}`,
          life: 4000
        })
      } catch (err) {
        const backendError = err?.response?.data?.meta?.error || 'Impossibile leggere il processlist del database.'
        this.processlistItems = []
        this.toast.add({
          severity: 'warn',
          summary: 'Errore',
          detail: backendError,
          life: 5000
        })
      } finally {
        this.loadingProcesslist = false
      }
    },
    isProcessBeingKilled(processId) {
      return this.killingProcessIds.includes(Number(processId))
    },
    toggleSelectAllProcesses(event) {
      if (event?.target?.checked) {
        this.selectedProcessIds = [...this.processlistValidIds]
        return
      }

      this.selectedProcessIds = []
    },
    requestKillSingleProcess(processId) {
      this.openKillProcessPasswordModal([processId])
    },
    requestKillSelectedProcesses() {
      this.openKillProcessPasswordModal(this.selectedProcessIds)
    },
    openKillProcessPasswordModal(processIds = []) {
      if (!this.hasProcesslistPassword) {
        return
      }

      const normalizedIds = processIds
        .map(id => Number(id))
        .filter(id => Number.isInteger(id) && id > 0)

      if (normalizedIds.length === 0) {
        return
      }

      this.pendingKillProcessIds = [...new Set(normalizedIds)]
      this.killProcessPassword = ''
      this.showKillProcessPasswordModal = true
    },
    async confirmKillProcessesByPassword() {
      const password = String(this.killProcessPassword || '').trim()
      if (password.length === 0) {
        this.toast.add({
          severity: 'warn',
          summary: 'Password non valida',
          detail: 'Inserisci la password per procedere.',
          life: 3500
        })
        return
      }

      const ids = [...this.pendingKillProcessIds]
      if (ids.length === 0) {
        this.showKillProcessPasswordModal = false
        return
      }

      const isSingleKill = ids.length === 1
      this.confirmingKillWithPassword = true
      this.killingSelected = !isSingleKill
      this.killingProcessIds = [...new Set([...this.killingProcessIds, ...ids])]

      try {
        const res = await this.service.killProcessById(ids.join(','), password)
        const killedCount = Number(res?.data?.killed_count || 0)
        const requested = Number(res?.data?.requested || ids.length)
        this.toast.add({
          severity: killedCount > 0 ? 'success' : 'warn',
          summary: isSingleKill ? 'Kill processo' : 'Kill processi',
          detail: isSingleKill
            ? (killedCount > 0 ? `Processo ${ids[0]} terminato.` : `Impossibile terminare il processo ${ids[0]}.`)
            : `Terminati ${killedCount} processi su ${requested} richiesti.`,
          life: 4500
        })

        this.showKillProcessPasswordModal = false
        this.killProcessPassword = ''
        this.pendingKillProcessIds = []
        await this.loadFullProcesslist()
      } catch (err) {
        const backendError = err?.response?.data?.meta?.error || 'Errore durante il kill del processo.'
        this.toast.add({
          severity: 'warn',
          summary: 'Errore',
          detail: backendError,
          life: 5000
        })
      } finally {
        this.confirmingKillWithPassword = false
        this.killingSelected = false
        this.killingProcessIds = []
      }
    },
    openCreateProcesslistPasswordModal() {
      this.processlistPassword = ''
      this.showCreateProcesslistPasswordModal = true
    },
    async checkProcesslistPasswordStatus() {
      this.checkingProcesslistPassword = true
      try {
        const res = await this.service.checkPswListProcess()
        this.hasProcesslistPassword = Boolean(res?.data?.has_password)
      } catch (err) {
        this.hasProcesslistPassword = false
      } finally {
        this.checkingProcesslistPassword = false
      }
    },
    async createProcesslistPassword() {
      const password = String(this.processlistPassword || '').trim()
      if (password.length === 0) {
        this.toast.add({
          severity: 'warn',
          summary: 'Password non valida',
          detail: 'Inserisci una password prima di salvare.',
          life: 3500
        })
        return
      }

      this.creatingProcesslistPassword = true
      try {
        const res = await this.service.createPswListProcess(password)
        const created = res?.data?.created
        this.hasProcesslistPassword = true
        this.showCreateProcesslistPasswordModal = false
        this.processlistPassword = ''
        this.toast.add({
          severity: 'success',
          summary: created === false ? 'Password già presente' : 'Password creata',
          detail: created === false
            ? 'Per questo utente la password esiste già. Accesso abilitato.'
            : 'Password salvata correttamente. Ora puoi usare Lista Processi.',
          life: 4000
        })
        await this.checkProcesslistPasswordStatus()
      } catch (err) {
        const backendError = err?.response?.data?.meta?.error || 'Impossibile creare la password.'
        this.toast.add({
          severity: 'warn',
          summary: 'Errore',
          detail: backendError,
          life: 5000
        })
      } finally {
        this.creatingProcesslistPassword = false
      }
    },
    async exportNumeriFatturaAgyo() {
      const startDate = String(this.agyoStartDate || '').trim()
      const endDate = String(this.agyoEndDate || '').trim()
      const dateRegex = /^\d{4}-\d{2}-\d{2}$/

      if (!dateRegex.test(startDate) || !dateRegex.test(endDate)) {
        this.toast.add({
          severity: 'warn',
          summary: 'Date non valide',
          detail: 'Inserisci entrambe le date nel formato YYYY-MM-DD.',
          life: 4000
        })
        return
      }

      if (startDate > endDate) {
        this.toast.add({
          severity: 'warn',
          summary: 'Intervallo non valido',
          detail: 'La data "Dal" deve essere minore o uguale alla data "Al".',
          life: 4000
        })
        return
      }

      this.loadingExportNumeriFatturaAgyo = true
      try {
        await this.service.exportNumeriFatturaContabilitaCsv(startDate, endDate)
        this.toast.add({
          severity: 'success',
          summary: 'Download avviato',
          detail: 'Il file CSV e stato generato correttamente.',
          life: 3500
        })
      } catch (err) {
        const backendError = err?.response?.data?.meta?.error || 'Impossibile esportare il file richiesto.'
        this.toast.add({
          severity: 'warn',
          summary: 'Errore',
          detail: backendError,
          life: 5000
        })
      } finally {
        this.loadingExportNumeriFatturaAgyo = false
      }
    },
    async getComuniRemi(){
      if(this.comuniRemi.length > 0) return
      this.loader = true
      await this.service.getComuniRemi()
      .then((res) => {
        this.comuniRemi = res
      })
      .finally(()=>{
        this.loader = false
      })
    },
    async addCodiceDestinatarioSdi(){
      const codiceSdi = String(this.newSdiCode || '').replace(/\s+/g, '').toUpperCase()

      if (!codiceSdi) {
        this.$toast.add({severity: 'warn', detail: 'Non hai inserito il codice SDI'})
        return
      }

      if (!/^[A-Z0-9]{6,7}$/.test(codiceSdi)) {
        this.$toast.add({severity: 'warn', detail: 'Il codice SDI deve contenere solo lettere e numeri, da 6 a 7 caratteri.'})
        return
      }

      this.loadingAddSdi = true
      await this.service.addCodiceDestinatarioSdi(codiceSdi)
      .then((res) => {
        const severity = res.success ? 'success' : 'warn'
        this.$toast.add({severity, detail: res.message, life: 4000})
        if (res.success) this.newSdiCode = ''
      })
      .catch((err) => {
        const detail = err?.response?.data?.message || 'Errore durante inserimento del codice SDI.'
        this.$toast.add({severity: 'warn', detail, life: 4000})
      })
      .finally(() => {
        this.loadingAddSdi = false
      })
    },
    async addRemiToComune(){
      if (!this.selectedComune) {
        this.$toast.add({severity: 'warn', detail: 'Non hai selezionato il comune'})
        return;
      }

      if(!this.selectedComune.remiToAdd){
        this.$toast.add({severity: 'warn', detail: 'Non hai inserito remi da aggiungere'})
        return;
      }

      const stringaPulita = this.selectedComune.remiToAdd.replace(/\s+/g, '');

      const codici = stringaPulita.split(',').filter(codice => codice !== '').map(codice => codice.toUpperCase());

      const regexRemiValido = /^[A-Z0-9]+$/;

      const tuttiValidi = codici.every(codice => regexRemiValido.test(codice));

      if (!tuttiValidi) {
          this.$toast.add({severity: 'warn', detail: 'Errore: uno o piu codici REMI non sono validi. Usa solo lettere e numeri, separati da una virgola.'})
          return;
      }

      const codiciEsistenti = this.selectedComune.codici_remi
      const codiciEsistentiNormalizzati = codiciEsistenti.map(codice => String(codice).toUpperCase())

      const codiciDuplicati = codici.filter(codice => codiciEsistentiNormalizzati.includes(codice));
      const codiciNuoviDaAggiungere = codici.filter(codice => !codiciEsistentiNormalizzati.includes(codice));

      if (codiciDuplicati.length > 0) {
        this.$toast.add({
          severity: 'warn',
          summary: 'Codici già presenti',
          detail: `I seguenti codici sono già registrati per questo comune e verranno ignorati: ${codiciDuplicati.join(', ')}`,
          life: 6000
        });
      }

      if (codiciNuoviDaAggiungere.length === 0) return

      this.loader = true
      await this.service.addRemiToComune(this.selectedComune.id, codiciNuoviDaAggiungere)
      .then((res) => {
        let detail = res.message
        let severity = res.success ? 'success' : 'warn'
        if (res.success) {
          this.selectedComune.codici_remi.push(...res.added_remi)
          this.selectedComune.remiToAdd = ''
        }
        this.$toast.add({ severity: severity, detail: detail, life: 4000 })
      })
      .finally(()=>{
        this.loader = false
      })
    },
    async getStoricoCaricamento(){
      if(!this.idMatriceToReset) return
      const id = this.idMatriceToReset.replace(/\s+/g, '');
      if (id.length === 0) {
        this.$toast.add({severity: 'warn', detail: 'Non hai inserito ID matrice da resettare'})
        return;
      }

      this.resetStoricoCaricamento()
      this.loader = true
      await this.service.getStoricoCaricamento(id)
      .then((res) => {
        if(!res.success) {
          this.$toast.add({severity: 'warn', detail: 'Caricamento non trovato o impossibile da resettare'})
          this.idMatriceToreset = ''
        }else{
          this.canDetachSignature = res.can_detach_signature === true
          this.signatureToDetach = res.cod_richiesta_firma
          this.storicoCaricamento = res.data
          this.columnStoricoCaricamento = res.columns
          this.storicoCaricamento.forEach((storico, index) => {
            storico.available_to_reset = res.statuses_available_for_reset.includes(storico.cod_stato_aggiornamento) && (index != this.storicoCaricamento.length - 1)
          })
        }
      })
      .finally(()=>{
        this.loader = false
      })
    },
    resetStoricoCaricamento(){
      this.canDetachSignature = false
      this.signatureToDetach = null
      this.storicoCaricamento = null
    },
    async detachContractSignature() {
      if (this.loader || !this.canDetachSignature) return
      this.loader = true
      try {
        const res = await this.service.detachContractSignature(this.idMatriceToReset.trim(), this.signatureToDetach)
        this.$toast.add({ severity: res.cancel_attempted && !res.canceled ? 'warn' : 'success', detail: res.message, life: 7000 })
        this.resetStoricoCaricamento()
      } catch (error) {
        this.$toast.add({ severity: 'error', detail: error.response?.data?.message || 'Sgancio della richiesta di firma non riuscito', life: 7000 })
      } finally {
        this.loader = false
      }
    },
    async resetCaricamento(status){
      this.loader = true
      await this.service.resetCaricamento(this.idMatriceToReset, status)
      .then((res) => {
        let detail = res.message
        let severity = res.success ? 'success' : 'warn'
        this.$toast.add({ severity: severity, detail: detail, life: 4000 })
        this.resetStoricoCaricamento()
        this.idMatriceToReset = ''
      })
      .finally(()=>{
        this.loader = false
      })
    },
    async allineaDataInizio(){
      const stringaPulita = this.idsMatriceDaAllineare.replace(/\s+/g, '');

      const ids = stringaPulita.split(',').filter(id => id !== '');
      if (ids.length === 0) {
        this.$toast.add({severity: 'warn', detail: 'Non hai inserito ID matrice da allineare'})
        return;
      }
      const regexIdValido = /^\d+$/;

      const tuttiValidi = ids.every(id => regexIdValido.test(id));

      if (!tuttiValidi) {
          this.$toast.add({severity: 'warn', detail: 'Errore: Uno o più ID matrice non sono validi. Assicurati che siano numerici e separati da una virgola.'})
          return;
      }

      this.loader = true
      await this.service.allineaDataInizio(ids)
      .then((res) => {
        let detail = res.message
        let severity = res.success ? 'success' : 'warn'
        this.$toast.add({ severity: severity, detail: detail, life: 4000 })
        this.idsMatriceDaAllineare = ''
      })
      .finally(()=>{
        this.loader = false
      })
    },
    resetPPwithoutCTR(){
      this.pp_without_ctr = {
        exist: false,
        data: []
      }
    },
    async getPPwithoutCTR(){
      this.resetPPwithoutCTR()
      this.loader = true
      await this.service.getPPwithoutCTR()
      .then((res) => {
        if(res.exist) {
          this.pp_without_ctr = {
            exist: res.exist,
            data: res.data
          }
        }
      })
      .finally(()=>{
        this.loader = false
      })
    },
    async allineaPPtoCTR(){
      this.loader = true
      await this.service.allineaPPtoCTR()
      .then((res) => {
        let detail = res.message
        let severity = res.success ? 'success' : 'warn'
        this.$toast.add({ severity: severity, detail: detail, life: 4000 })
        if(res.success) this.resetPPwithoutCTR()
      })
      .finally(()=>{
        this.loader = false
      })
    },
    async getValidazioniPrenotate(){
      this.validazioni_prenotate.reset()
      this.loader = true
      await this.service.getValidazioniPrenotate()
      .then((res) => {
        const { exist, data, columns } = res;

        Object.assign(this.validazioni_prenotate, { exist, data, columns });
      })
      .finally(()=>{
        this.loader = false
      })
    },
    async deleteValidazionePrenotata(id){
      this.loader = true
      await this.service.deleteValidazionePrenotata(id)
      .then((res) => {
        let detail = res.message
        let severity = res.success ? 'success' : 'warn'
        this.$toast.add({ severity: severity, detail: detail, life: 4000 })
        if(res.success) this.getValidazioniPrenotate()
      })
      .finally(()=>{
        this.loader = false
      })

    },
    async getCategoryMotivationTicket() {
      this.loadingCategoryTicket = true
      this.selectedCategoryTicketItems = []

      try {
        const res = await this.service.getCategoryMotivationTicket()
        this.categoryTicketItems = Array.isArray(res?.data) ? res.data : []

        if (res?.success === false) {
          this.toast.add({
            severity: 'warn',
            summary: 'Errore',
            detail: res?.message || 'Impossibile caricare le categorie ticket.',
            life: 5000,
          })
        }
      } catch (err) {
        this.categoryTicketItems = []
        this.toast.add({
          severity: 'warn',
          summary: 'Errore',
          detail: err?.response?.data?.message || 'Impossibile caricare le categorie ticket.',
          life: 5000,
        })
      } finally {
        this.loadingCategoryTicket = false
      }
    },
    async addNewCategoryTicket() {
      const motivation = this.newCategoryTicketMotivation.trim()
      if (!motivation) {
        this.toast.add({
          severity: 'warn',
          summary: 'Attenzione',
          detail: 'Inserisci una motivazione per la categoria.',
          life: 4000,
        })
        return
      }

      this.addingCategoryTicket = true

      try {
        const res = await this.service.addNewCategoryTicket(
          motivation,
          this.newCategoryTicketCanViewAgente ? 1 : 0
        )

        if (res?.success) {
          this.categoryTicketItems = Array.isArray(res?.data) ? res.data : this.categoryTicketItems
          this.closeAddCategoryTicketModal()
          this.toast.add({
            severity: 'success',
            summary: 'Operazione completata',
            detail: 'Categoria ticket aggiunta correttamente.',
            life: 4000,
          })
          return
        }

        const validationMessage = res?.validate?.motivation?.[0]
        this.toast.add({
          severity: 'warn',
          summary: 'Errore',
          detail: validationMessage || res?.message || 'Impossibile aggiungere la categoria ticket.',
          life: 5000,
        })
      } catch (err) {
        const responseData = err?.response?.data
        const validationMessage = responseData?.validate?.motivation?.[0]
        this.toast.add({
          severity: 'warn',
          summary: 'Errore',
          detail: validationMessage || responseData?.message || 'Impossibile aggiungere la categoria ticket.',
          life: 5000,
        })
      } finally {
        this.addingCategoryTicket = false
      }
    },
    openAddCategoryTicketModal() {
      this.newCategoryTicketMotivation = ''
      this.newCategoryTicketCanViewAgente = false
      this.showAddCategoryTicketModal = true
    },
    closeAddCategoryTicketModal() {
      this.showAddCategoryTicketModal = false
      this.newCategoryTicketMotivation = ''
      this.newCategoryTicketCanViewAgente = false
    },
    async deleteSelectedCategoryTickets() {
      const ids = this.selectedCategoryTicketItems
        .map((item) => Number(item?.id))
        .filter((id) => Number.isInteger(id) && id > 0)

      if (ids.length === 0) {
        this.toast.add({
          severity: 'warn',
          summary: 'Attenzione',
          detail: 'Seleziona almeno una categoria da eliminare.',
          life: 4000,
        })
        return
      }

      this.deletingCategoryTicket = true

      try {
        const res = await this.service.deleteCategoryMotivationTicket(ids)

        if (res?.success) {
          this.categoryTicketItems = Array.isArray(res?.data) ? res.data : []
          this.selectedCategoryTicketItems = []

          let detail = `${res.deleted?.length || ids.length} categorie eliminate correttamente.`
          if (Array.isArray(res?.not_found) && res.not_found.length > 0) {
            detail += ` Alcune categorie non sono state trovate: ${res.not_found.join(', ')}.`
          }

          this.toast.add({
            severity: 'success',
            summary: 'Operazione completata',
            detail,
            life: 5000,
          })
          return
        }

        const validationMessage = res?.validate?.ids?.[0] || res?.validate?.['ids.0']?.[0]
        this.toast.add({
          severity: 'warn',
          summary: 'Errore',
          detail: validationMessage || res?.message || 'Impossibile eliminare le categorie selezionate.',
          life: 5000,
        })
      } catch (err) {
        const responseData = err?.response?.data
        const validationMessage = responseData?.validate?.ids?.[0] || responseData?.validate?.['ids.0']?.[0]
        this.toast.add({
          severity: 'warn',
          summary: 'Errore',
          detail: validationMessage || responseData?.message || 'Impossibile eliminare le categorie selezionate.',
          life: 5000,
        })
      } finally {
        this.deletingCategoryTicket = false
      }
    },
    async loadCreateContrattiCount() {
      this.loadingCreateContrattiCount = true

      try {
        const res = await this.service.getCreateContrattiCount()
        this.createContrattiCounts = {
          total: Number(res?.total || 0),
          pod: Number(res?.items?.pod?.count || 0),
          pdr: Number(res?.items?.pdr?.count || 0),
        }
      } catch (err) {
        this.createContrattiCounts = {
          total: 0,
          pod: 0,
          pdr: 0,
        }
      } finally {
        this.loadingCreateContrattiCount = false
      }
    },
    formatCheckExistReportDate(date) {
      const parts = new Intl.DateTimeFormat('en-GB', {
        timeZone: 'Europe/Rome', year: 'numeric', month: '2-digit', day: '2-digit',
        hour: '2-digit', minute: '2-digit', second: '2-digit', hourCycle: 'h23',
      }).formatToParts(date)
      const value = type => parts.find(part => part.type === type).value
      return `${value('year')}-${value('month')}-${value('day')}T${value('hour')}:${value('minute')}:${value('second')}`
    },
    async openCheckExistReportFilters() {
      if (this.loadingCheckExistReportAgents || this.loadingCheckExistReport) return
      if (this.showCheckExistReportSearch) return
      if (!this.checkExistReportAgents.length) {
        this.loadingCheckExistReportAgents = true
        try {
          const response = await this.service.getCheckExistReportAgents()
          this.checkExistReportAgents = (response.items || []).map(agent => ({
            id: Number(agent.id), label: agent.name ? `${agent.name} (#${agent.id})` : `Agente #${agent.id}`,
          })).sort((a, b) => a.label.localeCompare(b.label, 'it'))
        } catch (error) {
          this.toast.add({ severity: 'warn', summary: 'Errore caricamento agenti',
            detail: error?.response?.data?.message || 'Impossibile caricare la lista degli agenti.', life: 5000 })
          return
        } finally {
          this.loadingCheckExistReportAgents = false
        }
      }
      const now = new Date()
      this.checkExistReportFilters.from = new Date(this.formatCheckExistReportDate(new Date(now.getTime() - 60 * 60 * 1000)))
      this.checkExistReportFilters.to = new Date(this.formatCheckExistReportDate(now))
      this.showCheckExistReportSearch = true
    },
    async loadCheckExistReportPreview() {
      if (this.loadingCheckExistReport) return
      const params = {}
      const agentIds = this.checkExistReportFilters.agentIds || []
      if (agentIds.length) params.agent_ids = [...new Set(agentIds)]
      for (const field of ['from', 'to']) {
        const value = this.checkExistReportFilters[field]
        if (value) {
          const pad = part => String(part).padStart(2, '0')
          params[field] = `${value.getFullYear()}-${pad(value.getMonth() + 1)}-${pad(value.getDate())} ${pad(value.getHours())}:${pad(value.getMinutes())}:${pad(value.getSeconds())}`
        }
      }
      if (params.from && params.to && params.from >= params.to) {
        this.toast.add({ severity: 'warn', summary: 'Intervallo non valido', detail: 'La data iniziale deve precedere quella finale.', life: 5000 })
        return
      }
      this.loadingCheckExistReport = true
      this.checkExistReport = null

      try {
        const report = await this.service.getCheckExistReportPreview(params)
        if (report?.status === 'in_esecuzione') {
          this.toast.add({
            severity: 'warn',
            summary: 'Report gia in esecuzione',
            detail: 'Attendi che il report in corso termini e riprova.',
            life: 5000,
          })
          return
        }
        if (report?.success === false) {
          throw new Error(report.message || 'Impossibile caricare il report.')
        }
        this.checkExistReport = report
      } catch (error) {
        this.toast.add({
          severity: 'warn',
          summary: 'Errore caricamento report',
          detail: Object.values(error?.response?.data?.errors || {}).flat().join(' ') || error?.response?.data?.message || error?.message || 'Impossibile caricare il report.',
          life: 5000,
        })
      } finally {
        this.loadingCheckExistReport = false
      }
    },
    async createContratti() {
      this.loadingCreateContratti = true

      try {
        const res = await this.service.createContratti()

        this.toast.add({
          severity: res?.success === false ? 'warn' : 'success',
          summary: res?.success === false
            ? 'Avvio non completato'
            : (res?.started ? 'Script avviato' : 'Richiesta inviata'),
          detail: res?.message || 'Il processo di creazione contratti e stato avviato.',
          life: 5000,
        })
      } catch (err) {
        const responseData = err?.response?.data

        if (err?.response?.status === 409 && responseData?.already_running) {
          this.toast.add({
            severity: 'warn',
            summary: 'Script gia in esecuzione',
            detail: responseData.message || 'La creazione contratti e gia in esecuzione.',
            life: 7000,
          })
          return
        }

        if (err?.code === 'ECONNABORTED') {
          this.toast.add({
            severity: 'info',
            summary: 'Richiesta inviata',
            detail: 'Il server non ha risposto entro 10 secondi. Se il cron parte subito lato backend, potrebbe essere comunque in esecuzione.',
            life: 7000,
          })
          return
        }

        const backendError =
          responseData?.message ||
          responseData?.meta?.error ||
          'Impossibile avviare la creazione contratti.'

        this.toast.add({
          severity: 'warn',
          summary: 'Errore',
          detail: backendError,
          life: 5000,
        })
      } finally {
        this.loadingCreateContratti = false
        await this.loadCreateContrattiCount()
      }
    },
    async loadLogFiles(type, project = 'ask_pratiche') {
      this.selectedLogType = type
      this.selectedLogProject = project
      this.loadingLogs = true
      this.logFiles = []

      try {
        const res = await this.service.getLogFiles(type, project)
        this.logFiles = Array.isArray(res?.items) ? res.items.map(file => ({...file, project, log_key: project + ':' + file.filename})) : []

        this.toast.add({
          severity: 'success',
          summary: 'Log caricati',
          detail: `File trovati: ${this.logFiles.length}`,
          life: 3500,
        })
      } catch (err) {
        const responseData = err?.response?.data
        this.toast.add({
          severity: 'warn',
          summary: 'Errore',
          detail: responseData?.message || 'Impossibile caricare i file di log.',
          life: 5000,
        })
      } finally {
        this.loadingLogs = false
      }
    },
    async loadMatriciIndexClienteIdMancante(force = false) {
      if (this.loadingMatriciIndexClienteIdMancante) return
      if (this.matriciIndexClienteIdMancanteLoaded && !force) return

      this.loadingMatriciIndexClienteIdMancante = true

      try {
        const res = await this.service.getMatriciIndexClienteIdMancante()
        this.matriciIndexClienteIdMancante = {
          total: Number(res?.total || 0),
          items: Array.isArray(res?.items) ? res.items : [],
        }
        this.matriciIndexClienteIdMancanteSelections = {}
        this.matriciIndexClienteIdMancanteLoaded = true
      } catch (err) {
        const responseData = err?.response?.data
        this.toast.add({
          severity: 'warn',
          summary: 'Errore',
          detail: responseData?.message || 'Impossibile caricare le righe con cliente_id mancante.',
          life: 5000,
        })
      } finally {
        this.loadingMatriciIndexClienteIdMancante = false
      }
    },
    getClienteIdsForMissingClientRow(row) {
      const supplies = [
        ...(Array.isArray(row?.ee) ? row.ee : []),
        ...(Array.isArray(row?.gas) ? row.gas : []),
      ]

      const ids = supplies
        .flatMap(supply => String(supply?.cliente_id ?? '').split(','))
        .map(id => id.trim())
        .filter(id => /^\d+$/.test(id) && Number(id) > 0)
        .filter((id, index, list) => list.indexOf(id) === index)
        .sort((a, b) => Number(a) - Number(b))

      return ids.join(',')
    },
    hasValidClienteIdValue(value) {
      return String(value ?? '')
        .split(',')
        .map(id => id.trim())
        .some(id => /^\d+$/.test(id) && Number(id) > 0)
    },
    isPositiveIntegerValue(value) {
      const normalized = String(value ?? '').trim()
      return /^\d+$/.test(normalized) && Number(normalized) > 0
    },
    getMissingClientRowSupplies(row) {
      return [
        ...(Array.isArray(row?.ee) ? row.ee : []),
        ...(Array.isArray(row?.gas) ? row.gas : []),
      ]
    },
    canSelectMissingClientRow(row) {
      const supplies = this.getMissingClientRowSupplies(row)
      return supplies.length > 0 && supplies.every(supply => this.hasValidClienteIdValue(supply?.cliente_id))
    },
    getSelectableMissingClientRows(group) {
      return (Array.isArray(group?.rows) ? group.rows : [])
        .filter(row => this.canSelectMissingClientRow(row))
    },
    isMissingClientRowSelected(period, row) {
      const selectedRows = this.matriciIndexClienteIdMancanteSelections[period] || []
      return selectedRows.some(selected => Number(selected.id) === Number(row.id))
    },
    isMissingClientGroupFullySelected(group) {
      const selectableRows = this.getSelectableMissingClientRows(group)

      if (selectableRows.length === 0) return false

      const selectedRows = this.matriciIndexClienteIdMancanteSelections[group.period] || []
      return selectableRows.every(row => selectedRows.some(selected => Number(selected.id) === Number(row.id)))
    },
    toggleMissingClientRowSelection(period, row, checked) {
      if (!this.canSelectMissingClientRow(row)) return

      const selectedRows = this.matriciIndexClienteIdMancanteSelections[period] || []
      const exists = selectedRows.some(selected => Number(selected.id) === Number(row.id))

      if (checked && !exists) {
        this.matriciIndexClienteIdMancanteSelections[period] = [...selectedRows, row]
        return
      }

      if (!checked && exists) {
        this.matriciIndexClienteIdMancanteSelections[period] = selectedRows.filter(selected => Number(selected.id) !== Number(row.id))
      }
    },
    toggleMissingClientGroupSelection(group, checked) {
      const selectableRows = this.getSelectableMissingClientRows(group)
      this.matriciIndexClienteIdMancanteSelections[group.period] = checked ? [...selectableRows] : []
    },
    getMissingClientRowClass(row) {
      return {
        'missing-client-row-disabled': !this.canSelectMissingClientRow(row),
      }
    },
    canUpdateRecoveredSupplyClienteId(supply) {
      return !this.hasValidClienteIdValue(supply?.cliente_id) && this.isPositiveIntegerValue(supply?.id_recuperato)
    },
    async loadMatriciIndexRappresentanteIdMancante(force = false) {
      if (this.loadingMatriciIndexRappresentanteIdMancante) return
      if (this.matriciIndexRappresentanteIdMancanteLoaded && !force) return

      this.loadingMatriciIndexRappresentanteIdMancante = true

      try {
        const res = await this.service.getMatriciIndexRappresentanteIdMancante()
        this.matriciIndexRappresentanteIdMancante = {
          total: Number(res?.total || 0),
          items: Array.isArray(res?.items) ? res.items : [],
        }
        this.matriciIndexRappresentanteIdMancanteSelections = {}
        this.matriciIndexRappresentanteIdMancanteLoaded = true
      } catch (err) {
        const responseData = err?.response?.data
        this.toast.add({
          severity: 'warn',
          summary: 'Errore',
          detail: responseData?.message || 'Impossibile caricare le righe con rappresentante_id mancante.',
          life: 5000,
        })
      } finally {
        this.loadingMatriciIndexRappresentanteIdMancante = false
      }
    },
    canSelectMissingRepresentativeRow(row) {
      return this.isPositiveIntegerValue(row?.id_recuperato)
    },
    getSelectableMissingRepresentativeRows(group) {
      return (Array.isArray(group?.rows) ? group.rows : [])
        .filter(row => this.canSelectMissingRepresentativeRow(row))
    },
    isMissingRepresentativeRowSelected(period, row) {
      const selectedRows = this.matriciIndexRappresentanteIdMancanteSelections[period] || []
      return selectedRows.some(selected => Number(selected.id) === Number(row.id))
    },
    isMissingRepresentativeGroupFullySelected(group) {
      const selectableRows = this.getSelectableMissingRepresentativeRows(group)

      if (selectableRows.length === 0) return false

      const selectedRows = this.matriciIndexRappresentanteIdMancanteSelections[group.period] || []
      return selectableRows.every(row => selectedRows.some(selected => Number(selected.id) === Number(row.id)))
    },
    toggleMissingRepresentativeRowSelection(period, row, checked) {
      if (!this.canSelectMissingRepresentativeRow(row)) return

      const selectedRows = this.matriciIndexRappresentanteIdMancanteSelections[period] || []
      const exists = selectedRows.some(selected => Number(selected.id) === Number(row.id))

      if (checked && !exists) {
        this.matriciIndexRappresentanteIdMancanteSelections[period] = [...selectedRows, row]
        return
      }

      if (!checked && exists) {
        this.matriciIndexRappresentanteIdMancanteSelections[period] = selectedRows.filter(selected => Number(selected.id) !== Number(row.id))
      }
    },
    toggleMissingRepresentativeGroupSelection(group, checked) {
      const selectableRows = this.getSelectableMissingRepresentativeRows(group)
      this.matriciIndexRappresentanteIdMancanteSelections[group.period] = checked ? [...selectableRows] : []
    },
    getMissingRepresentativeRowClass(row) {
      return {
        'missing-client-row-disabled': !this.canSelectMissingRepresentativeRow(row),
      }
    },
    async updateMatriciIndexRappresentanteId() {
      const items = this.matriciIndexRappresentanteIdMancantePayload

      if (items.length === 0) {
        this.toast.add({
          severity: 'warn',
          summary: 'Nessuna riga valida',
          detail: 'Seleziona almeno una riga con id_recuperato valido.',
          life: 5000,
        })
        return
      }

      this.updatingMatriciIndexRappresentanteId = true

      try {
        const res = await this.service.updateMatriciIndexRappresentanteId(items)

        this.toast.add({
          severity: res?.skipped_count > 0 ? 'warn' : 'success',
          summary: 'Aggiornamento completato',
          detail: `Righe aggiornate: ${res?.updated_count || 0}. Scartate : ${res?.skipped_count || 0}.`,
          life: 5000,
        })

        await this.loadMatriciIndexRappresentanteIdMancante(true)
      } catch (err) {
        const responseData = err?.response?.data
        this.toast.add({
          severity: 'warn',
          summary: 'Errore',
          detail: responseData?.message || 'Impossibile aggiornare rappresentante_id su matrice_index.',
          life: 5000,
        })
      } finally {
        this.updatingMatriciIndexRappresentanteId = false
      }
    },
    normalizeCaricamentiMatriceIndexStoricoDuplicatoStato2Payload(payload) {
      const root = payload || {}
      const data = root?.data && !Array.isArray(root.data) && typeof root.data === 'object'
        ? root.data
        : root
      const items = Array.isArray(root?.data)
        ? root.data
        : Array.isArray(data?.items)
          ? data.items
          : Array.isArray(data?.rows)
            ? data.rows
            : Array.isArray(data?.caricamenti)
              ? data.caricamenti
              : Array.isArray(data)
                ? data
                : []

      return {
        total: Number(data?.total || root?.total || data?.count || root?.count || items.length),
        items,
        columns: Array.isArray(data?.columns)
          ? data.columns
          : Array.isArray(root?.columns)
            ? root.columns
            : [],
      }
    },
    async loadCaricamentiMatriceIndexStoricoDuplicatoStato2(force = false) {
      if (this.loadingCaricamentiMatriceIndexStoricoDuplicatoStato2) return
      if (this.caricamentiMatriceIndexStoricoDuplicatoStato2Loaded && !force) return

      this.loadingCaricamentiMatriceIndexStoricoDuplicatoStato2 = true

      try {
        const res = await this.service.getCaricamentiMatriceIndexStoricoDuplicatoStato2()
        this.caricamentiMatriceIndexStoricoDuplicatoStato2 = this.normalizeCaricamentiMatriceIndexStoricoDuplicatoStato2Payload(res)
        this.caricamentiMatriceIndexStoricoDuplicatoStato2Loaded = true
      } catch (err) {
        const responseData = err?.response?.data
        this.caricamentiMatriceIndexStoricoDuplicatoStato2 = {
          total: 0,
          items: [],
          columns: [],
        }
        this.toast.add({
          severity: 'warn',
          summary: 'Errore',
          detail: responseData?.message || 'Impossibile caricare i caricamenti con stato 2 duplicato nello storico.',
          life: 5000,
        })
      } finally {
        this.loadingCaricamentiMatriceIndexStoricoDuplicatoStato2 = false
      }
    },
    getCaricamentoStoricoDuplicatoHeader(item) {
      const date = this.formatDateTime(item?.data_caricamento)
      return `Caricamento #${item?.id || '-'} - stati 2: ${item?.righe_storico_stato_2 || 0}${date ? ` - ${date}` : ''}`
    },
    getCaricamentoStoricoDuplicatoRows(item) {
      return Array.isArray(item?.storico) ? item.storico : []
    },
    canDeleteMatriceIndexStoricoRow(row) {
      return row?.can_delete_from_duplicate_stato_2 === true || row?.can_delete_from_duplicate_stato_2 === 1
    },
    getMatriceIndexStoricoDuplicatoGroup(row) {
      const matriceId = Number(row?.matrice_id || 0)
      const rowId = Number(row?.id || 0)

      return this.caricamentiMatriceIndexStoricoDuplicatoStato2.items.find(item => {
        if (matriceId && Number(item?.id) === matriceId) return true

        const storico = Array.isArray(item?.storico) ? item.storico : []
        return storico.some(storicoRow => Number(storicoRow?.id) === rowId)
      })
    },
    isLastDeletableMatriceIndexStoricoRow(row) {
      if (!this.canDeleteMatriceIndexStoricoRow(row)) return false

      const group = this.getMatriceIndexStoricoDuplicatoGroup(row)
      const storico = Array.isArray(group?.storico) ? group.storico : []
      const lastDeletableRow = [...storico].reverse().find(storicoRow => this.canDeleteMatriceIndexStoricoRow(storicoRow))

      return Number(lastDeletableRow?.id || 0) === Number(row?.id || 0)
    },
    getMatriceIndexStoricoDuplicatoRowClass(row) {
      return {
        'matrice-storico-duplicato-row-deletable': this.canDeleteMatriceIndexStoricoRow(row),
        'matrice-storico-duplicato-row-last-deletable': this.isLastDeletableMatriceIndexStoricoRow(row),
      }
    },
    isDeletingMatriceIndexStorico(id) {
      return this.deletingMatriceIndexStoricoIds[Number(id)] === true
    },
    setDeletingMatriceIndexStorico(id, value) {
      this.deletingMatriceIndexStoricoIds = {
        ...this.deletingMatriceIndexStoricoIds,
        [Number(id)]: value,
      }
    },
    recalculateMatriceIndexStoricoDuplicatoRows(rows) {
      let stato2Count = 0
      let canDeleteFromHere = false

      return (Array.isArray(rows) ? rows : []).map(row => {
        const normalizedRow = { ...row }

        if (Number(normalizedRow.cod_stato_aggiornamento) === 2) {
          stato2Count++

          if (stato2Count >= 2) {
            canDeleteFromHere = true
          }
        }

        normalizedRow.can_delete_from_duplicate_stato_2 = canDeleteFromHere
        return normalizedRow
      })
    },
    removeMatriceIndexStoricoRowFromLocalGroup(row) {
      const storicoId = Number(row?.id || 0)
      const matriceId = Number(row?.matrice_id || 0)

      if (!storicoId) return

      this.caricamentiMatriceIndexStoricoDuplicatoStato2 = {
        ...this.caricamentiMatriceIndexStoricoDuplicatoStato2,
        items: this.caricamentiMatriceIndexStoricoDuplicatoStato2.items.map(item => {
          const storico = Array.isArray(item?.storico) ? item.storico : []
          const hasRow = storico.some(storicoRow => Number(storicoRow?.id) === storicoId)

          if ((matriceId && Number(item?.id) !== matriceId) || (!matriceId && !hasRow)) {
            return item
          }

          const updatedStorico = this.recalculateMatriceIndexStoricoDuplicatoRows(
            storico.filter(storicoRow => Number(storicoRow?.id) !== storicoId)
          )
          const stato2Ids = updatedStorico
            .filter(storicoRow => Number(storicoRow?.cod_stato_aggiornamento) === 2)
            .map(storicoRow => storicoRow.id)

          if (!updatedStorico.some(storicoRow => this.canDeleteMatriceIndexStoricoRow(storicoRow))) {
            return null
          }

          return {
            ...item,
            storico: updatedStorico,
            righe_storico_stato_2: stato2Ids.length,
            storico_ids: stato2Ids.join(','),
          }
        }).filter(Boolean),
      }
      this.caricamentiMatriceIndexStoricoDuplicatoStato2.total = this.caricamentiMatriceIndexStoricoDuplicatoStato2.items.length
    },
    async deleteMatriceIndexStorico(row) {
      if (!this.canDeleteMatriceIndexStoricoRow(row)) return
      if (!this.isLastDeletableMatriceIndexStoricoRow(row)) return

      const id = Number(row?.id || 0)

      if (!id) {
        this.toast.add({
          severity: 'warn',
          summary: 'Errore',
          detail: 'Id storico non valido.',
          life: 5000,
        })
        return
      }

      this.setDeletingMatriceIndexStorico(id, true)

      try {
        await this.service.deleteMatriceIndexStorico(id)
        this.toast.add({
          severity: 'success',
          summary: 'Storico eliminato',
          detail: `Riga matrice_index_storico #${id} eliminata.`,
          life: 5000,
        })
        this.removeMatriceIndexStoricoRowFromLocalGroup(row)
      } catch (err) {
        const responseData = err?.response?.data
        this.toast.add({
          severity: 'warn',
          summary: 'Errore',
          detail: responseData?.message || 'Impossibile eliminare la riga storico.',
          life: 5000,
        })
      } finally {
        this.setDeletingMatriceIndexStorico(id, false)
      }
    },
    getRecoveredSupplyClienteIdKey(type, supply) {
      return `${type}-${supply?.id || 0}`
    },
    isUpdatingRecoveredSupplyClienteId(type, supply) {
      return this.updatingRecoveredSupplyClienteIds[this.getRecoveredSupplyClienteIdKey(type, supply)] === true
    },
    setUpdatingRecoveredSupplyClienteId(type, supply, value) {
      this.updatingRecoveredSupplyClienteIds = {
        ...this.updatingRecoveredSupplyClienteIds,
        [this.getRecoveredSupplyClienteIdKey(type, supply)]: value,
      }
    },
    async updateRecoveredSupplyClienteId(type, supply) {
      if (!this.canUpdateRecoveredSupplyClienteId(supply)) return

      this.setUpdatingRecoveredSupplyClienteId(type, supply, true)

      try {
        const idRecuperato = Number(String(supply.id_recuperato).trim())
        const res = await this.service.updateMatriceSupplyClienteIdRecuperato(type, supply.id, idRecuperato)

        supply.cliente_id = String(res?.cliente_id || idRecuperato)
        supply.id_recuperato = null

        this.toast.add({
          severity: 'success',
          summary: 'Fornitura aggiornata',
          detail: `cliente_id aggiornato su matrice_${type}`,
          life: 4000,
        })
      } catch (err) {
        const responseData = err?.response?.data
        this.toast.add({
          severity: 'warn',
          summary: 'Errore',
          detail: responseData?.message || `Impossibile aggiornare cliente_id su matrice_${type}.`,
          life: 5000,
        })
      } finally {
        this.setUpdatingRecoveredSupplyClienteId(type, supply, false)
      }
    },
    async updateMatriciIndexClienteId() {
      const items = this.matriciIndexClienteIdMancantePayload

      if (items.length === 0) {
        this.toast.add({
          severity: 'warn',
          summary: 'Nessuna riga valida',
          detail: 'Seleziona almeno una riga con cliente_id valorizzato su matrice_ee o matrice_gas.',
          life: 5000,
        })
        return
      }

      this.updatingMatriciIndexClienteId = true

      try {
        const res = await this.service.updateMatriciIndexClienteId(items)

        this.toast.add({
          severity: res?.skipped_count > 0 ? 'warn' : 'success',
          summary: 'Aggiornamento completato',
          detail: `Righe aggiornate: ${res?.updated_count || 0}. Scartate: ${res?.skipped_count || 0}.`,
          life: 5000,
        })

        await this.loadMatriciIndexClienteIdMancante(true)
      } catch (err) {
        const responseData = err?.response?.data
        this.toast.add({
          severity: 'warn',
          summary: 'Errore',
          detail: responseData?.message || 'Impossibile aggiornare cliente_id su matrice_index.',
          life: 5000,
        })
      } finally {
        this.updatingMatriciIndexClienteId = false
      }
    },
    async openLogFile(filename, initialSearchQuery = '', project = this.selectedLogProject) {
      this.stopLogTail()
      this.selectedLogFilename = filename
      this.selectedLogFileProject = project
      this.selectedLogContent = ''
      this.resetLogSearch()
      this.showLogContentModal = true
      this.loadingLogContent = true

      try {
        const res = await this.service.getLogFileContent(filename, project)
        this.selectedLogContent = res?.content || ''
        if (initialSearchQuery) {
          this.logSearchQuery = initialSearchQuery
          this.onLogSearchInput()
        }
      } catch (err) {
        const responseData = err?.response?.data
        this.showLogContentModal = false
        this.toast.add({
          severity: 'warn',
          summary: 'Errore',
          detail: responseData?.message || 'Impossibile leggere il file di log.',
          life: 5000,
        })
      } finally {
        this.loadingLogContent = false
      }
    },
    async openLogTail(filename, project = this.selectedLogFileProject) {
      const canResumeFromOffset = this.selectedLogFileProject === project && this.selectedLogFilename === filename && this.logTailOffset !== null

      if (!canResumeFromOffset) {
        this.stopLogTail()
      }
      this.selectedLogFilename = filename
      this.selectedLogFileProject = project
      if (!canResumeFromOffset) {
        this.selectedLogContent = ''
        this.logTailOffset = null
        this.resetLogSearch()
      }
      this.isLogPinnedToBottom = true
      this.markNextLogTailContentAsUnread = false
      this.clearUnreadLogTailState()
      this.isLogTailActive = true
      this.scheduleLogTailAutoStop()
      this.showLogContentModal = true
      this.loadingLogContent = true

      try {
        await this.fetchLogTail(!canResumeFromOffset)
      } catch (err) {
        this.handleLogTailError(err)
      } finally {
        this.loadingLogContent = false
      }
    },
    async resumeLogTail(filename) {
      if (!filename) return

      if (this.selectedLogFilename !== filename || this.logTailOffset === null) {
        await this.openLogTail(filename)
        return
      }

      this.markNextLogTailContentAsUnread = true
      this.isLogTailActive = true
      this.scheduleLogTailAutoStop()

      try {
        await this.fetchLogTail(false)
      } catch (err) {
        this.handleLogTailError(err)
      }
    },
    async fetchLogTail(isInitial = false) {
      if (!this.isLogTailActive || !this.selectedLogFilename || this.loadingLogTail) return

      this.loadingLogTail = true

      try {
        const filename = this.selectedLogFilename
        const project = this.selectedLogFileProject
        const res = await this.service.getLogFileTail(filename, {
          lines: 1000,
          offset: this.logTailOffset,
        }, project)
        if (filename !== this.selectedLogFilename || project !== this.selectedLogFileProject || !this.isLogTailActive) return

        const content = res?.content || ''
        const shouldMarkAsUnread = this.markNextLogTailContentAsUnread && content
        const shouldScrollToBottom = !shouldMarkAsUnread
          && (isInitial || this.logTailOffset === null || res?.reset_offset || this.isLogPinnedToBottom)
        const currentLineCount = this.getLogContentLineCount()

        if (isInitial || this.logTailOffset === null || res?.reset_offset) {
          this.selectedLogContent = content
          this.markNextLogTailContentAsUnread = false
          this.clearUnreadLogTailState()
        } else if (content) {
          if ((shouldMarkAsUnread || !shouldScrollToBottom) && this.unreadLogTailStartLine === null) {
            this.unreadLogTailStartLine = currentLineCount
            this.readLogTailUntilLine = currentLineCount - 1
          }
          this.appendLogContent(content)
          if (shouldMarkAsUnread || !shouldScrollToBottom) {
            this.hasUnreadLogTailContent = true
            this.isLogPinnedToBottom = false
          } else {
            this.clearUnreadLogTailState()
          }
        }
        this.markNextLogTailContentAsUnread = false

        this.logTailOffset = Number.isFinite(Number(res?.offset)) ? Number(res.offset) : this.logTailOffset
        if (shouldScrollToBottom) {
          this.scrollLogContentToBottom()
        }
        this.scheduleLogTail()
      } catch (err) {
        this.handleLogTailError(err)
      } finally {
        this.loadingLogTail = false
      }
    },
    scheduleLogTail() {
      if (!this.isLogTailActive) return

      clearTimeout(this.logTailTimer)
      this.logTailTimer = setTimeout(() => {
        this.fetchLogTail(false)
      }, this.logTailPollMs)
    },
    scheduleLogTailAutoStop() {
      clearTimeout(this.logTailAutoStopTimer)
      this.logTailAutoStopTimer = setTimeout(() => {
        this.stopLogTail(true)
      }, this.logTailAutoStopMs)
    },
    stopLogTail(autoStopped = false) {
      const wasActive = this.isLogTailActive
      this.isLogTailActive = false
      this.loadingLogTail = false
      if (!autoStopped) {
        this.logTailOffset = null
        this.markNextLogTailContentAsUnread = false
        this.clearUnreadLogTailState()
      }

      if (this.logTailTimer) {
        clearTimeout(this.logTailTimer)
        this.logTailTimer = null
      }

      if (this.logTailAutoStopTimer) {
        clearTimeout(this.logTailAutoStopTimer)
        this.logTailAutoStopTimer = null
      }

      if (autoStopped && wasActive) {
        this.toast.add({
          severity: 'info',
          summary: 'Tail sospeso',
          detail: 'Il tail live è stato fermato automaticamente dopo 15 minuti.',
          life: 5000,
        })
      }
    },
    appendLogContent(content) {
      if (!content) return

      this.selectedLogContent = this.selectedLogContent
        ? `${this.selectedLogContent}\n${content}`
        : content
    },
    scrollLogContentToBottom() {
      this.$nextTick(() => {
        const el = this.$refs.logContentPre
        if (el) {
          el.scrollTop = el.scrollHeight
          this.isLogPinnedToBottom = true
          this.clearUnreadLogTailState()
        }
      })
    },
    onLogContentScroll() {
      const el = this.$refs.logContentPre
      if (!el) return

      const distanceFromBottom = el.scrollHeight - el.scrollTop - el.clientHeight
      this.isLogPinnedToBottom = distanceFromBottom < 32

      if (this.isLogPinnedToBottom) {
        this.clearUnreadLogTailState()
      } else {
        this.updateUnreadLogTailReadProgress()
      }
    },
    getLogContentLineCount() {
      if (!this.selectedLogContent) return 0

      return String(this.selectedLogContent).split(/\r\n|\n|\r/).length
    },
    clearUnreadLogTailState() {
      this.hasUnreadLogTailContent = false
      this.unreadLogTailStartLine = null
      this.readLogTailUntilLine = null
    },
    shouldShowUnreadMarker(index) {
      return this.unreadLogTailStartLine !== null && index === this.unreadLogTailStartLine
    },
    getLogLineClass(index) {
      return {
        'log-content-line--unread': this.isUnreadLogLine(index),
        'log-content-line--search-match': this.hasLogSearchMatchOnLine(index),
        'log-content-line--active-search-match': this.isActiveLogSearchLine(index),
      }
    },
    resetLogSearch() {
      this.logSearchQuery = ''
      this.logSearchActiveMatchIndex = -1
    },
    clearLogSearch() {
      this.resetLogSearch()
    },
    resetLogGlobalSearch() {
      this.logGlobalSearchQuery = ''
      this.logGlobalSearchLastQuery = ''
      this.logGlobalSearchResults = []
      this.logGlobalSearchErrorCount = 0
      this.logGlobalSearchCompletedTypes = 0
      this.logGlobalSearchTotalTypes = 0
      this.logGlobalSearchSearchedTypes = []
      this.logGlobalSearchRunId += 1
    },
    clearLogGlobalSearch() {
      if (this.loadingLogGlobalSearch) return

      this.resetLogGlobalSearch()
    },
    onLogGlobalSearchInput() {
      if (this.normalizedLogGlobalSearchQuery !== this.logGlobalSearchLastQuery) {
        this.logGlobalSearchLastQuery = ''
        this.logGlobalSearchResults = []
        this.logGlobalSearchErrorCount = 0
        this.logGlobalSearchCompletedTypes = 0
        this.logGlobalSearchTotalTypes = 0
        this.logGlobalSearchSearchedTypes = []
        this.logGlobalSearchRunId += 1
      }
    },
    async searchAllLogTypes() {
      if (this.loadingLogGlobalSearch) return

      const query = this.normalizedLogGlobalSearchQuery
      if (!this.isLogGlobalSearchQueryValid) {
        this.toast.add({
          severity: 'warn',
          summary: 'Ricerca non valida',
          detail: 'Inserisci una stringa di almeno 3 caratteri.',
          life: 4500,
        })
        return
      }

      if (this.logTypes.length === 0) {
        this.toast.add({
          severity: 'warn',
          summary: 'Nessun tipo log disponibile',
          detail: 'Non ci sono tipi log su cui eseguire la ricerca.',
          life: 4500,
        })
        return
      }

      this.loadingLogGlobalSearch = true
      this.logGlobalSearchLastQuery = query
      this.logGlobalSearchResults = []
      this.logGlobalSearchErrorCount = 0
      this.logGlobalSearchCompletedTypes = 0
      this.logGlobalSearchTotalTypes = this.logTypes.length
      this.logGlobalSearchSearchedTypes = []
      const runId = this.logGlobalSearchRunId + 1
      this.logGlobalSearchRunId = runId

      try {
        const searchPromises = this.logTypes.map(logType => this.searchSingleLogType(logType, query, runId))
        await Promise.allSettled(searchPromises)

        if (runId !== this.logGlobalSearchRunId) return

        const totalMatches = this.logGlobalSearchResults.reduce((total, item) => total + Number(item.match_count || 0), 0)
        const errorLabel = this.logGlobalSearchErrorCount > 0
          ? `, errori: ${this.logGlobalSearchErrorCount}`
          : ''

        this.toast.add({
          severity: this.logGlobalSearchResults.length > 0 ? 'success' : 'info',
          summary: 'Ricerca completata',
          detail: `${this.logGlobalSearchResults.length} file, ${totalMatches} occorrenze${errorLabel}`,
          life: 4500,
        })
      } finally {
        if (runId === this.logGlobalSearchRunId) {
          this.loadingLogGlobalSearch = false
        }
      }
    },
    async searchSingleLogType(logType, query, runId) {
      try {
        const res = await this.service.searchLogFiles(logType.type, query, logType.project)
        if (runId !== this.logGlobalSearchRunId) return

        const results = Array.isArray(res?.items)
          ? res.items.map(item => ({
            ...item,
            project: logType.project,
            log_key: logType.project + ':' + item.filename,
            log_type: item.log_type || res?.type || logType.type || '',
            log_type_label: item.log_type_label || logType.label || logType.type || '',
          }))
          : []

        if (results.length > 0) {
          this.logGlobalSearchResults = [
            ...this.logGlobalSearchResults,
            ...results,
          ]
        }
      } catch {
        if (runId === this.logGlobalSearchRunId) {
          this.logGlobalSearchErrorCount += 1
        }
      } finally {
        if (runId === this.logGlobalSearchRunId) {
          this.logGlobalSearchCompletedTypes += 1
          this.logGlobalSearchSearchedTypes = [
            ...this.logGlobalSearchSearchedTypes,
            logType.project + ':' + logType.type,
          ]
        }
      }
    },
    onLogSearchInput() {
      this.$nextTick(() => {
        this.logSearchActiveMatchIndex = this.logSearchMatches.length > 0 ? 0 : -1
        this.scrollToActiveLogSearchMatch()
      })
    },
    navigateLogSearch(direction = 1) {
      if (!this.logSearchQuery || this.logSearchMatches.length === 0) return

      const matchesCount = this.logSearchMatches.length
      const currentIndex = this.logSearchActiveMatchIndex >= 0
        ? this.logSearchActiveMatchIndex
        : (direction < 0 ? 0 : -1)

      this.logSearchActiveMatchIndex = (currentIndex + direction + matchesCount) % matchesCount
      this.scrollToActiveLogSearchMatch()
    },
    scrollToActiveLogSearchMatch() {
      this.$nextTick(() => {
        const match = this.activeLogSearchMatch
        const container = this.$refs.logContentPre
        if (!match || !container) return

        const lineEl = container.querySelector(`[data-line-index="${match.lineIndex}"]`)
        if (lineEl) {
          lineEl.scrollIntoView({ block: 'center' })
          this.isLogPinnedToBottom = false
        }
      })
    },
    hasLogSearchMatchOnLine(index) {
      const lineMatches = this.logSearchMatchesByLine.get(index)
      return Array.isArray(lineMatches) && lineMatches.length > 0
    },
    isActiveLogSearchLine(index) {
      return this.activeLogSearchMatch?.lineIndex === index
    },
    getHighlightedLogLineSegments(line, lineIndex) {
      const text = String(line || ' ')
      const lineMatches = this.logSearchMatchesByLine.get(lineIndex) || []

      if (lineMatches.length === 0) {
        return [{ text, match: false, active: false }]
      }

      const segments = []
      let cursor = 0

      lineMatches.forEach((match) => {
        if (match.start > cursor) {
          segments.push({
            text: text.slice(cursor, match.start),
            match: false,
            active: false,
          })
        }

        segments.push({
          text: text.slice(match.start, match.end),
          match: true,
          active: match.matchIndex === this.logSearchActiveMatchIndex,
        })

        cursor = match.end
      })

      if (cursor < text.length) {
        segments.push({
          text: text.slice(cursor),
          match: false,
          active: false,
        })
      }

      return segments
    },
    isUnreadLogLine(index) {
      return this.unreadLogTailStartLine !== null
        && index >= this.unreadLogTailStartLine
        && (this.readLogTailUntilLine === null || index > this.readLogTailUntilLine)
    },
    updateUnreadLogTailReadProgress() {
      if (this.unreadLogTailStartLine === null) return

      const el = this.$refs.logContentPre
      if (!el) return

      const thresholdY = el.getBoundingClientRect().top + (el.clientHeight * 0.35)
      const unreadLines = el.querySelectorAll('.log-content-line--unread')
      let lastReadLine = this.readLogTailUntilLine ?? (this.unreadLogTailStartLine - 1)

      unreadLines.forEach((lineEl) => {
        const lineIndex = Number(lineEl.dataset.lineIndex)
        if (!Number.isFinite(lineIndex)) return

        if (lineEl.getBoundingClientRect().bottom <= thresholdY) {
          lastReadLine = Math.max(lastReadLine, lineIndex)
        }
      })

      if (lastReadLine !== this.readLogTailUntilLine) {
        this.readLogTailUntilLine = lastReadLine
      }

      if (lastReadLine >= this.logContentLines.length - 1) {
        this.clearUnreadLogTailState()
      }
    },
    handleLogTailError(err) {
      const responseData = err?.response?.data
      this.stopLogTail()
      this.toast.add({
        severity: 'warn',
        summary: 'Tail log interrotto',
        detail: responseData?.message || 'Impossibile aggiornare il tail del file di log.',
        life: 5000,
      })
    },
    normalizeNumeriFatturaPosteInput() {
      return String(this.numeriFatturaPoste || '')
        .split(',')
        .map(numero => numero.trim().toUpperCase())
        .filter(Boolean)
    },
    validateNumeriFatturaPosteInput() {
      const numeri = this.normalizeNumeriFatturaPosteInput()
      const isValid = numeri.length > 0 && numeri.every(numero => /^[EG]\d{1,8}$/.test(numero))

      return {
        isValid,
        numeri,
        value: numeri.join(','),
      }
    },
    buildContattoFatturaPostePayload(row) {
      const contatto = row?.contatto || {}

      return {
        contatto_id: Number(contatto.id || 0),
        toponimo: String(contatto.toponimo || '').trim(),
        indirizzo: String(contatto.indirizzo || '').trim(),
        civico: String(contatto.civico || '').trim(),
        cap: String(contatto.cap || '').trim(),
        comune: String(contatto.comune || '').trim(),
        provincia: String(contatto.provincia || '').trim().toUpperCase(),
        cod_comune: contatto.cod_comune || null,
      }
    },
    markFatturaPosteRowDirty(row, clearComune = false) {
      row.valid = false
      row.can_save = false
      row.saved = false
      if (clearComune && row.contatto) row.contatto.cod_comune = null
    },
    applyFatturaPosteValidation(row, payload) {
      const data = payload?.data || payload || {}

      row.valid = data.valid === true
      row.can_save = data.can_save === true || data.valid === true
      row.error = row.valid ? '' : (data.error || data.poste?.error || 'Indirizzo non valido.')
      row.poste = data.poste || row.poste || null
      row.saved = false
    },
    normalizeFatturePosteReport(items) {
      return (Array.isArray(items) ? items : []).map(item => ({
        ...item,
        valid: item.valid === true,
        can_save: false,
        saved: false,
        loading_validate: false,
        loading_save: false,
        contatto: item.contatto ? { ...item.contatto } : null,
      }))
    },
    getFatturaPosteRowClass(row) {
      return {
        'invoice-poste-row-valid': row.valid === true,
        'invoice-poste-row-invalid': row.valid !== true,
      }
    },
    async validaFatturePoste() {
      const normalized = this.validateNumeriFatturaPosteInput()

      if (!normalized.isValid) {
        this.toast.add({
          severity: 'warn',
          summary: 'Lista non valida',
          detail: 'Usa numeri separati da virgola nel formato E/G + massimo 8 cifre.',
          life: 5000,
        })
        return
      }

      this.loadingFatturePoste = true
      this.fatturePosteReport = []
      this.fatturePosteErrors = []

      try {
        const res = await this.service.validaFatturePoste(normalized.value)
        const data = res?.data || {}

        this.fatturePosteReport = this.normalizeFatturePosteReport(data.items)
        this.fatturePosteErrors = Array.isArray(data.errors) ? data.errors : []

        this.toast.add({
          severity: this.fatturePosteErrors.length > 0 ? 'warn' : 'success',
          summary: 'Controllo completato',
          detail: `Fatture validate: ${this.fatturePosteReport.length}. Errori: ${this.fatturePosteErrors.length}.`,
          life: 5000,
        })
      } catch (err) {
        const responseData = err?.response?.data
        this.toast.add({
          severity: 'warn',
          summary: 'Errore',
          detail: responseData?.meta?.validate?.numeri_fattura?.[0] || responseData?.message || 'Impossibile validare le fatture.',
          life: 5000,
        })
      } finally {
        this.loadingFatturePoste = false
      }
    },
    async validaContattoFatturaPoste(row) {
      row.loading_validate = true

      try {
        const res = await this.service.validaContattoFatturaPoste(this.buildContattoFatturaPostePayload(row))
        this.applyFatturaPosteValidation(row, res)
      } catch (err) {
        this.applyFatturaPosteValidation(row, err?.response?.data)
      } finally {
        row.loading_validate = false
      }
    },
    async aggiornaContattoFatturaPoste(row) {
      row.loading_save = true

      try {
        const res = await this.service.aggiornaContattoFatturaPoste(this.buildContattoFatturaPostePayload(row))
        const data = res?.data || {}

        row.saved = data.updated === true
        row.can_save = false
        row.valid = data.valid === true
        row.error = ''
        row.poste = data.poste || row.poste
        if (row.contatto && data.cod_comune) row.contatto.cod_comune = data.cod_comune

        this.toast.add({
          severity: row.saved ? 'success' : 'warn',
          summary: row.saved ? 'Contatto aggiornato' : 'Nessuna modifica',
          detail: row.saved ? `Contatto fattura ${row.numero} aggiornato.` : 'Non risultano modifiche da salvare.',
          life: 5000,
        })
      } catch (err) {
        this.applyFatturaPosteValidation(row, err?.response?.data)
        const responseData = err?.response?.data
        this.toast.add({
          severity: 'warn',
          summary: 'Errore',
          detail: responseData?.data?.message || responseData?.data?.error || 'Impossibile aggiornare il contatto.',
          life: 5000,
        })
      } finally {
        row.loading_save = false
      }
    },
    normalizeFattureNonInviateDaProcessarePayload(payload) {
      const root = payload || {}
      const data = root?.data && !Array.isArray(root.data) && typeof root.data === 'object'
        ? root.data
        : root
      const dataRows = Array.isArray(root?.data) ? root.data : data?.data
      const items = Array.isArray(data)
        ? data
        : Array.isArray(data?.items)
          ? data.items
          : Array.isArray(dataRows)
            ? dataRows
            : Array.isArray(data?.fatture)
              ? data.fatture
              : Array.isArray(data?.groups)
                ? data.groups
                : []

      return {
        total: Number(data?.total || root?.total || data?.count || root?.count || items.reduce((total, item) => {
          const rows = Array.isArray(item?.fatture)
            ? item.fatture
            : Array.isArray(item?.rows)
              ? item.rows
              : Array.isArray(item?.items)
                ? item.items
                : null

          return total + (rows ? rows.length : 1)
        }, 0)),
        items,
        columns: Array.isArray(data?.columns)
          ? data.columns
          : Array.isArray(root?.columns)
            ? root.columns
            : [],
      }
    },
    async loadFattureNonInviateDaProcessare(force = false) {
      if (this.loadingFattureNonInviateDaProcessare) return
      if (this.fattureNonInviateDaProcessareLoaded && !force) return

      this.loadingFattureNonInviateDaProcessare = true

      try {
        const res = await this.service.getFattureNonInviateDaProcessare()
        this.fattureNonInviateDaProcessare = this.normalizeFattureNonInviateDaProcessarePayload(res)
        this.fattureNonInviateDaProcessareLoaded = true
      } catch (err) {
        const responseData = err?.response?.data
        this.fattureNonInviateDaProcessare = {
          total: 0,
          items: [],
          columns: [],
        }
        this.toast.add({
          severity: 'warn',
          summary: 'Errore',
          detail: responseData?.message || 'Impossibile caricare le fatture non inviate da processare.',
          life: 5000,
        })
      } finally {
        this.loadingFattureNonInviateDaProcessare = false
      }
    },
    normalizeFilePraticheDaRecuperarePayload(payload) {
      const data = payload?.data && typeof payload.data === 'object'
        ? payload.data
        : payload

      const items = Array.isArray(data?.items)
        ? data.items
        : Array.isArray(payload?.items)
          ? payload.items
          : Array.isArray(data)
            ? data
            : []

      return {
        total: Number(data?.total || payload?.total || items.length || 0),
        items: this.sortFilePraticheDaRecuperareItems(items),
        columns: Array.isArray(data?.columns)
          ? data.columns
          : Array.isArray(payload?.columns)
            ? payload.columns
            : [],
      }
    },
    sortFilePraticheDaRecuperareItems(items) {
      return [...items].sort((first, second) => {
        const firstTime = new Date(first?.data_creazione || 0).getTime()
        const secondTime = new Date(second?.data_creazione || 0).getTime()

        if (Number.isNaN(firstTime) && Number.isNaN(secondTime)) {
          return Number(second?.id || 0) - Number(first?.id || 0)
        }

        if (Number.isNaN(firstTime)) return 1
        if (Number.isNaN(secondTime)) return -1
        if (secondTime !== firstTime) return secondTime - firstTime

        return Number(second?.id || 0) - Number(first?.id || 0)
      })
    },
    getValidCalendarDate(value) {
      if (!value) return null

      const date = value instanceof Date
        ? new Date(value.getTime())
        : new Date(value)

      return Number.isNaN(date.getTime()) ? null : date
    },
    normalizeCalendarDate(value, unit = 'day') {
      const date = this.getValidCalendarDate(value)
      if (!date) return null

      if (unit === 'month') {
        return new Date(date.getFullYear(), date.getMonth(), 1)
      }

      if (unit === 'year') {
        return new Date(date.getFullYear(), 0, 1)
      }

      date.setHours(0, 0, 0, 0)
      return date
    },
    getCalendarDefaultDate(unit = 'day', minDate = null, maxDate = null) {
      const today = this.normalizeCalendarDate(new Date(), unit)
      return this.clampCalendarDate(today, minDate, maxDate, unit)
    },
    addToCalendarDate(value, amount = 1, unit = 'day') {
      const date = this.normalizeCalendarDate(value, unit)
      if (!date) return null

      const nextDate = new Date(date.getTime())

      if (unit === 'month') {
        nextDate.setMonth(nextDate.getMonth() + amount)
      } else if (unit === 'year') {
        nextDate.setFullYear(nextDate.getFullYear() + amount)
      } else {
        nextDate.setDate(nextDate.getDate() + amount)
      }

      return this.normalizeCalendarDate(nextDate, unit)
    },
    clampCalendarDate(value, minDate = null, maxDate = null, unit = 'day') {
      const date = this.normalizeCalendarDate(value, unit)
      const min = this.normalizeCalendarDate(minDate, unit)
      const max = this.normalizeCalendarDate(maxDate, unit)

      if (!date) return null
      if (min && date.getTime() < min.getTime()) return min
      if (max && date.getTime() > max.getTime()) return max

      return date
    },
    shiftCalendarDate(modelKey, amount = 1, unit = 'day', minDate = null, maxDate = null) {
      const currentDate = this.normalizeCalendarDate(this[modelKey], unit)
      const baseDate = currentDate || this.getCalendarDefaultDate(unit, minDate, maxDate)
      const shiftedDate = this.addToCalendarDate(baseDate, amount, unit)

      this[modelKey] = this.clampCalendarDate(shiftedDate, minDate, maxDate, unit)
    },
    isCalendarShiftDisabled(modelKey, amount = 1, unit = 'day', minDate = null, maxDate = null) {
      const currentDate = this.normalizeCalendarDate(this[modelKey], unit)

      if (!currentDate) return false

      const shiftedDate = this.addToCalendarDate(currentDate, amount, unit)
      const nextDate = this.clampCalendarDate(shiftedDate, minDate, maxDate, unit)

      return !nextDate || nextDate.getTime() === currentDate.getTime()
    },
    getFilePraticheMonthValue() {
      if (!this.filePraticheMonth) return null

      const date = this.filePraticheMonth instanceof Date
        ? this.filePraticheMonth
        : new Date(this.filePraticheMonth)

      if (Number.isNaN(date.getTime())) return null

      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0')

      return `${year}-${month}`
    },
    getFirstNumericPayloadValue(...values) {
      for (const value of values) {
        if (value === null || value === undefined || value === '') continue

        const numericValue = Number(value)
        if (!Number.isNaN(numericValue)) return numericValue
      }

      return null
    },
    normalizePayloadIdCaricamentiPayload(payload) {
      const data = payload?.data && typeof payload.data === 'object'
        ? payload.data
        : payload
      const meta = data?.meta && typeof data.meta === 'object'
        ? data.meta
        : payload?.meta && typeof payload.meta === 'object'
          ? payload.meta
          : {}

      const items = Array.isArray(data?.items)
        ? data.items
        : Array.isArray(payload?.items)
          ? payload.items
          : Array.isArray(data)
            ? data
            : []
      const total = this.getFirstNumericPayloadValue(
        data?.total_without_limit,
        data?.total_all,
        data?.total_available,
        data?.total_records,
        data?.total_items,
        data?.recordsTotal,
        data?.filtered_total,
        data?.count_without_limit,
        data?.count_all,
        payload?.total_without_limit,
        payload?.total_all,
        payload?.total_available,
        payload?.total_records,
        payload?.total_items,
        payload?.recordsTotal,
        payload?.filtered_total,
        payload?.count_without_limit,
        payload?.count_all,
        meta?.total_without_limit,
        meta?.total_all,
        meta?.total_available,
        meta?.total_records,
        meta?.total_items,
        meta?.recordsTotal,
        meta?.filtered_total,
        meta?.count_without_limit,
        meta?.count_all,
        data?.total,
        payload?.total,
        meta?.total,
        data?.count,
        payload?.count,
        meta?.count
      )

      return {
        total,
        items,
        columns: Array.isArray(data?.columns)
          ? data.columns
          : Array.isArray(payload?.columns)
            ? payload.columns
            : [],
      }
    },
    isPayloadIdCaricamentoSelectable(row) {
      return this.isNonEmptyValue(row?.origin_id_suggerito) ||
        this.isNonEmptyValue(row?.payload_id_suggerito)
    },
    isPayloadIdCaricamentoSelected(row) {
      const matriceId = String(row?.matrice_index_id || '')
      return this.selectedPayloadIdCaricamenti.some(selected => String(selected?.matrice_index_id || '') === matriceId)
    },
    isPayloadIdCaricamentoSelectionDisabled(row) {
      if (this.payloadIdLoadedWithoutLimit) return false

      return !this.isPayloadIdCaricamentoSelected(row) &&
        this.selectedPayloadIdCaricamenti.length >= this.maxSelectedPayloadIdCaricamenti
    },
    getSelectablePayloadIdCaricamenti() {
      const items = Array.isArray(this.payloadIdCaricamenti.items)
        ? this.payloadIdCaricamenti.items
        : []

      return items.filter(row => this.isPayloadIdCaricamentoSelectable(row))
    },
    getLimitedSelectablePayloadIdCaricamenti() {
      const selectableRows = this.getSelectablePayloadIdCaricamenti()

      return this.payloadIdLoadedWithoutLimit
        ? selectableRows
        : selectableRows.slice(0, this.maxSelectedPayloadIdCaricamenti)
    },
    areAllPayloadIdCaricamentiSelected() {
      const selectableRows = this.getLimitedSelectablePayloadIdCaricamenti()
      return selectableRows.length > 0 &&
        selectableRows.every(row => this.isPayloadIdCaricamentoSelected(row))
    },
    toggleAllPayloadIdCaricamenti(checked) {
      this.selectedPayloadIdCaricamenti = checked
        ? this.getLimitedSelectablePayloadIdCaricamenti()
        : []
    },
    togglePayloadIdCaricamentoSelection(row, checked) {
      if (!this.isPayloadIdCaricamentoSelectable(row)) return
      if (checked && this.isPayloadIdCaricamentoSelectionDisabled(row)) {
        this.toast.add({
          severity: 'warn',
          summary: 'Limite selezione',
          detail: `Puoi selezionare al massimo ${this.maxSelectedPayloadIdCaricamenti} righe alla volta.`,
          life: 4000,
        })
        return
      }

      const matriceId = String(row?.matrice_index_id || '')
      const selectedRows = this.selectedPayloadIdCaricamenti
        .filter(selected => String(selected?.matrice_index_id || '') !== matriceId)

      this.selectedPayloadIdCaricamenti = checked
        ? [...selectedRows, row]
        : selectedRows
    },
    normalizePayloadIdSuggestedNumber(value, allowNull = false) {
      if (!this.isNonEmptyValue(value)) return allowNull ? null : undefined

      const parsedValue = Number(value)
      if (!Number.isInteger(parsedValue) || parsedValue <= 0) return allowNull ? null : undefined

      return parsedValue
    },
    getPayloadIdCaricamentiUpdatePayload() {
      return this.selectedPayloadIdCaricamenti
        .filter(row => this.isPayloadIdCaricamentoSelectable(row))
        .map(row => ({
          matrice_id: this.normalizePayloadIdSuggestedNumber(row.matrice_index_id),
          origin_id: this.normalizePayloadIdSuggestedNumber(row.origin_id_suggerito, true),
          payload_id: this.normalizePayloadIdSuggestedNumber(row.payload_id_suggerito),
        }))
        .filter(row => row.matrice_id)
    },
    getPayloadIdMonthValue() {
      if (!this.payloadIdMonth) return null

      const date = this.payloadIdMonth instanceof Date
        ? this.payloadIdMonth
        : new Date(this.payloadIdMonth)

      if (Number.isNaN(date.getTime())) return null

      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0')

      return `${year}-${month}`
    },
    async loadPayloadIdCaricamenti() {
      const month = this.getPayloadIdMonthValue()

      if (!month) {
        this.toast.add({
          severity: 'warn',
          summary: 'Mese mancante',
          detail: 'Seleziona un mese valido prima di cercare.',
          life: 4000,
        })
        return
      }

      this.payloadIdCaricamentiLoaded = false
      this.loadingPayloadIdCaricamenti = true

      try {
        const res = await this.service.getPayloadIdCaricamentiByMonth(month, this.payloadIdWithoutLimit)
        this.payloadIdCaricamenti = this.normalizePayloadIdCaricamentiPayload(res)
        this.selectedPayloadIdCaricamenti = []
        this.payloadIdLoadedMonth = month
        this.payloadIdLoadedWithoutLimit = this.payloadIdWithoutLimit
        this.payloadIdCaricamentiLoaded = true
      } catch (err) {
        const responseData = err?.response?.data
        this.payloadIdCaricamenti = {
          total: null,
          items: [],
          columns: [],
        }
        this.selectedPayloadIdCaricamenti = []
        this.payloadIdLoadedMonth = month
        this.payloadIdLoadedWithoutLimit = this.payloadIdWithoutLimit
        this.payloadIdCaricamentiLoaded = true
        this.toast.add({
          severity: 'warn',
          summary: 'Errore',
          detail: responseData?.message || 'Impossibile cercare i payload_id dei caricamenti.',
          life: 5000,
        })
      } finally {
        this.loadingPayloadIdCaricamenti = false
      }
    },
    async updatePayloadIdCaricamenti() {
      const items = this.getPayloadIdCaricamentiUpdatePayload()

      if (items.length === 0) {
        this.toast.add({
          severity: 'warn',
          summary: 'Nessuna riga valida',
          detail: 'Seleziona almeno una riga con origin o payload suggerito.',
          life: 4000,
        })
        return
      }

      if (!this.payloadIdLoadedWithoutLimit && items.length > this.maxSelectedPayloadIdCaricamenti) {
        this.toast.add({
          severity: 'warn',
          summary: 'Limite selezione',
          detail: `Puoi aggiornare al massimo ${this.maxSelectedPayloadIdCaricamenti} righe alla volta.`,
          life: 4000,
        })
        return
      }

      this.updatingPayloadIdCaricamenti = true

      try {
        const chunks = this.chunkItems(items, this.payloadIdUpdateChunkSize)
        const responses = []

        for (const chunk of chunks) {
          responses.push(await this.service.updatePayloadIdCaricamenti(chunk))
        }

        const updated = responses.reduce((total, res) => total + Number(res?.updated || 0), 0)
        const skipped = responses.reduce((total, res) => total + Number(res?.skipped || 0), 0)
        const errors = responses.reduce((total, res) => total + Number(res?.errors_count || 0), 0)
        const updatedItems = responses.flatMap(res => Array.isArray(res?.items) ? res.items : [])

        this.toast.add({
          severity: errors > 0 ? 'warn' : 'success',
          summary: errors > 0 ? 'Aggiornamento parziale' : 'Payload aggiornati',
          detail: `Aggiornati: ${updated}. Saltati: ${skipped}. Errori: ${errors}. Chunk: ${chunks.length}.`,
          life: 5000,
        })

        this.removeUpdatedPayloadIdCaricamenti(updatedItems)

        if (this.payloadIdCaricamenti.items.length === 0 && updated > 0) {
          await this.loadPayloadIdCaricamenti()
        }
      } catch (err) {
        const responseData = err?.response?.data
        this.toast.add({
          severity: 'warn',
          summary: 'Errore',
          detail: responseData?.message || 'Impossibile aggiornare i payload selezionati.',
          life: 5000,
        })
      } finally {
        this.updatingPayloadIdCaricamenti = false
      }
    },
    chunkItems(items, chunkSize = 20) {
      const size = Number(chunkSize || 20)
      const chunks = []

      for (let index = 0; index < items.length; index += size) {
        chunks.push(items.slice(index, index + size))
      }

      return chunks
    },
    removeUpdatedPayloadIdCaricamenti(updatedItems = []) {
      const updatedMatriceIds = Array.isArray(updatedItems)
        ? updatedItems
          .map(item => String(item?.matrice_id || '').trim())
          .filter(Boolean)
        : []

      if (updatedMatriceIds.length === 0) return

      const updatedMatriceIdSet = new Set(updatedMatriceIds)
      const currentItems = Array.isArray(this.payloadIdCaricamenti.items)
        ? this.payloadIdCaricamenti.items
        : []

      this.payloadIdCaricamenti.items = currentItems
        .filter(item => !updatedMatriceIdSet.has(String(item?.matrice_index_id || '').trim()))
      const removedCount = currentItems.length - this.payloadIdCaricamenti.items.length
      if (this.payloadIdCaricamenti.total !== null) {
        this.payloadIdCaricamenti.total = Math.max(0, Number(this.payloadIdCaricamenti.total || 0) - removedCount)
      }
      this.selectedPayloadIdCaricamenti = this.selectedPayloadIdCaricamenti
        .filter(item => !updatedMatriceIdSet.has(String(item?.matrice_index_id || '').trim()))
    },
    normalizeSwitchDateLogRetroattiviPayload(payload) {
      return this.normalizePayloadIdCaricamentiPayload(payload)
    },
    isSwitchDateLogRetroattivoSelectable(row) {
      return row?.selezionabile === true
    },
    isSwitchDateLogRetroattivoSelected(row) {
      const matriceId = String(row?.matrice_index_id || '')
      return this.selectedSwitchDateLogRetroattivi.some(selected => String(selected?.matrice_index_id || '') === matriceId)
    },
    isSwitchDateLogSelectionDisabled(row) {
      if (this.switchDateLogLoadedWithoutLimit) return false

      return !this.isSwitchDateLogRetroattivoSelected(row) &&
        this.selectedSwitchDateLogRetroattivi.length >= this.maxSelectedSwitchDateLogRetroattivi
    },
    getSelectableSwitchDateLogRetroattivi() {
      const items = Array.isArray(this.switchDateLogRetroattivi.items)
        ? this.switchDateLogRetroattivi.items
        : []

      return items.filter(row => this.isSwitchDateLogRetroattivoSelectable(row))
    },
    getLimitedSelectableSwitchDateLogRetroattivi() {
      const selectableRows = this.getSelectableSwitchDateLogRetroattivi()

      return this.switchDateLogLoadedWithoutLimit
        ? selectableRows
        : selectableRows.slice(0, this.maxSelectedSwitchDateLogRetroattivi)
    },
    areAllSwitchDateLogRetroattiviSelected() {
      const selectableRows = this.getLimitedSelectableSwitchDateLogRetroattivi()
      return selectableRows.length > 0 &&
        selectableRows.every(row => this.isSwitchDateLogRetroattivoSelected(row))
    },
    toggleAllSwitchDateLogRetroattivi(checked) {
      this.selectedSwitchDateLogRetroattivi = checked
        ? this.getLimitedSelectableSwitchDateLogRetroattivi()
        : []
    },
    toggleSwitchDateLogRetroattivoSelection(row, checked) {
      if (!this.isSwitchDateLogRetroattivoSelectable(row)) return
      if (checked && this.isSwitchDateLogSelectionDisabled(row)) {
        this.toast.add({
          severity: 'warn',
          summary: 'Limite selezione',
          detail: `Puoi selezionare al massimo ${this.maxSelectedSwitchDateLogRetroattivi} righe alla volta.`,
          life: 4000,
        })
        return
      }

      const matriceId = String(row?.matrice_index_id || '')
      const selectedRows = this.selectedSwitchDateLogRetroattivi
        .filter(selected => String(selected?.matrice_index_id || '') !== matriceId)

      this.selectedSwitchDateLogRetroattivi = checked
        ? [...selectedRows, row]
        : selectedRows
    },
    getSwitchDateLogMonthValue() {
      if (!this.switchDateLogMonth) return null

      const date = this.switchDateLogMonth instanceof Date
        ? this.switchDateLogMonth
        : new Date(this.switchDateLogMonth)

      if (Number.isNaN(date.getTime())) return null

      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0')

      return `${year}-${month}`
    },
    async loadSwitchDateLogRetroattivi() {
      const month = this.getSwitchDateLogMonthValue()

      if (!month) {
        this.toast.add({
          severity: 'warn',
          summary: 'Mese mancante',
          detail: 'Seleziona un mese valido prima di cercare.',
          life: 4000,
        })
        return
      }

      this.switchDateLogRetroattiviLoaded = false
      this.loadingSwitchDateLogRetroattivi = true

      try {
        const res = await this.service.getSwitchDateLogRetroattiviByValidationMonth(month, this.switchDateLogWithoutLimit)
        this.switchDateLogRetroattivi = this.normalizeSwitchDateLogRetroattiviPayload(res)
        this.selectedSwitchDateLogRetroattivi = []
        this.switchDateLogLoadedMonth = month
        this.switchDateLogLoadedWithoutLimit = this.switchDateLogWithoutLimit
        this.switchDateLogRetroattiviLoaded = true
      } catch (err) {
        const responseData = err?.response?.data
        this.switchDateLogRetroattivi = {
          total: null,
          items: [],
          columns: [],
        }
        this.selectedSwitchDateLogRetroattivi = []
        this.switchDateLogLoadedMonth = month
        this.switchDateLogLoadedWithoutLimit = this.switchDateLogWithoutLimit
        this.switchDateLogRetroattiviLoaded = true
        this.toast.add({
          severity: 'warn',
          summary: 'Errore',
          detail: responseData?.message || 'Impossibile cercare i log data switch retroattivi.',
          life: 5000,
        })
      } finally {
        this.loadingSwitchDateLogRetroattivi = false
      }
    },
    getMatriciSenzaSwitchMonthValue() {
      if (!this.matriciSenzaSwitchMonth) return null

      const date = this.matriciSenzaSwitchMonth instanceof Date
        ? this.matriciSenzaSwitchMonth
        : new Date(this.matriciSenzaSwitchMonth)

      if (Number.isNaN(date.getTime())) return null

      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0')

      return `${year}-${month}`
    },
    normalizeMatriciSenzaSwitchPayload(payload) {
      const data = payload?.data && typeof payload.data === 'object'
        ? payload.data
        : payload
      const groupedItems = [
        ...(Array.isArray(data?.ee) ? data.ee.map(item => ({ ...item, tipo: item?.tipo || 'ee' })) : []),
        ...(Array.isArray(data?.gas) ? data.gas.map(item => ({ ...item, tipo: item?.tipo || 'gas' })) : []),
      ]
      const items = Array.isArray(data?.items)
        ? data.items
        : Array.isArray(payload?.items)
          ? payload.items
          : groupedItems.length > 0
            ? groupedItems
            : Array.isArray(data)
              ? data
              : []

      return {
        total: this.getFirstNumericPayloadValue(
          data?.total,
          payload?.total,
          data?.count,
          payload?.count,
          items.length
        ),
        items: items.map((item, index) => {
          const tipo = String(item?.tipo || item?.type || item?.commodity || '').trim().toLowerCase()

          return {
            ...item,
            tipo: tipo || '-',
            row_key: item?.row_key || `${tipo || 'row'}-${item?.id || index}`,
          }
        }),
        columns: Array.isArray(data?.columns)
          ? data.columns
          : Array.isArray(payload?.columns)
            ? payload.columns
            : [],
      }
    },
    async loadMatriciSenzaSwitch() {
      const month = this.getMatriciSenzaSwitchMonthValue()

      if (!month) {
        this.toast.add({
          severity: 'warn',
          summary: 'Mese mancante',
          detail: 'Seleziona un mese valido prima di cercare.',
          life: 4000,
        })
        return
      }

      this.matriciSenzaSwitchLoaded = false
      this.loadingMatriciSenzaSwitch = true

      try {
        const res = await this.service.getMatriciSenzaSwitchByMonth(month, this.matriciSenzaSwitchWithoutLimit)
        this.matriciSenzaSwitch = this.normalizeMatriciSenzaSwitchPayload(res)
        this.selectedMatriciSenzaSwitch = []
        this.matriciSenzaSwitchLoadedMonth = month
        this.matriciSenzaSwitchLoadedWithoutLimit = this.matriciSenzaSwitchWithoutLimit
        this.matriciSenzaSwitchLoaded = true
      } catch (err) {
        const responseData = err?.response?.data
        this.matriciSenzaSwitch = {
          total: null,
          items: [],
          columns: [],
        }
        this.selectedMatriciSenzaSwitch = []
        this.matriciSenzaSwitchLoadedMonth = month
        this.matriciSenzaSwitchLoadedWithoutLimit = this.matriciSenzaSwitchWithoutLimit
        this.matriciSenzaSwitchLoaded = true
        this.toast.add({
          severity: 'warn',
          summary: 'Errore',
          detail: responseData?.message || 'Impossibile cercare le righe matrice senza switch.',
          life: 5000,
        })
      } finally {
        this.loadingMatriciSenzaSwitch = false
      }
    },
    getMatriciSenzaSwitchRowKey(row) {
      return String(row?.row_key || `${String(row?.tipo || '').trim().toLowerCase()}-${row?.id || ''}`)
    },
    isMatriciSenzaSwitchSelectable(row) {
      return Number(row?.cod_state_switch) === 2 &&
        Boolean(this.normalizePayloadIdSuggestedNumber(row?.id_switch)) &&
        Boolean(row?.suggerimento_insert_switch) &&
        ['ee', 'gas'].includes(String(row?.tipo || '').trim().toLowerCase())
    },
    getSelectableMatriciSenzaSwitch() {
      return Array.isArray(this.matriciSenzaSwitch.items)
        ? this.matriciSenzaSwitch.items.filter(row => this.isMatriciSenzaSwitchSelectable(row))
        : []
    },
    isMatriciSenzaSwitchSelected(row) {
      const rowKey = this.getMatriciSenzaSwitchRowKey(row)
      return this.selectedMatriciSenzaSwitch
        .some(selected => this.getMatriciSenzaSwitchRowKey(selected) === rowKey)
    },
    areAllMatriciSenzaSwitchSelected() {
      const selectableRows = this.getSelectableMatriciSenzaSwitch()
      return selectableRows.length > 0 &&
        selectableRows.every(row => this.isMatriciSenzaSwitchSelected(row))
    },
    toggleAllMatriciSenzaSwitch(checked) {
      this.selectedMatriciSenzaSwitch = checked
        ? this.getSelectableMatriciSenzaSwitch()
        : []
    },
    toggleMatriciSenzaSwitchSelection(row, checked) {
      if (!this.isMatriciSenzaSwitchSelectable(row)) return

      const rowKey = this.getMatriciSenzaSwitchRowKey(row)
      const selectedRows = this.selectedMatriciSenzaSwitch
        .filter(selected => this.getMatriciSenzaSwitchRowKey(selected) !== rowKey)

      this.selectedMatriciSenzaSwitch = checked
        ? [...selectedRows, row]
        : selectedRows
    },
    getMatriciSwitchMancantiCreatePayload() {
      return this.selectedMatriciSenzaSwitchCodState2Items
        .map(row => ({
          tipo: String(row?.tipo || '').trim().toLowerCase(),
          id: this.normalizePayloadIdSuggestedNumber(row?.id),
          id_switch: this.normalizePayloadIdSuggestedNumber(row?.id_switch),
        }))
        .filter(row => ['ee', 'gas'].includes(row.tipo) && row.id && row.id_switch)
    },
    async createMatriciSwitchMancanti() {
      const items = this.getMatriciSwitchMancantiCreatePayload()

      if (items.length === 0) {
        this.toast.add({
          severity: 'warn',
          summary: 'Nessuna riga valida',
          detail: 'Non ci sono righe con cod_state_switch 2 e id_switch valorizzato.',
          life: 4000,
        })
        return
      }

      this.creatingMatriciSwitchMancanti = true

      try {
        const res = await this.service.createMatriciSwitchMancanti(items)
        const created = Number(res?.created || 0)
        const skipped = Number(res?.skipped || 0)
        const errors = Number(res?.errors_count || 0)
        const createdItems = Array.isArray(res?.items) ? res.items : []

        this.toast.add({
          severity: errors > 0 ? 'warn' : 'success',
          summary: errors > 0 ? 'Creazione parziale' : 'Switch creati',
          detail: `Creati: ${created}. Saltati: ${skipped}. Errori: ${errors}.`,
          life: 5000,
        })

        this.removeCreatedMatriciSwitchMancanti(createdItems)

        if (this.matriciSenzaSwitch.items.length === 0 && created > 0) {
          await this.loadMatriciSenzaSwitch()
        }
      } catch (err) {
        const responseData = err?.response?.data
        this.toast.add({
          severity: 'warn',
          summary: 'Errore',
          detail: responseData?.message || 'Impossibile creare gli switch mancanti.',
          life: 5000,
        })
      } finally {
        this.creatingMatriciSwitchMancanti = false
      }
    },
    removeCreatedMatriciSwitchMancanti(createdItems = []) {
      const createdKeys = Array.isArray(createdItems)
        ? createdItems
          .map(item => `${String(item?.type || item?.tipo || '').trim().toLowerCase()}-${String(item?.supply_id || item?.id || '').trim()}`)
          .filter(key => !key.endsWith('-'))
        : []

      if (createdKeys.length === 0) return

      const createdKeySet = new Set(createdKeys)
      const currentItems = Array.isArray(this.matriciSenzaSwitch.items)
        ? this.matriciSenzaSwitch.items
        : []
      const currentSelectedItems = Array.isArray(this.selectedMatriciSenzaSwitch)
        ? this.selectedMatriciSenzaSwitch
        : []

      this.matriciSenzaSwitch.items = currentItems
        .filter(item => !createdKeySet.has(`${String(item?.tipo || '').trim().toLowerCase()}-${String(item?.id || '').trim()}`))
      this.selectedMatriciSenzaSwitch = currentSelectedItems
        .filter(item => !createdKeySet.has(`${String(item?.tipo || '').trim().toLowerCase()}-${String(item?.id || '').trim()}`))
      const removedCount = currentItems.length - this.matriciSenzaSwitch.items.length
      if (this.matriciSenzaSwitch.total !== null) {
        this.matriciSenzaSwitch.total = Math.max(0, Number(this.matriciSenzaSwitch.total || 0) - removedCount)
      }
    },
    getSwitchDateLogRetroattiviCreatePayload() {
      return this.selectedSwitchDateLogRetroattivi
        .filter(row => this.isSwitchDateLogRetroattivoSelectable(row))
        .map(row => ({
          matrice_id: this.normalizePayloadIdSuggestedNumber(row.matrice_index_id),
          data_validazione: row.data_validazione,
        }))
        .filter(row => row.matrice_id && row.data_validazione)
    },
    async createSwitchDateLogRetroattivi() {
      const items = this.getSwitchDateLogRetroattiviCreatePayload()

      if (items.length === 0) {
        this.toast.add({
          severity: 'warn',
          summary: 'Nessuna riga valida',
          detail: 'Seleziona almeno una riga senza log switch gia presente.',
          life: 4000,
        })
        return
      }

      if (!this.switchDateLogLoadedWithoutLimit && items.length > this.maxSelectedSwitchDateLogRetroattivi) {
        this.toast.add({
          severity: 'warn',
          summary: 'Limite selezione',
          detail: `Puoi creare al massimo ${this.maxSelectedSwitchDateLogRetroattivi} log alla volta.`,
          life: 4000,
        })
        return
      }

      this.creatingSwitchDateLogRetroattivi = true

      try {
        const chunks = this.chunkItems(items, this.switchDateLogUpdateChunkSize)
        const responses = []

        for (const chunk of chunks) {
          responses.push(await this.service.createSwitchDateLogRetroattivi(chunk))
        }

        const created = responses.reduce((total, res) => total + Number(res?.created || 0), 0)
        const skipped = responses.reduce((total, res) => total + Number(res?.skipped || 0), 0)
        const errors = responses.reduce((total, res) => total + Number(res?.errors_count || 0), 0)
        const createdItems = responses.flatMap(res => Array.isArray(res?.items) ? res.items : [])

        this.toast.add({
          severity: errors > 0 ? 'warn' : 'success',
          summary: errors > 0 ? 'Creazione parziale' : 'Log creati',
          detail: `Creati: ${created}. Saltati: ${skipped}. Errori: ${errors}. Chunk: ${chunks.length}.`,
          life: 5000,
        })

        this.removeCreatedSwitchDateLogRetroattivi(createdItems)

        if (this.switchDateLogRetroattivi.items.length === 0 && created > 0) {
          await this.loadSwitchDateLogRetroattivi()
        }
      } catch (err) {
        const responseData = err?.response?.data
        this.toast.add({
          severity: 'warn',
          summary: 'Errore',
          detail: responseData?.message || 'Impossibile creare i log selezionati.',
          life: 5000,
        })
      } finally {
        this.creatingSwitchDateLogRetroattivi = false
      }
    },
    removeCreatedSwitchDateLogRetroattivi(createdItems = []) {
      const createdMatriceIds = Array.isArray(createdItems)
        ? createdItems
          .map(item => String(item?.matrice_id || '').trim())
          .filter(Boolean)
        : []

      if (createdMatriceIds.length === 0) return

      const createdMatriceIdSet = new Set(createdMatriceIds)
      const currentItems = Array.isArray(this.switchDateLogRetroattivi.items)
        ? this.switchDateLogRetroattivi.items
        : []

      this.switchDateLogRetroattivi.items = currentItems
        .filter(item => !createdMatriceIdSet.has(String(item?.matrice_index_id || '').trim()))
      const removedCount = currentItems.length - this.switchDateLogRetroattivi.items.length
      if (this.switchDateLogRetroattivi.total !== null) {
        this.switchDateLogRetroattivi.total = Math.max(0, Number(this.switchDateLogRetroattivi.total || 0) - removedCount)
      }
      this.selectedSwitchDateLogRetroattivi = this.selectedSwitchDateLogRetroattivi
        .filter(item => !createdMatriceIdSet.has(String(item?.matrice_index_id || '').trim()))
    },
    async loadFilePraticheDaRecuperare(force = false) {
      if (this.loadingFilePraticheDaRecuperare) return
      if (this.filePraticheDaRecuperareLoaded && !force) return

      const month = this.getFilePraticheMonthValue()

      if (!month) {
        this.toast.add({
          severity: 'warn',
          summary: 'Mese mancante',
          detail: 'Seleziona un mese valido prima di cercare.',
          life: 4000,
        })
        return
      }

      this.filePraticheDaRecuperareLoaded = false
      this.loadingFilePraticheDaRecuperare = true

      try {
        const res = await this.service.getFilePraticheDaRecuperare(month, this.filePraticheWithoutLimit)
        this.filePraticheDaRecuperare = this.normalizeFilePraticheDaRecuperarePayload(res)
        this.selectedFilePraticheDaRecuperare = []
        this.filePraticheLoadedMonth = month
        this.filePraticheLoadedWithoutLimit = this.filePraticheWithoutLimit
        this.filePraticheDaRecuperareLoaded = true
      } catch (err) {
        const responseData = err?.response?.data
        this.filePraticheDaRecuperare = {
          total: 0,
          items: [],
          columns: [],
        }
        this.selectedFilePraticheDaRecuperare = []
        this.filePraticheLoadedMonth = month
        this.filePraticheLoadedWithoutLimit = this.filePraticheWithoutLimit
        this.filePraticheDaRecuperareLoaded = true
        this.toast.add({
          severity: 'warn',
          summary: 'Errore',
          detail: responseData?.message || 'Impossibile caricare i file pratiche da recuperare.',
          life: 5000,
        })
      } finally {
        this.loadingFilePraticheDaRecuperare = false
      }
    },
    isNonEmptyValue(value) {
      return value !== null && value !== undefined && String(value).trim() !== ''
    },
    isFilePraticaDaRecuperareSelectable(row) {
      return this.isNonEmptyValue(row?.cod_servizio_suggerito) ||
        this.isNonEmptyValue(row?.response_filename_suggerito)
    },
    isFilePraticaDaRecuperareSelected(row) {
      return this.selectedFilePraticheDaRecuperare.some(selected => String(selected.filename) === String(row?.filename))
    },
    getSelectableFilePraticheDaRecuperare() {
      const items = Array.isArray(this.filePraticheDaRecuperare.items)
        ? this.filePraticheDaRecuperare.items
        : []

      return items.filter(row => this.isFilePraticaDaRecuperareSelectable(row))
    },
    areAllFilePraticheDaRecuperareSelected() {
      const selectableRows = this.getSelectableFilePraticheDaRecuperare()
      return selectableRows.length > 0 &&
        selectableRows.every(row => this.isFilePraticaDaRecuperareSelected(row))
    },
    toggleAllFilePraticheDaRecuperare(checked) {
      this.selectedFilePraticheDaRecuperare = checked
        ? this.getSelectableFilePraticheDaRecuperare()
        : []
    },
    toggleFilePraticaDaRecuperareSelection(row, checked) {
      if (!this.isFilePraticaDaRecuperareSelectable(row)) return

      const filename = String(row?.filename || '')
      const selectedRows = this.selectedFilePraticheDaRecuperare
        .filter(selected => String(selected.filename) !== filename)

      this.selectedFilePraticheDaRecuperare = checked
        ? [...selectedRows, row]
        : selectedRows
    },
    getFilePraticheDaRecuperareUpdatePayload() {
      return this.selectedFilePraticheDaRecuperare
        .filter(row => this.isFilePraticaDaRecuperareSelectable(row))
        .map(row => ({
          filename: row.filename,
          cod_servizio: row.cod_servizio_suggerito,
          response_filename: row.response_filename_suggerito,
        }))
        .filter(row => this.isNonEmptyValue(row.filename))
    },
    async updateFilePraticheDaRecuperare() {
      const items = this.getFilePraticheDaRecuperareUpdatePayload()

      if (items.length === 0) {
        this.toast.add({
          severity: 'warn',
          summary: 'Nessuna riga valida',
          detail: 'Seleziona almeno una riga con cod servizio o response filename suggeriti.',
          life: 4000,
        })
        return
      }

      this.updatingFilePraticheDaRecuperare = true

      try {
        const res = await this.service.updateFilePraticheDaRecuperare(items)
        const updated = Number(res?.updated || 0)
        const skipped = Number(res?.skipped || 0)
        const errors = Number(res?.errors_count || 0)

        this.toast.add({
          severity: errors > 0 ? 'warn' : 'success',
          summary: errors > 0 ? 'Aggiornamento parziale' : 'File pratiche aggiornati',
          detail: `Aggiornati: ${updated}. Saltati: ${skipped}. Errori: ${errors}.`,
          life: 5000,
        })

        this.removeUpdatedFilePraticheDaRecuperare(res?.items)

        if (this.filePraticheDaRecuperare.items.length === 0 && updated > 0) {
          await this.loadFilePraticheDaRecuperare(true)
        }
      } catch (err) {
        const responseData = err?.response?.data
        this.toast.add({
          severity: 'warn',
          summary: 'Errore',
          detail: responseData?.message || 'Impossibile aggiornare i file pratiche selezionati.',
          life: 5000,
        })
      } finally {
        this.updatingFilePraticheDaRecuperare = false
      }
    },
    removeUpdatedFilePraticheDaRecuperare(updatedItems = []) {
      const updatedFilenames = Array.isArray(updatedItems)
        ? updatedItems
          .map(item => String(item?.filename || '').trim())
          .filter(Boolean)
        : []

      if (updatedFilenames.length === 0) return

      const updatedFilenameSet = new Set(updatedFilenames)
      const currentItems = Array.isArray(this.filePraticheDaRecuperare.items)
        ? this.filePraticheDaRecuperare.items
        : []

      this.filePraticheDaRecuperare.items = currentItems
        .filter(item => !updatedFilenameSet.has(String(item?.filename || '').trim()))
      this.filePraticheDaRecuperare.total = Math.max(0, Number(this.filePraticheDaRecuperare.total || 0) - (currentItems.length - this.filePraticheDaRecuperare.items.length))
      this.selectedFilePraticheDaRecuperare = this.selectedFilePraticheDaRecuperare
        .filter(item => !updatedFilenameSet.has(String(item?.filename || '').trim()))
    },
    normalizeForzaScissionePkInput() {
      const ids = String(this.forzaScissionePkIds || '')
        .split(',')
        .map(id => id.trim())
        .filter(Boolean)

      const isValid = ids.length > 0 && ids.every(id => /^\d+$/.test(id) && Number(id) > 0)

      return {
        isValid,
        ids: [...new Set(ids.map(id => String(Number(id))))],
      }
    },
    buildForzaScissionePkFeedback(payload) {
      const items = Array.isArray(payload?.items) ? payload.items : []
      const errors = Array.isArray(payload?.errors) ? payload.errors : []
      const successCount = Number(payload?.success_count || items.filter(item => item.success === true).length || 0)
      const errorCount = Number(payload?.error_count || errors.length || items.filter(item => item.success !== true).length || 0)
      const total = Number(payload?.total || items.length || successCount + errorCount || 0)
      const details = items.map(item => `ID ${item.id}: ${item.errore || item.message || (item.success ? 'OK' : 'Errore')}`)

      errors.forEach(error => {
        details.push(`ID ${error.id || '-'}: ${error.errore || error.message || 'Errore'}`)
      })

      return {
        severity: errorCount > 0 ? 'warn' : 'success',
        title: errorCount > 0 ? 'Scissione completata con errori' : 'Scissione completata',
        message: `Totale: ${total}. OK: ${successCount}. KO: ${errorCount}.`,
        details,
      }
    },
    async forzaScissionePkMassiva() {
      const normalized = this.normalizeForzaScissionePkInput()

      if (!normalized.isValid) {
        this.forzaScissionePkFeedback = {
          severity: 'warn',
          title: 'Lista non valida',
          message: 'Inserisci uno o piu ID numerici maggiori di 0, separati da virgola.',
          details: [],
        }
        this.toast.add({
          severity: 'warn',
          summary: 'Lista non valida',
          detail: this.forzaScissionePkFeedback.message,
          life: 4000,
        })
        return
      }

      this.loadingForzaScissionePk = true
      this.forzaScissionePkFeedback = null

      try {
        const res = await this.service.forzaScissionePkMassiva(normalized.ids)
        this.forzaScissionePkFeedback = this.buildForzaScissionePkFeedback(res)
        if (this.forzaScissionePkFeedback.severity === 'success') {
          this.forzaScissionePkIds = ''
        }
        this.toast.add({
          severity: this.forzaScissionePkFeedback.severity,
          summary: this.forzaScissionePkFeedback.title,
          detail: this.forzaScissionePkFeedback.message,
          life: 5000,
        })
      } catch (err) {
        const responseData = err?.response?.data
        this.forzaScissionePkFeedback = {
          severity: 'error',
          title: 'Errore',
          message: responseData?.message || responseData?.errore || 'Impossibile forzare la scissione PK.',
          details: [],
        }
        this.toast.add({
          severity: 'warn',
          summary: this.forzaScissionePkFeedback.title,
          detail: this.forzaScissionePkFeedback.message,
          life: 5000,
        })
      } finally {
        this.loadingForzaScissionePk = false
      }
    },
    async cronForzaScissionePkMassiva() {
      this.loadingCronForzaScissionePk = true
      this.forzaScissionePkFeedback = null

      try {
        const res = await this.service.cronForzaScissionePkMassiva()
        this.forzaScissionePkFeedback = this.buildForzaScissionePkFeedback(res)
        this.toast.add({
          severity: this.forzaScissionePkFeedback.severity,
          summary: this.forzaScissionePkFeedback.title,
          detail: res?.message || this.forzaScissionePkFeedback.message,
          life: 5000,
        })
      } catch (err) {
        const responseData = err?.response?.data
        this.forzaScissionePkFeedback = {
          severity: 'error',
          title: 'Errore cron',
          message: responseData?.message || responseData?.errore || 'Impossibile avviare il cron di forza scissione PK.',
          details: [],
        }
        this.toast.add({
          severity: 'warn',
          summary: this.forzaScissionePkFeedback.title,
          detail: this.forzaScissionePkFeedback.message,
          life: 5000,
        })
      } finally {
        this.loadingCronForzaScissionePk = false
      }
    },
    getFatturaNonInviataAgentId(record) {
      return record?.agente_id ||
        record?.id_agente ||
        record?.agent_id ||
        record?.cod_agente ||
        record?.agente?.id ||
        record?.agent?.id ||
        null
    },
    getFatturaNonInviataAgentName(record) {
      const value = record?.agente ||
        record?.agente_nome ||
        record?.nome_agente ||
        record?.agent ||
        record?.agent_name ||
        record?.rappresentante ||
        record?.rappresentante_nome ||
        null

      if (value && typeof value === 'object') {
        return value.name ||
          value.nome ||
          value.label ||
          value.ragione_sociale ||
          value.denominazione ||
          ''
      }

      return value ? String(value) : ''
    },
    getFatturaNonInviataAgentLabel(record) {
      const agentId = this.getFatturaNonInviataAgentId(record)
      const agentName = this.getFatturaNonInviataAgentName(record)

      if (agentName && agentId && !agentName.includes(String(agentId))) {
        return `${agentName} (ID ${agentId})`
      }

      if (agentName) return agentName
      if (agentId) return `Agente ${agentId}`

      return 'Senza agente'
    },
    getFatturaNonInviataAgentKey(record, fallbackIndex = null) {
      const agentId = this.getFatturaNonInviataAgentId(record)
      if (agentId) return `agent-id-${agentId}`

      const agentName = this.getFatturaNonInviataAgentName(record)
      if (agentName) return `agent-name-${agentName.toLowerCase()}`

      return fallbackIndex === null ? 'senza-agente' : `senza-agente-${fallbackIndex}`
    },
    sortFattureNonInviateGroups(groups) {
      return [...groups].sort((first, second) => {
        const firstIsWithoutAgent = first.key === 'senza-agente' || first.label === 'Senza agente'
        const secondIsWithoutAgent = second.key === 'senza-agente' || second.label === 'Senza agente'

        if (firstIsWithoutAgent && !secondIsWithoutAgent) return 1
        if (!firstIsWithoutAgent && secondIsWithoutAgent) return -1

        return String(first.label || '').localeCompare(String(second.label || ''), 'it', {
          sensitivity: 'base',
          numeric: true,
        })
      })
    },
    humanizeColumnLabel(field) {
      return String(field || '')
        .replace(/_/g, ' ')
        .replace(/\b\w/g, char => char.toUpperCase())
    },
    formatFatturaNonInviataCell(value, field = null) {
      if (value === null || value === undefined || value === '') return '-'
      if (field === 'giorni_in_validazione') {
        const days = Number(value)
        if (Number.isNaN(days)) return value

        return days === 1 ? '1 giorno' : `${days} giorni`
      }
      if (Array.isArray(value)) return value.join(', ')
      if (typeof value === 'object') return JSON.stringify(value)
      return value
    },
    formatFilePraticaDaRecuperareCell(value, field = null) {
      if (value === null || value === undefined || value === '') return '-'
      if (field && String(field).startsWith('data_')) return this.formatDateTime(value)
      if (Array.isArray(value)) return value.join(', ')
      if (typeof value === 'object') return JSON.stringify(value)
      return value
    },
    getPayloadIdMatchLabel(matchType) {
      if (matchType === 'direct') return 'Diretto'
      if (matchType === 'gemello') return 'Gemello'
      if (matchType === 'name') return 'Nome esatto'
      if (matchType === 'fallback') return 'Fallback dati'
      return 'Non trovato'
    },
    getPayloadIdMatchSeverity(matchType) {
      if (matchType === 'direct' || matchType === 'name') return 'success'
      if (matchType === 'gemello' || matchType === 'fallback') return 'warning'
      return 'danger'
    },
    isPayloadIdSuggestedField(field) {
      return [
        'payload_id_suggerito',
        'origin_id_suggerito',
      ].includes(field)
    },
    formatPayloadIdCaricamentiCell(value, field = null) {
      if (value === null || value === undefined || value === '') return '-'
      if (field && String(field).includes('data')) return this.formatDateTime(value)
      if (Array.isArray(value)) return value.join(', ')
      if (typeof value === 'object') return JSON.stringify(value)
      return value
    },
    formatSwitchDateLogRetroattiviCell(value, field = null) {
      if (value === null || value === undefined || value === '') return '-'
      if (field && String(field).includes('data')) return this.formatDateTime(value)
      if (Array.isArray(value)) return value.join(', ')
      if (typeof value === 'object') return JSON.stringify(value)
      return value
    },
    formatMatriciSenzaSwitchCell(value, field = null) {
      if (value === null || value === undefined || value === '') return '-'
      if (field && String(field).includes('data')) return this.formatDateTime(value)
      if (Array.isArray(value)) return value.join(', ')
      if (typeof value === 'object') return JSON.stringify(value)
      return value
    },
    emptyLogErrorPreavvisiPage(perPage = 20) {
      return {
        items: [],
        total: 0,
        current_page: 1,
        last_page: 1,
        per_page: perPage,
      }
    },
    normalizeLogErrorPreavvisiPage(payload, fallbackPerPage = 20) {
      const items = Array.isArray(payload?.items) ? payload.items : []
      const perPage = Number(payload?.per_page || fallbackPerPage) || fallbackPerPage

      return {
        items,
        total: Number(payload?.total || 0),
        current_page: Number(payload?.current_page || 1) || 1,
        last_page: Number(payload?.last_page || 1) || 1,
        per_page: perPage,
      }
    },
    async testAskMailConnection() {
      if (this.loadingAskMailCheck) return

      this.loadingAskMailCheck = true
      this.askMailResult = null

      try {
        const data = await this.askMailService.checkConnection({
          tables: this.askMailIncludeTables,
          table: (this.askMailTableName || '').trim() || undefined,
        })
        this.askMailResult = data
        this.toast.add({
          severity: data?.success ? 'success' : 'warn',
          summary: data?.success ? 'Ask Mail OK' : 'Ask Mail KO',
          detail: data?.success
            ? `Database: ${data.database || '-'} | Host: ${data.host || '-'}`
            : (data?.message || 'Connessione fallita'),
          life: 5000,
        })
      } catch (err) {
        const message =
          err?.response?.data?.message ||
          err?.response?.data?.meta?.error ||
          err?.message ||
          'Impossibile testare la connessione Ask Mail.'
        this.askMailResult = {
          success: false,
          connection: 'ask_mail',
          host: err?.response?.data?.host,
          port: err?.response?.data?.port,
          message,
        }
        this.toast.add({
          severity: 'warn',
          summary: 'Ask Mail KO',
          detail: message,
          life: 6000,
        })
      } finally {
        this.loadingAskMailCheck = false
      }
    },
    formatAskMailResult(result) {
      try {
        return JSON.stringify(result, null, 2)
      } catch (e) {
        return String(result)
      }
    },
    formatLogErrorPreavvisiDate(value) {
      return this.formatDateTime(value) || '-'
    },
    async loadLogErroriInviiPreavvisi(force = false) {
      if (this.loadingLogErrorPreavvisi) return
      if (this.logErrorPreavvisiLoaded && !force) return

      this.loadingLogErrorPreavvisi = true

      try {
        await Promise.all([
          this.loadLogErroriInviiPreavvisiTipo('pec', this.logErrorPreavvisi.pec.current_page, this.logErrorPreavvisi.pec.per_page),
          this.loadLogErroriInviiPreavvisiTipo('email', this.logErrorPreavvisi.email.current_page, this.logErrorPreavvisi.email.per_page),
        ])
        this.logErrorPreavvisiLoaded = true
      } finally {
        this.loadingLogErrorPreavvisi = false
      }
    },
    async loadLogErroriInviiPreavvisiTipo(tipo, page = 1, perPage = 20) {
      if (!['pec', 'email'].includes(tipo)) return

      const loadingKey = tipo === 'pec' ? 'loadingLogErrorPreavvisiPec' : 'loadingLogErrorPreavvisiEmail'
      this[loadingKey] = true

      try {
        const data = await this.preavvisiService.getLogErroriInviiPreavvisi({
          tipo_invio: tipo,
          page,
          per_page: perPage,
        })

        this.logErrorPreavvisi[tipo] = this.normalizeLogErrorPreavvisiPage(data?.[tipo], perPage)
        this.logErrorPreavvisiLoaded = true
      } catch (err) {
        this.logErrorPreavvisi[tipo] = this.emptyLogErrorPreavvisiPage(perPage)
        this.toast.add({
          severity: 'warn',
          summary: 'Errore',
          detail: err?.response?.data?.meta?.error || `Impossibile caricare i log errori ${tipo.toUpperCase()}.`,
          life: 5000,
        })
      } finally {
        this[loadingKey] = false
      }
    },
    onLogErrorPreavvisiPage(tipo, event) {
      const page = Number(event?.page || 0) + 1
      const perPage = Number(event?.rows || 20)
      this.loadLogErroriInviiPreavvisiTipo(tipo, page, perPage)
    },
    formatPayloadIdTotal(value) {
      return value === null || value === undefined ? 'non disponibile' : value
    },
    formatMatriceIndexStoricoDuplicatoCell(value, field = null) {
      if (value === null || value === undefined || value === '') return '-'
      if (field && String(field).includes('data')) return this.formatDateTime(value)
      if (Array.isArray(value)) return value.join(', ')
      if (typeof value === 'object') return JSON.stringify(value)
      return value
    },
    normalizeExternalNewsRecord(row = {}) {
      return {
        id: Number(row.id || 0),
        title: String(row.title || ''),
        image: row.image ? String(row.image) : '',
        description: row.description ? String(row.description) : '',
        external_link: row.external_link ? String(row.external_link) : '',
        visible: Number(row.visible) === 1 ? 1 : 0,
      }
    },
    resetExternalNewsForm() {
      this.externalNewsEditingId = null
      this.externalNewsForm = {
        title: '',
        image: '',
        description: '',
        external_link: '',
        visible: true,
      }
    },
    async loadExternalNews(showToast = false) {
      this.loadingExternalNews = true
      try {
        const res = await this.service.getExternalNews()
        const rows = Array.isArray(res?.data)
          ? res.data
          : Array.isArray(res?.items)
            ? res.items
            : []
        this.externalNewsItems = rows.map(item => this.normalizeExternalNewsRecord(item))
        if (showToast) {
          this.toast.add({
            severity: 'success',
            summary: 'News aggiornate',
            detail: `Trovate ${this.externalNewsItems.length} news`,
            life: 3000,
          })
        }
      } catch (err) {
        this.toast.add({
          severity: 'error',
          summary: 'Errore caricamento news',
          detail: err?.response?.data?.message || 'Impossibile recuperare le news esterne',
          life: 5000,
        })
      } finally {
        this.loadingExternalNews = false
      }
    },
    editExternalNews(item) {
      this.externalNewsEditingId = Number(item.id)
      this.externalNewsForm = {
        title: item.title || '',
        image: item.image || '',
        description: item.description || '',
        external_link: item.external_link || '',
        visible: Number(item.visible) === 1,
      }
    },
    getExternalNewsPayload() {
      return {
        title: String(this.externalNewsForm.title || '').trim(),
        image: String(this.externalNewsForm.image || '').trim(),
        description: String(this.externalNewsForm.description || '').trim(),
        external_link: String(this.externalNewsForm.external_link || '').trim(),
        visible: this.externalNewsForm.visible ? 1 : 0,
      }
    },
    async saveExternalNews() {
      const payload = this.getExternalNewsPayload()
      if (!payload.title) {
        this.toast.add({
          severity: 'warn',
          summary: 'Titolo obbligatorio',
          detail: 'Inserisci il titolo della news.',
          life: 4000,
        })
        return
      }

      this.savingExternalNews = true
      try {
        if (this.externalNewsEditingId) {
          await this.service.updateExternalNews(this.externalNewsEditingId, payload)
          this.toast.add({
            severity: 'success',
            summary: 'News aggiornata',
            detail: 'Modifica salvata con successo',
            life: 3000,
          })
        } else {
          await this.service.createExternalNews(payload)
          this.toast.add({
            severity: 'success',
            summary: 'News creata',
            detail: 'Nuova news aggiunta',
            life: 3000,
          })
        }

        this.resetExternalNewsForm()
        await this.loadExternalNews()
      } catch (err) {
        this.toast.add({
          severity: 'error',
          summary: 'Operazione non riuscita',
          detail: err?.response?.data?.message || 'Salvataggio news non riuscito',
          life: 5000,
        })
      } finally {
        this.savingExternalNews = false
      }
    },
    isDeletingExternalNews(id) {
      return this.externalNewsDeletingIds[Number(id)] === true
    },
    isTogglingExternalNews(id) {
      return this.externalNewsTogglingIds[Number(id)] === true
    },
    async deleteExternalNews(item) {
      const id = Number(item.id)
      if (!id) return
      if (!window.confirm(`Confermi eliminazione della news "${item.title}"?`)) {
        return
      }

      this.externalNewsDeletingIds = {
        ...this.externalNewsDeletingIds,
        [id]: true,
      }
      try {
        await this.service.deleteExternalNews(id)
        this.toast.add({
          severity: 'success',
          summary: 'News eliminata',
          detail: 'La news è stata rimossa',
          life: 3000,
        })
        await this.loadExternalNews()
        if (this.externalNewsEditingId === id) {
          this.resetExternalNewsForm()
        }
      } catch (err) {
        this.toast.add({
          severity: 'error',
          summary: 'Eliminazione non riuscita',
          detail: err?.response?.data?.message || 'Impossibile eliminare la news',
          life: 5000,
        })
      } finally {
        const nextState = { ...this.externalNewsDeletingIds }
        delete nextState[id]
        this.externalNewsDeletingIds = nextState
      }
    },
    async toggleExternalNewsVisibility(item) {
      const id = Number(item.id)
      if (!id) return
      const nextVisible = Number(item.visible) === 1 ? 0 : 1

      this.externalNewsTogglingIds = {
        ...this.externalNewsTogglingIds,
        [id]: true,
      }

      try {
        await this.service.setExternalNewsVisibility(id, nextVisible)
        this.toast.add({
          severity: 'success',
          summary: 'Visibilità aggiornata',
          detail: nextVisible === 1 ? 'News resa visibile' : 'News nascosta',
          life: 3000,
        })
        await this.loadExternalNews()
      } catch (err) {
        this.toast.add({
          severity: 'error',
          summary: 'Aggiornamento non riuscito',
          detail: err?.response?.data?.message || 'Impossibile aggiornare la visibilità',
          life: 5000,
        })
      } finally {
        const nextState = { ...this.externalNewsTogglingIds }
        delete nextState[id]
        this.externalNewsTogglingIds = nextState
      }
    },
    formatBytes(bytes) {
      const value = Number(bytes || 0)
      if (value < 1024) return `${value} B`
      if (value < 1024 * 1024) return `${(value / 1024).toFixed(1)} KB`
      return `${(value / (1024 * 1024)).toFixed(1)} MB`
    },
    formatDateTime(value) {
      if (!value) return ''

      const date = new Date(value)
      if (Number.isNaN(date.getTime())) return value

      return date.toLocaleString('it-IT', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
      })
    }
  }
}
</script>



<style scoped>
.pannello-funzionalita-page {
  padding: 1rem;
}

.feature-box {
  margin-top: 1rem;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  overflow: hidden;
}

.feature-toggle-button {
  width: 100%;
  border: 0;
  background: #f9fafb;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.9rem 1rem;
  font-size: 1.2rem;
  font-weight: 600;
  color: #1f2937;
  cursor: pointer;
}

.feature-content {
  padding: 1rem;
}

.controls-row {
  display: flex;
  gap: 0.75rem;
  align-items: flex-end;
  flex-wrap: wrap;
}

.field-group {
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
  min-width: 260px;
}

.calendar-stepper {
  display: flex;
  align-items: center;
  gap: 0.25rem;
  width: 100%;
}

.calendar-stepper .p-calendar {
  flex: 1 1 auto;
  min-width: 0;
}

.calendar-stepper-button {
  flex: 0 0 2.25rem;
  width: 2.25rem;
  height: 2.25rem;
}

.response-box {
  margin-top: 1rem;
  border: 1px solid transparent;
  border-radius: 8px;
  padding: 0.85rem 1rem;
}

.response-box h4 {
  margin: 0;
  margin-bottom: 0.4rem;
}

.feedback-message {
  margin: 0;
}

.feedback-list {
  margin: 0.6rem 0 0;
  padding-left: 1rem;
}

.results-grid {
  margin-top: 1rem;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 0.8rem;
}

.confirm-btn {
  margin-top: 0.9rem;
}

.changed-inline {
  color: #065f46;
  font-size: 0.9rem;
}

.response-box--success {
  background: #ecfdf5;
  border-color: #a7f3d0;
}

.response-box--warn {
  background: #fffbeb;
  border-color: #fde68a;
}

.response-box--info {
  background: #eff6ff;
  border-color: #bfdbfe;
}

.payload-id-visible-count {
  color: #64748b;
  margin-left: 0.35rem;
}

.response-box--error {
  background: #fef2f2;
  border-color: #fecaca;
}

.processlist-table-wrap {
  margin-top: 1rem;
  overflow-x: auto;
  overflow-y: auto;
  max-height: 420px;
}

.processlist-table {
  width: 100%;
  border-collapse: collapse;
  border: 1px solid #e5e7eb;
}

.processlist-table th,
.processlist-table td {
  padding: 0.55rem 0.7rem;
  border-bottom: 1px solid #e5e7eb;
  text-align: left;
  vertical-align: top;
}

.category-ticket-section {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.category-ticket-form {
  align-items: flex-end;
  flex-wrap: wrap;
}

.category-ticket-checkbox {
  min-width: 180px;
  margin-top: 1rem;
}

.category-ticket-table {
  margin-top: 0.5rem;
}

.category-ticket-table :deep(.p-datatable-wrapper) {
  overflow-y: auto;
}

.logs-table {
  margin-top: 0.5rem;
}

.logs-global-search-toolbar {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 0.5rem;
  margin-top: 0.5rem;
}

.logs-global-search-input-wrap {
  flex: 1 1 18rem;
  max-width: 28rem;
  min-width: 14rem;
}

.logs-global-search-input {
  width: 100%;
}

.logs-global-search-button {
  flex: 0 0 auto;
}

.logs-global-search-clear {
  flex: 0 0 2rem;
  width: 2rem;
  height: 2rem;
}

.logs-global-search-status {
  color: #4b5563;
  font-size: 0.86rem;
  font-weight: 700;
}

.logs-global-search-results {
  margin-top: 0.5rem;
}

.logs-global-search-preview {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  max-width: 48rem;
}

.logs-global-search-preview-line {
  overflow: hidden;
  color: #374151;
  font-family: Consolas, Monaco, monospace;
  font-size: 0.82rem;
  line-height: 1.35;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.missing-client-accordion,
.missing-client-row-accordion {
  margin-top: 0.75rem;
}

.missing-client-row-meta {
  display: flex;
  gap: 1rem;
  flex-wrap: wrap;
  margin-bottom: 0.75rem;
}

.missing-client-table {
  font-size: 0.92rem;
}

.missing-client-table :deep(.missing-client-row-disabled) {
  opacity: 0.58;
}

.missing-client-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 0.75rem;
}

.missing-client-supplies {
  display: flex;
  flex-direction: column;
  gap: 0.45rem;
}

.missing-client-supply {
  display: flex;
  flex-direction: column;
  gap: 0.15rem;
  line-height: 1.25;
}

.missing-client-supply-action {
  align-self: flex-start;
  margin-top: 0.35rem;
}

.create-contracts-button {
  gap: 0.55rem;
}

.create-contracts-label {
  line-height: 1;
}

.create-contracts-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 3.2rem;
  height: 1.5rem;
  padding: 0 0.55rem;
  border-radius: 999px;
  background: #ffffff;
  color: #047857;
  font-size: 0.78rem;
  font-weight: 700;
  line-height: 1;
}

.log-content-wrap {
  position: relative;
}

.log-content {
  max-height: 70vh;
  margin: 0;
  padding: 1rem;
  overflow: auto;
  white-space: pre-wrap;
  word-break: break-word;
  background: #111827;
  color: #f9fafb;
  border-radius: 4px;
  font-size: 0.85rem;
  line-height: 1.45;
}

.log-content-line {
  min-height: 1.25em;
  padding: 0 0.25rem;
  border-radius: 2px;
  transition: background-color 0.2s ease, color 0.2s ease;
}

.log-content-line--unread {
  background: rgba(37, 99, 235, 0.18);
  color: #eff6ff;
}

.log-content-line--search-match {
  background: rgba(234, 179, 8, 0.08);
}

.log-content-line--active-search-match {
  outline: 1px solid rgba(251, 191, 36, 0.85);
  background: rgba(234, 179, 8, 0.16);
}

.log-search-match {
  padding: 0 0.08rem;
  border-radius: 2px;
  background: #fde047;
  color: #111827;
}

.log-search-match--active {
  background: #f97316;
  color: #111827;
  box-shadow: 0 0 0 1px rgba(255, 255, 255, 0.55);
}

.log-unread-marker {
  position: sticky;
  top: 0;
  z-index: 3;
  margin: 0.45rem 0;
  padding: 0.25rem 0.55rem;
  border-top: 1px solid #60a5fa;
  border-bottom: 1px solid #60a5fa;
  background: #1e3a8a;
  color: #dbeafe;
  font-size: 0.78rem;
  font-weight: 700;
  text-transform: uppercase;
}

.log-read-threshold {
  position: absolute;
  top: 35%;
  left: 0.75rem;
  right: 0.75rem;
  z-index: 4;
  height: 0;
  border-top: 1px dashed #93c5fd;
  pointer-events: none;
}

.log-read-threshold span {
  position: absolute;
  right: 0;
  top: -0.8rem;
  padding: 0.12rem 0.4rem;
  border-radius: 3px;
  background: #1d4ed8;
  color: #eff6ff;
  font-size: 0.7rem;
  font-weight: 700;
}

.log-tail-toolbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 0.75rem;
  margin-bottom: 0.75rem;
}

.log-tail-actions,
.log-search-toolbar {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  min-width: 0;
}

.log-tail-actions {
  flex: 1 1 auto;
  flex-wrap: wrap;
}

.log-search-toolbar {
  flex: 0 1 31rem;
  justify-content: flex-end;
}

.log-search-input-wrap {
  flex: 1 1 14rem;
  min-width: 12rem;
}

.log-search-input {
  width: 100%;
}

.log-search-count {
  flex: 0 0 auto;
  min-width: 3.5rem;
  color: #4b5563;
  font-size: 0.82rem;
  font-weight: 700;
  text-align: center;
}

.log-search-button {
  flex: 0 0 2rem;
  width: 2rem;
  height: 2rem;
}

.log-tail-status {
  display: inline-flex;
  align-items: center;
  min-height: 1.75rem;
  padding: 0.25rem 0.55rem;
  border-radius: 4px;
  background: #f3f4f6;
  color: #374151;
  font-size: 0.82rem;
  font-weight: 700;
}

.log-tail-status--active {
  background: #dcfce7;
  color: #166534;
}

.log-tail-new-lines {
  display: inline-flex;
  align-items: center;
  min-height: 1.75rem;
  padding: 0.25rem 0.55rem;
  border-radius: 4px;
  background: #dbeafe;
  color: #1d4ed8;
  font-size: 0.82rem;
  font-weight: 700;
}

@media (max-width: 640px) {
  :deep(.log-content-dialog) {
    width: 100vw !important;
    max-width: 100vw;
    height: 100dvh;
    max-height: 100dvh;
    margin: 0;
    border-radius: 0;
  }

  :deep(.log-content-dialog .p-dialog-header) {
    flex: 0 0 auto;
    padding: 0.75rem;
  }

  :deep(.log-content-dialog .p-dialog-content) {
    display: flex;
    flex: 1 1 auto;
    flex-direction: column;
    min-height: 0;
    padding: 0 0.75rem 0.75rem;
    overflow: hidden;
  }

  .log-tail-toolbar {
    flex: 0 0 auto;
    flex-wrap: wrap;
    justify-content: flex-start;
    gap: 0.5rem;
  }

  .log-tail-actions,
  .log-search-toolbar {
    flex: 1 1 100%;
    justify-content: flex-start;
  }

  .log-search-input-wrap {
    flex: 1 1 auto;
    min-width: 0;
  }

  .log-tail-status,
  .log-tail-new-lines {
    max-width: 100%;
  }

  .log-content-wrap {
    display: flex;
    flex: 1 1 auto;
    min-height: 0;
  }

  .log-content {
    flex: 1 1 auto;
    max-height: none;
    min-height: 0;
    font-size: 0.78rem;
  }
}

.processlist-table th {
  background: #f8fafc;
  font-weight: 600;
  position: sticky;
  top: 0;
  z-index: 1;
}

.checkbox-col {
  width: 44px;
  text-align: center;
}

.processlist-kill-selected {
  margin-left: 0.6rem;
}

.processlist-guard-box {
  margin-top: 0;
}

.processlist-create-psw-btn {
  margin-top: 0.75rem;
}

.processlist-password-field {
  min-width: 100%;
}


.invoice-poste-controls-row {
  align-items: stretch;
}

.invoice-poste-input-field {
  flex: 1 1 auto;
  min-width: 0;
}

.invoice-poste-textarea {
  min-height: 7rem;
  resize: vertical;
}

.invoice-poste-validate-button {
  align-self: flex-end;
  flex: 0 0 auto;
  min-width: 8rem;
}

.force-scissione-pk-controls-row {
  align-items: stretch;
}

.force-scissione-pk-input-field {
  flex: 1 1 auto;
  min-width: 0;
}

.force-scissione-pk-textarea {
  min-height: 7rem;
  resize: vertical;
}

.force-scissione-pk-button {
  align-self: flex-end;
  flex: 0 0 auto;
}

.invoice-poste-table {
  margin-top: 1rem;
}

.invoice-poste-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 0.45rem;
}

.invoice-poste-status {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 1.5rem;
  padding: 0.15rem 0.45rem;
  border-radius: 4px;
  font-size: 0.78rem;
  font-weight: 700;
}

.invoice-poste-status--ok {
  background: #dcfce7;
  color: #166534;
}

.invoice-poste-status--ko {
  background: #fee2e2;
  color: #991b1b;
}

.invoice-poste-status--saved {
  margin-left: 0.35rem;
  background: #dbeafe;
  color: #1d4ed8;
}

.invoice-poste-table :deep(.invoice-poste-row-valid) {
  background: #f0fdf4;
}

.invoice-poste-table :deep(.invoice-poste-row-invalid) {
  background: #fff7ed;
}

.fatture-non-inviate-accordion {
  margin-top: 0.75rem;
}

.fatture-non-inviate-table {
  font-size: 0.92rem;
}

.log-error-preavvisi-toolbar {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  gap: 0.75rem 1.25rem;
}

.log-error-preavvisi-filter {
  margin: 0;
}

.log-error-preavvisi-accordion {
  margin-top: 0.75rem;
}

.log-error-preavvisi-table {
  font-size: 0.92rem;
}

.log-error-preavvisi-error {
  display: block;
  white-space: pre-wrap;
  word-break: break-word;
}

.ask-mail-toolbar {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  gap: 0.75rem 1.25rem;
}

.ask-mail-toolbar .field-group {
  margin: 0;
  min-width: 220px;
}

.check-exist-report-search {
  padding: 1rem;
  border: 1px solid #dee2e6;
  border-radius: 0.5rem;
}

.ask-mail-result {
  margin: 0;
  white-space: pre-wrap;
  word-break: break-word;
  font-size: 0.85rem;
  max-height: 420px;
  overflow: auto;
}

.external-news-form-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 0.75rem;
  margin-bottom: 0.75rem;
}

.external-news-description-field {
  grid-column: 1 / -1;
}

.external-news-visible-field {
  align-self: end;
}

.external-news-actions {
  display: flex;
  gap: 0.5rem;
  flex-wrap: wrap;
  margin-bottom: 0.75rem;
}

.external-news-row-actions {
  display: flex;
  gap: 0.45rem;
  flex-wrap: wrap;
}

.matrice-storico-duplicato-table :deep(.matrice-storico-duplicato-row-deletable) {
  background: #fff7ed;
}

.matrice-storico-duplicato-table :deep(.matrice-storico-duplicato-row-last-deletable) {
  background: #ffedd5;
}
@media (max-width: 900px) {
  .results-grid {
    grid-template-columns: 1fr;
  }

  .external-news-form-grid {
    grid-template-columns: 1fr;
  }
}
</style>
